{
  "common": {
    "add": "Agregar",
    "all": "Toda",
    "apply": "Aplicar",
    "back": "Atrás",
    "batchCreate": "Crear por lotes",
    "cancel": "Cancelar",
    "clear": "Clara",
    "clearAll": "Borrar todo",
    "close": "Cerca",
    "columnValues": {
      "basicInfo": "Información básica",
      "bindTime": "Fecha y hora de asignación",
      "createBy": "Creado por",
      "createTime": "Crear tiempo",
      "description": "Descripción",
      "id": "IDENTIFICACIÓN",
      "operation": "Operación",
      "remark": "Observación",
      "status": "Estado",
      "updateTime": "Hora de actualización"
    },
    "confirm": "Confirmar",
    "copy": "Copiar",
    "create": "Crear",
    "delete": "Borrar",
    "detail": "Detalle",
    "dialogTitles": {
      "addTitle": "Agregar",
      "confirmDelete": "Confirmar eliminación",
      "deleteTitle": "Eliminar confirmación",
      "editTitle": "Editar",
      "reminder": "Recordatorio"
    },
    "export": "Exportar",
    "exportSuccess": "Exportación exitosa",
    "hide": "Esconder",
    "http": {
      "getLocaleFailed": "No se pudo obtener la configuración regional usando el idioma predeterminado:",
      "insufficientPermission": "Permisos insuficientes, inicie sesión nuevamente",
      "loginExpired": "Vaya, su sesión se agotó, inicie sesión nuevamente",
      "requestFailed": "Solicitud fallida",
      "systemPrompt": "Sólo una nota"
    },
    "inputPlaceholder": "Por favor ingresa",
    "login": "Acceso",
    "loginOut": "Finalizar la sesión",
    "messages": {
      "addFailed": "No se pudo crear",
      "addSuccess": "¡Creada!",
      "deleteConfirm": "¿Estás segura de que quieres eliminar?",
      "deleteFailed": "No se pudo eliminar",
      "deleteSuccess": "¡Eliminada!",
      "editFailed": "No se pudo guardar",
      "editSuccess": "Cambios guardados",
      "formValidationFailed": "Error de validación del formulario",
      "imageUploadFailed": "Error al subir la imagen",
      "imageUploadSuccess": "Carga de imagen exitosa",
      "loginOutMessage": "¿Estás segura de que quieres cerrar sesión?",
      "operationFailed": "Operación fallida",
      "resetPasswordFailed": "Error al restablecer la contraseña",
      "resetPasswordSuccess": "Restablecimiento de contraseña exitosa",
      "saveFailed": "No se pudo guardar",
      "saveSuccess": "¡Salvado!",
      "submitFailed": "Envío fallido",
      "updateFailed": "No se pudo actualizar",
      "updateSuccess": "Actualizado !"
    },
    "no": "fallar",
    "none": "Ninguna",
    "ok": "DE ACUERDO",
    "openInNewWindow": "Abrir en una nueva pestaña",
    "placeholders": {
      "enter": "Por favor ingrese {field}",
      "search": "Buscar {field}....",
      "select": "Por favor seleccione {field}",
      "selectOrInput": "Por favor seleccione o ingrese {field}"
    },
    "register": "Inscribirse",
    "reset": "Reiniciar",
    "save": "Guardar",
    "search": "Buscar",
    "selectAll": "Seleccionar todo",
    "show": "Espectáculo",
    "statusValues": {
      "assignDevice": "Asignar dispositivo",
      "assignQR": "Asignar QR",
      "binded": "Asignado",
      "bound": "Asignado",
      "commandFailed": "Comando fallido",
      "commandProgress": "Progreso del comando",
      "commandSuc": "comando suc",
      "copyFailed": "Copia fallida",
      "copySuccess": "Copia exitosa",
      "disabled": "Desactivada",
      "enabled": "Activada",
      "error": "Error",
      "forbidden": "No activa",
      "no": "No",
      "noData": "Sin datos",
      "none": "Ninguna",
      "normal": "Activa",
      "notSet": "No establecido",
      "offline": "Desconectada",
      "online": "En línea",
      "processing": "Tratamiento",
      "shipped": "Enviada",
      "shippedFail": "Envío fallido",
      "unShipped": "Sin enviar",
      "unbind": "No asignado",
      "unbound": "No asignado",
      "unknown": "Desconocida",
      "yes": "Sí"
    },
    "update": "Editar",
    "timeZone": "Zona horaria",
    "validation": {
      "emailFormat": "Por favor, introduce una dirección de correo electrónico válida",
      "hyphenRequired": "{field} debe contener un guion (-)",
      "invalidLocale": "El formato de {field} no es válido. Introduzca un código regional válido",
      "imageSizeLimit": "El tamaño de la imagen debe ser inferior a 1 MB.",
      "lengthRange": "La longitud debe estar entre {min} y {max} caracteres",
      "maxLength": "La longitud no puede exceder {max} caracteres",
      "minLength": "La longitud debe ser de al menos {min} caracteres",
      "onlyImageFiles": "Sólo se permiten archivos de imagen",
      "passwordComplexity": "Incluya al menos dos tipos: letras, números y símbolos.",
      "passwordMismatch": "Las dos contraseñas no coinciden",
      "required": "Por favor ingrese {field}",
      "selectRequired": "Por favor seleccione {field}",
      "urlFormat": "Por favor introduce una dirección URL válida"
    },
    "version": "Versión",
    "view": "Vista",
    "viewDetail": "Ver detalle",
    "yes": "éxito"
  },
  "dashboardPage": {
    "annualSalesComparison": "Comparación de ventas anuales",
    "bottom5Performers": "Los 5 últimos máquinas",
    "bottom5WorstPerforming": "Los 5 últimos peores resultados",
    "cash": "Dinero",
    "cashVsCashless": "Ingresos en efectivo versus ingresos en pagos digitales",
    "cashless": "Pagos Digitales",
    "cityMachineLocations": "Mapa",
    "clusterOffline": "Sin conexión en esta ubicación",
    "clusterOnline": "En línea en esta ubicación",
    "day": "Día",
    "displayBy": "Mostrar por",
    "errorMachines": "Error",
    "errorMachinesShort": "Errar",
    "errorStatus": "Error",
    "hour": "Hora",
    "income": "Ingreso",
    "last12Months": "Últimos 12 meses",
    "last24H": "Últimas 24 horas",
    "last30Days": "Últimos 30 días",
    "last7Days": "Últimos 7 días",
    "last10Days": "Últimos 10 días",
    "last10Mins": "Últimos 10 minutos",
    "lastMonth": "Mes pasado",
    "lastPeriod": "Último período",
    "lastUpdated": "Última actualización",
    "lastWeek": "La semana pasada",
    "lastYear": "El año pasado",
    "loadMachineMapFailed": "No se pudieron cargar los datos del mapa de la máquina",
    "locationLabel": "Ubicación",
    "machine": "Máquina",
    "machineNoLabel": "Máquina No.",
    "machinePrefix": "Máquina #",
    "machines": "Galaxia",
    "mapInfoOffline": "Desconectada",
    "mapInfoOnline": "En línea",
    "mapRetryLoad": "Reintentar cargar mapa",
    "mapUnavailable": "Mapa no disponible",
    "month": "Mes",
    "month1": "Ene",
    "month10": "Oct",
    "month11": "Nov",
    "month12": "Dic",
    "month2": "Feb",
    "month3": "Mar",
    "month4": "Abr",
    "month5": "Puede",
    "month6": "Jun",
    "month7": "Jul",
    "month8": "Ago",
    "month9": "Sep",
    "noMachineData": "No hay datos de la máquina disponibles",
    "noPaymentData": "No hay datos de pago disponibles",
    "officeBuildingA": "Edificio de oficinas A",
    "offlineMachines": "Máquinas sin conexión",
    "onlineMachines": "Máquinas en línea",
    "onlineStatus": "En línea",
    "paymentMethod": "Método de pago",
    "paymentMethods": "Métodos de pago",
    "revenue": "Ganancia",
    "sales": "Ventas",
    "salesTrendAnalysis": "Análisis de tendencias de ventas",
    "saltLakeCityArea": "Área de Salt Lake City",
    "searchFilter": "Filtro de búsqueda",
    "searchMachines": "buscar galaxia...",
    "thisMonth": "Este mes",
    "thisWeek": "Esta semana",
    "thisYear": "Este año",
    "title": "Panel",
    "today": "Hoy",
    "todayRevenue": "Los ingresos de hoy",
    "todayVends": "Las ventas de hoy",
    "top5BestPerforming": "Top 5 con mejor desempeño",
    "top5Performers": "Los 5 mejores máquinas",
    "totalSalesToday": "Ventas totales hoy",
    "totalVendsToday": "Ventas totales hoy",
    "vends": "Ventas",
    "weekDay1": "Lun",
    "weekDay2": "Mar",
    "weekDay3": "Casarse",
    "weekDay4": "Jue",
    "weekDay5": "Vie",
    "weekDay6": "Se sentó",
    "weekDay7": "Sol",
    "weeklyComparison": "Comparación semanal",
    "year": "Año",
    "yesterday": "Ayer",
    "yesterdayRevenue": "Ingresos del último período",
    "yesterdayVends": "Ventas del último período"
  },
  "developmentCenter": {
    "addApiKey": "Agregar clave API",
    "addGatewayConfig": "Agregar configuración de puerta de enlace",
    "apiKeyCreatedSuccess": "¡Clave API creada exitosamente!\nContraseña: {password}",
    "apiKeyManagement": "Gestión de claves OpenAPI",
    "apiName": "Nombre de API",
    "apiNameLength": "La longitud del nombre de API debe tener entre 2 y 50 caracteres.",
    "confirmDeleteApiKey": "¿Estás segura de eliminar la clave de API {apiName}?",
    "confirmDeleteGatewayConfig": "¿Estás segura de eliminar la configuración de la puerta de enlace de org {orgName}?",
    "createSuccess": "Creado con éxito",
    "deleteApiKeyFailed": "No se pudo eliminar la clave API",
    "deleteGatewayConfigFailed": "No se pudo eliminar la configuración de la puerta de enlace",
    "description": "Configuración de OpenAPI Gateway y gestión de claves API",
    "editApiKey": "Editar clave API",
    "editGatewayConfig": "Editar configuración de puerta de enlace",
    "enterApiName": "Por favor ingrese el nombre de la API",
    "enterGatewayUrl": "Por favor ingrese la URL de la puerta de enlace",
    "enterSignKey": "Por favor ingrese la clave de firma",
    "gatewayConfig": "Configuración de puerta de enlace OpenAPI",
    "gatewayType": "Tipo de puerta de enlace",
    "gatewayUrl": "URL de puerta de enlace",
    "help": {
      "apiName": "El identificador de nombre de la clave API, utilizado para identificar y administrar la clave API en el sistema, de 2 a 50 caracteres de longitud.",
      "apiSignKey": "La clave de firma se utiliza para la verificación de la firma de la solicitud API para garantizar la seguridad e integridad de las solicitudes, con una longitud de 8 a 100 caracteres.",
      "cstatus": "Estado de la clave API, las claves API habilitadas se pueden usar normalmente, las claves API deshabilitadas no podrán realizar llamadas API",
      "gatewayOrgId": "Seleccione la organización propietaria de esta configuración de puerta de enlace. La organización utilizará esta configuración de puerta de enlace para llamadas API; no se puede modificar después de la creación.",
      "gatewayStatus": "Estado de configuración de la puerta de enlace, las configuraciones de puerta de enlace habilitadas se pueden usar normalmente, las configuraciones de puerta de enlace deshabilitadas no podrán realizar llamadas API",
      "gatewayType": "Tipo de puerta de enlace, seleccione el tipo de puerta de enlace API, actualmente admite el tipo de API operativa",
      "gatewayUrl": "La dirección URL de la puerta de enlace, utilizada para el enrutamiento y reenvío de solicitudes de API, debe tener un formato de URL válido",
      "orgId": "Seleccione la organización propietaria de esta clave API. La organización tendrá permisos de uso para esta clave API y no se puede modificar después de la creación."
    },
    "loadApiKeysFailed": "No se pudieron cargar las claves API",
    "loadGatewayConfigsFailed": "No se pudieron cargar las configuraciones de la puerta de enlace",
    "loadOrgTreeFailed": "No se pudo cargar el árbol de la organización",
    "operational": "API operativa",
    "operationalApi": "API operativa",
    "orgCode": "Código de organización",
    "orgType": "Tipo de organización",
    "organization": "Organización",
    "parentOrgNotFound": "ID de la organización principal: {sid} no encontrado, se trata la organización {label} como nodo raíz",
    "pleaseEnterApiName": "Por favor ingrese el nombre de la API",
    "pleaseEnterSignKey": "Por favor ingrese la clave de firma",
    "pleaseSelectOrg": "Por favor seleccione organización",
    "pleaseSelectStatus": "Por favor seleccione estado",
    "resetPassword": "Restablecer contraseña",
    "selectGatewayType": "Por favor seleccione el tipo de puerta de enlace",
    "selectOrganization": "Por favor seleccione organización",
    "selectStatus": "Por favor seleccione estado",
    "signKey": "Clave de firma",
    "signKeyLength": "La longitud de la clave de signo debe tener entre 8 y 100 caracteres.",
    "signKeyTip": "La clave de firma se utiliza para la verificación de firma de solicitud de API",
    "submitFailed": "Envío fallido",
    "title": "Centro de desarrollo",
    "updateSuccess": "Actualizado exitosamente"
  },
  "error": {
    "mobileLayoutWarning": "El modo móvil no admite cambios de diseño",
    "networkError": "Vaya, parece que tenemos un error.",
    "noPermission": "Oh oh, parece que no tienes suficientes permisos para esta página.",
    "pageError": "Ohh, eso es extraño, parece que la página que estás intentando abrir no existe.",
    "returnToHome": "volver a casa"
  },
  "fileUpload": {
    "delete": "Borrar",
    "downloadFailed": "Error en la descarga, inténtelo de nuevo",
    "downloadSuccess": "Descargar exitosa",
    "exampleDownload": "Descarga de ejemplo",
    "exampleDownloadBtnName": "Ejemplo de importación por lotes de dispositivos.csv",
    "exampleDownloadTip": "Descargue el archivo de ejemplo, complete la información del dispositivo de acuerdo con el formato y luego cárguelo",
    "fileSizeLimit": "¡El tamaño del archivo no puede exceder los 2 MB!",
    "fileTip": "Cargue archivos en formato Excel o CSV, con un tamaño de hasta 2 MB",
    "fileUpload": "Carga de archivos",
    "invalidFileFormat": "Formato de archivo no válido. Cargue archivos Excel o CSV.",
    "onlyExcelOrCsv": "¡Solo se permiten archivos Excel o CSV!",
    "selectFile": "Seleccionar archivo"
  },
  "listFilter": {
    "cancel": "Cancelar",
    "delete": "Borrar",
    "deletedColumns": "Columnas eliminadas",
    "exportFailed": "Error al exportar, inténtelo de nuevo",
    "noFilterItems": "Sin elementos de filtro",
    "reset": "Reiniciar",
    "save": "Guardar",
    "saveFailed": "Error al guardar, inténtelo de nuevo",
    "saveSuccess": "Guardar exitosa",
    "selectedColumns": "Columnas seleccionadas",
    "title": "Filtro de lista"
  },
  "lock": {
    "backToLogin": "Volver a iniciar sesión",
    "entrySystem": "Vuelve a iniciar sesión",
    "lockAction": "Cerrar",
    "lockPassword": "Contraseña de pantalla de bloqueo",
    "lockScreen": "Pantalla de bloqueo",
    "message": "Contraseña de pantalla de bloqueo incorrecta",
    "placeholder": "Por favor ingresa tu contraseña de pantalla de bloqueo",
    "unlock": "Haga clic para desbloquear"
  },
  "loginPage": {
    "checkPassword": "confirmar Contraseña",
    "code": "Código de verificación",
    "copyright": "© 2026 Trilad Technology US LLC. Todos los derechos reservados.",
    "continueWithApple": "Continuar con Apple",
    "continueWithGoogle": "Continuar con Google",
    "hasUser": "¿Ya tienes una cuenta? Acceso",
    "officialWebsite": "Sitio web oficial",
    "or": "o",
    "password": "Contraseña",
    "remember": "Acuérdate de mí",
    "subtitle": "controla el universo de tu máquina",
    "username": "Nombre de usuario"
  },
  "myAccount": {
    "accountInfo": "Información de la cuenta",
    "backupEmail": "Correo electrónico de respaldo",
    "basicInfo": "Información básica",
    "belongingOrg": "Organización asignada",
    "changePassword": "Cambiar la contraseña",
    "companyName": "nombre de empresa",
    "confirmPwd": "Confirmar nueva contraseña",
    "createBy": "Creado por",
    "createTime": "Crear tiempo",
    "currentTimeZone": "Zona horaria actual",
    "editPersonalProfile": "Edita tu perfil",
    "editProfile": "Editar perfil",
    "email": "Correo electrónico",
    "enterCorrectMobile": "Por favor introduce un número de móvil válido",
    "firstName": "Nombre de pila",
    "fullName": "Nombre completo",
    "lastName": "Apellido",
    "lastUpdate": "Última actualización",
    "loadUserInfoFailed": "No se pudo cargar la información del usuario",
    "loginAccount": "Nombre de usuario",
    "mobile": "Móvil",
    "myProfile": "Mi perfil",
    "newPwd": "Nueva contraseña",
    "notSet": "No establecido",
    "oldPwd": "Contraseña actual",
    "operatorName": "Nombre del operador",
    "passwordMismatch": "Las dos contraseñas ingresadas son diferentes",
    "personalInfo": "Información personal",
    "preferences": "Preferencias",
    "preferencesTabDescription": "Gestiona la configuración de tu zona horaria.",
    "profileTabDescription": "Gestiona la información básica de tu perfil.",
    "profileUpdateSuccess": "Información actualizada con éxito",
    "pwdChangeFailed": "No se pudo cambiar la contraseña",
    "pwdChanged": "Tu contraseña ha sido cambiada",
    "role": "Role",
    "security": "Seguridad",
    "securityTabDescription": "Actualiza tu contraseña de inicio de sesión.",
    "status": "Estado",
    "language": "Idioma",
    "timeZone": "Zona horaria",
    "title": "Mi cuenta",
    "titleLabel": "Título",
    "updateFailed": "La actualización falló, verifique los datos ingresados",
    "updateFailedMissingId": "Error en la actualización, falta el ID del operador"
  },
  "operationManagement": {
    "agencyManagement": {
      "addAgency": "Agregar entidad",
      "addSubAgency": "Agregar subentidad",
      "agencyCode": "ID de entidad:",
      "agencyTypes": {
        "branchAgent": "Distribuidora",
        "customer": "Operadora",
        "factory": "Fábrica",
        "factoryAgent": "Distribuidora de fabrica",
        "plat": "Plataforma"
      },
      "basicInfoDetails": {
        "address": "DIRECCIÓN",
        "agencyCode": "ID de entidad",
        "agencyLogo": "Logotipo de la entidad",
        "agencyName": "Nombre de la entidad",
        "agencyType": "Tipo de entidad",
        "contactEmail": "Correo electrónico de contacto",
        "contactPerson": "Persona de contacto",
        "contactPhone": "Teléfono de contacto",
        "country": "País",
        "culture": "Cultura",
        "displayName": "Nombre para mostrar",
        "email": "Correo electrónico",
        "hasContract": "¿Acuerdo firmado?",
        "hasKyc": "¿KYC aprobado?",
        "help": {
          "agencyLogo": "Cargar logo de entidad, admite archivos de imagen, tamaño recomendado 40x40px, máximo 1MB",
          "agencyName": "Nombre de la entidad utilizado para identificar la entidad, máximo 100 caracteres",
          "agencyType": "Seleccione el tipo de entidad, los diferentes tipos de entidad tienen diferentes reglas comerciales y permisos",
          "country": "Seleccione el país donde se encuentra la entidad, esto completará automáticamente la información de cultura, idioma y zona horaria.",
          "culture": "Configuración cultural, completada automáticamente según el país seleccionado, utilizada para formatos de número y moneda",
          "displayName": "Nombre para mostrar utilizado para mostrar el nombre de la entidad en la interfaz de usuario, máximo 100 caracteres",
          "email": "El correo electrónico de contacto de la entidad para recibir notificaciones del sistema debe tener un formato de correo electrónico válido",
          "hasContract": "Si se ha firmado un contrato, solo se requiere para entidades de tipo cliente",
          "hasKyc": "Si se ha completado la apertura de la cuenta KYC, solo se requiere para entidades de tipo cliente",
          "language": "Configuración de idioma, completada automáticamente según el país seleccionado, utilizada para la visualización de la interfaz del sistema",
          "parentAgency": "Seleccione la entidad matriz, determina automáticamente si es la sede según el tipo de entidad matriz",
          "status": "Seleccione el estado de la entidad, las entidades deshabilitadas no podrán funcionar normalmente",
          "taxRate": "Tasa de impuesto sobre el producto, rango 0-100, admite 2 decimales y se utiliza para calcular el impuesto sobre el producto",
          "timezone": "Configuración de zona horaria, completada automáticamente según el país seleccionado, utilizada para mostrar y calcular la hora"
        },
        "imageSizeLimit": "¡El tamaño de la imagen no puede exceder 1 MB!",
        "isHeadquarters": "es la sede",
        "isHeadquartersTip": "(Determinada automáticamente por tipo de entidad principal)",
        "language": "Idioma",
        "logoLoadFailed": "No se pudo cargar el logo, inténtalo de nuevo.",
        "logoTip": "Sólo archivos de imagen: PNG, JPEG/JPG; tamaño recomendado: 40x40px",
        "logoUploadFailed": "No se pudo subir",
        "logoUploadSuccess": "¡Logotipo subido!",
        "noLogo": "No hay logotipo aquí",
        "onlyImageFiles": "¡Solo se pueden cargar archivos de imágenes!",
        "parentAgency": "Entidad matriz",
        "taxRate": "Tasa impositiva",
        "taxRateTip": "(Unidad: %, Rango: 0-100)",
        "timezone": "Zona horaria"
      },
      "deleteAgency": "Eliminar entidad",
      "editAgency": "Editar entidad",
      "email": "Correo electrónico:",
      "getOrgChildrenFailed": "No se pudo cargar la lista de suborganizaciones",
      "getOrgDetailFailed": "No se pudieron cargar los detalles de la organización",
      "getOrgTreeListFailed": "No se pudo cargar la lista del árbol de organización",
      "messages": {
        "businessRules": {
          "addOperatorPasswordRequired": "Se requiere contraseña para el nuevo operador",
          "branchAgentOnlyCustomerOrAgent": "Solo se puede crear una entidad de cliente o agente de sucursal en agentes de sucursal",
          "customerOnlyCustomer": "Solo se pueden crear entidades de tipo cliente en clientes",
          "factoryAgentOnlyCustomerOrAgent": "Solo se puede crear una entidad de cliente o agente de fábrica bajo agentes de fábrica",
          "factoryOnlyFactory": "Solo se pueden crear entidades de tipo fábrica en fábricas",
          "loadRolesFailed": "No se pudo cargar la lista de roles",
          "platMustBeHeadquarters": "La entidad de plataforma debe ser la sede",
          "subAgencyCannotBeHeadquarters": "Las entidades bajo otras matrices no pueden establecerse como sede"
        },
        "cannotDeleteWithChildren": "Esta entidad tiene subentidades y no se puede eliminar. Primero elimine todas las subentidades.",
        "confirmDeleteNoChildren": "¿Está seguro de que desea eliminar la entidad \"{name}\"?",
        "confirmDeleteOperator": "¿Está seguro de que desea eliminar el usuario \"{name}\"?",
        "loadDataFailed": "No se pudieron cargar los datos",
        "loadingTree": "Cargando árbol de organización..."
      },
      "operators": "Usuarias",
      "operatorsDetails": {
        "addOperator": "Agregar usuario",
        "adminRole": "Administradora",
        "auditorRole": "Aprobadora",
        "backupEmail": "Correo electrónico de respaldo",
        "companyName": "Nombre de la entidad",
        "customerServiceRole": "Servicio al cliente",
        "editOperator": "Editar entidad",
        "emailLabel": "Correo electrónico",
        "financeRole": "Finanzas",
        "firstName": "Nombre de pila",
        "help": {
          "backupEmail": "Dirección de correo electrónico de respaldo del operador para contacto de emergencia; debe tener un formato de correo electrónico válido",
          "companyName": "Nombre de la empresa del operador, máximo 200 caracteres",
          "email": "La dirección de correo electrónico principal del operador para recibir notificaciones del sistema debe tener un formato de correo electrónico válido.",
          "firstName": "Nombre del operador, máximo 50 caracteres",
          "lastName": "Apellido del operador, máximo 50 caracteres",
          "loginAccount": "Nombre de inicio de sesión para iniciar sesión en el sistema, solo puede contener letras, números y guiones bajos, longitud de 3 a 100 caracteres",
          "mobile": "Número de móvil del operador, máximo 50 caracteres",
          "operatorName": "Nombre para mostrar del operador utilizado para identificar al operador en el sistema, máximo 100 caracteres",
          "password": "Contraseña de inicio de sesión, longitud de 6 a 255 caracteres, se recomienda utilizar una combinación de letras, números y caracteres especiales",
          "role": "Seleccione el rol de operador, diferentes roles tienen diferentes permisos del sistema",
          "status": "Seleccione el estado del operador, los operadores deshabilitados no podrán iniciar sesión en el sistema",
          "titleLabel": "Puesto o título del operador, máximo 50 caracteres"
        },
        "lastName": "Apellido",
        "loginAccount": "Nombre de usuario",
        "mobile": "Móvil",
        "operations": "Operaciones",
        "operatorName": "Nombre del operador",
        "operatorRole": "Operadora",
        "operatorsCreateTime": "Crear tiempo",
        "operatorsDelete": "Borrar",
        "operatorsEdit": "Editar",
        "password": "Contraseña",
        "passwordTip": "Longitud de la contraseña entre 6 y 255 caracteres; se recomienda utilizar una combinación de letras, números y caracteres especiales.",
        "resetPassword": "Restablecer contraseña",
        "role": "Role",
        "title": "Gestión de usuarios",
        "titleLabel": "Título",
        "userType": "Tipo de usuario"
      },
      "payChannels": {
        "addChannelConfig": "Agregar proveedor de pago",
        "addToAgency": "Agregar a la entidad",
        "apiKeySecurityWarning": "Está a punto de ver información confidencial de la clave API. Confirme que su entorno operativo sea seguro.",
        "availableChannels": "Canales de pago disponibles para agregar a la entidad",
        "channelConfig": "Configuración del proveedor de pagos",
        "channelName": "Nombre del proveedor",
        "channelProducts": "Proveedores de pago",
        "channelReferencedWarning": "Un paquete hace referencia a este proveedor. Sáquelo primero del paquete antes de eliminarlo.",
        "configInfo": "Información de configuración",
        "configItemsIncomplete": "Complete todos los campos del elemento de configuración",
        "configKeyDuplicate": "Las claves de los elementos de configuración no se pueden duplicar",
        "configKeyPlaceholder": "Clave de configuración",
        "configValuePlaceholder": "Valor de configuración",
        "configuredChannels": "Proveedores de pago configurados por la entidad",
        "currentConfiguredChannels": "Proveedores de pago configurados por la entidad actual",
        "deleteConfirmMessage": "¿Está seguro de que desea eliminar este proveedor de pagos? Esta acción no se puede deshacer.",
        "editChannelConfig": "Editar la configuración del proveedor de pagos",
        "formMode": "Modo formulario",
        "help": {
          "channelConfig": "Configure los parámetros del proveedor de pagos, admite tanto el modo formulario como el modo JSON, complete los parámetros requeridos de acuerdo con los requisitos del proveedor",
          "channelName": "Nombre del proveedor de pago, completado automáticamente por el sistema y no se puede modificar",
          "mdrVatRate": "Tasa de IVA MDR, rango 0-100, admite 2 decimales, utilizada para calcular el IVA MDR",
          "mdrVatRateFixed": "Tasa fija de MDR, admite 2 decimales, utilizada para calcular el MDR fijo",
          "status": "Seleccione el estado del proveedor, los proveedores discapacitados no estarán disponibles"
        },
        "jsonConfigPlaceholder": "Por favor ingrese la configuración JSON...",
        "jsonFormatIncorrect": "Formato JSON no válido",
        "jsonGenerateFailed": "No se pudo generar JSON:",
        "jsonMode": "Modo JSON",
        "jsonParseFailed": "No se pudo analizar JSON:",
        "loadOrgChannelsFailed": "No se pudieron cargar los canales de pago de la organización:",
        "loadSystemChannelsFailed": "No se pudieron cargar los canales del sistema:",
        "mdrVatRate": "Tasa de IVA MDR",
        "mdrVatRateFixed": "Tasa fija de MDR",
        "mdrVatRateTip": "(Unidad: %, Rango: 0-100)",
        "methodsCount": "canales",
        "noAvailableChannels": "No hay canales disponibles para agregar",
        "noConfig": "aquí está todo vacío...",
        "noConfigItems": "Aún no hay elementos de configuración, haga clic en Agregar arriba",
        "noConfiguredChannels": "Aún no hay proveedores de pago configurados; seleccione desde la izquierda para agregar",
        "noProducts": "No hay productos, ¿agregar algunos?",
        "parseChannelConfigFailed": "No se pudo analizar la configuración del canal:",
        "searchNoResults": "No se encontraron resultados, intente con otras palabras clave",
        "searchPlaceholder": "Buscar nombre o código del canal",
        "securityConfirm": "Confirmación de seguridad",
        "submitFormFailed": "No se pudo enviar el formulario:",
        "systemChannelPool": "Proveedores de pago del sistema",
        "toggleStatusConfirmMessage": "¿Está seguro de que desea {action} proveedor de pagos \"{name}\"?",
        "toggleStatusConfirmTitle": "Confirmar {action}",
        "toggleStatusSuccess": "{action} exitosa",
        "typeBoolean": "Booleano",
        "typeNumber": "Número",
        "typePlaceholder": "Tipo",
        "typeString": "Cadena",
        "configWarningMsg": "Se detectaron caracteres asterisco consecutivos en la configuraciÃ³n, puede que exista un error de configuraciÃ³n. ¿Desea continuar con el envÃ­o?",
        "configWarningTitle": "ConfiguraciÃ³n puede tener errores"
      },
      "payChannelsTab": "Proveedor de pagos",
      "payMethods": {
        "addFailed": "Error al agregar",
        "addToAgency": "Agregar a la entidad",
        "availableMethods": "Métodos de pago disponibles para agregar a la entidad",
        "configuredMethods": "Métodos de pago configurados por la entidad",
        "currentConfiguredMethods": "Métodos de pago habilitados para la entidad actual",
        "deleteConfirmMessage": "¿Está seguro de que desea eliminar esta configuración de método de pago? Esta acción no se puede deshacer.",
        "methodReferencedWarning": "Los siguientes paquetes hacen referencia a este método de pago y no se puede eliminar:",
        "noAvailableMethods": "No hay métodos de pago disponibles para agregar",
        "noConfiguredMethods": "Aún no hay métodos de pago configurados, seleccione desde la izquierda para agregar",
        "packageRefsCount": "referencias del paquete",
        "searchNoResults": "No hay resultados de búsqueda, pruebe con otras palabras clave",
        "searchPlaceholder": "Buscar nombre o código del método de pago",
        "systemPaymentMethods": "Métodos de pago del sistema",
        "toggleStatusConfirmMessage": "¿Estás seguro de que deseas {action} método de pago \"{name}\"?",
        "toggleStatusConfirmTitle": "Confirmar {action}",
        "toggleStatusSuccess": "{action} exitosa"
      },
      "payMethodsTab": "Configuración del método de pago",
      "payPackages": {
        "addChannel": "Agregar proporcionar",
        "addChannelSuccess": "Agregar canal exitosa",
        "addChannelToPackage": "Agregar canal al paquete",
        "addMethod": "Agregar método",
        "addMethodSuccess": "Añadir exitosa",
        "addPaymentMethod": "Agregar método de pago",
        "amount": "Cantidad",
        "calculateFee": "Calcular tarifa",
        "calculationResult": "Resultado del cálculo",
        "channelConfiguration": "Configuración del canal",
        "channelOperationFailed": "Error en la operación del canal",
        "channelPaymentMethodConfiguration": "Configuración preestablecida",
        "cloneFailed": "Copia fallida",
        "cloneSuccess": "Copia exitosa",
        "createPackage": "Crear preestablecido",
        "createPackageDialog": "Agregar nueva plantilla",
        "createSuccess": "Creado con éxito",
        "currency": "Divisa",
        "currencyLoadFailed": "No se pudieron cargar las monedas",
        "dataLoading": "Cargando datos, por favor espere...",
        "deleteChannelConfirm": "¿Estás seguro de que quieres eliminar este canal? También se eliminarán las configuraciones de métodos de pago relacionados.",
        "deleteChannelFailed": "No se pudo eliminar el canal",
        "deleteMethodConfirm": "¿Está seguro de que desea eliminar esta configuración de método de pago?",
        "deleteMethodFailed": "No se pudo eliminar el método de pago",
        "deletePackageConfirm": "¿Estás seguro de que deseas eliminar esta plantilla? Esta acción no se puede deshacer.",
        "device": "Dispositivo",
        "editChannel": "Editar proveedor",
        "editPackage": "Editar paquete",
        "editPaymentMethod": "Editar método de pago",
        "feePreview": "Vista previa de tarifas",
        "fixedFee": "Tarifa fija",
        "fixedFeeCannotBeNegative": "La tarifa fija no puede ser negativa",
        "fixedRate": "Tasa Fija",
        "handlingFee": "Comisión",
        "help": {
          "currency": "Seleccione la moneda admitida por la plantilla, que se aplicará a todos los canales y métodos de pago en la plantilla.",
          "fixedFee": "Tarifa fija, rango ≥0, comisión fija cobrada por transacción",
          "maxAmount": "Monto máximo de transacción permitido por este paquete; los precios de la máquina vinculados no pueden excederlo",
          "minAmount": "Monto mínimo de transacción permitido por este paquete; los precios de la máquina vinculados no pueden ser menores",
          "packageName": "Nombre de la plantilla utilizado para identificar la plantilla, máximo 100 caracteres",
          "packageType": "Seleccione el tipo de plantilla, el tipo de dispositivo para escenarios de pago de dispositivo, abra API para escenarios de llamada de interfaz API",
          "paymentMethod": "Seleccione método de pago, solo muestra los métodos de pago admitidos por el canal actual",
          "platProduct": "Seleccione el producto comercial de plataforma asociado, lo que limitará los canales a aquellos asociados con este producto, requerido para el tipo de dispositivo",
          "ratePercentage": "Tasa porcentual, rango 0-99,99, calcula la comisión como porcentaje del monto de la transacción",
          "selectChannel": "Seleccione canales de los canales de pago de la entidad configurados para agregarlos a la plantilla, se permite la selección múltiple",
          "status": "Seleccione el estado de la plantilla; las plantillas deshabilitadas no estarán disponibles"
        },
        "amountCannotBeNegative": "El monto no puede ser negativo",
        "maxAmount": "Monto máximo",
        "maxAmountCannotBeLessThanMin": "El monto máximo no puede ser menor que el monto mínimo",
        "minAmount": "Monto mínimo",
        "minAmountCannotExceedMax": "El monto mínimo no puede ser mayor que el monto máximo",
        "loadChannelMethodsFailed": "No se pudieron cargar los métodos de pago del canal",
        "loadChannelsFailed": "No se pudieron cargar los canales",
        "loadCurrenciesFailed": "No se pudieron cargar las monedas",
        "loadMethodsFailed": "No se pudieron cargar los métodos de pago",
        "loadPackageChannelsFailed": "No se pudieron cargar los canales de plantilla",
        "loadPackageMethodsFailed": "No se pudieron cargar los métodos de plantilla",
        "loadPackagesFailed": "No se pudieron cargar los paquetes",
        "methodFormRefNotFound": "Vaya, error del sistema {field}",
        "methodOperationFailed": "Error en la operación del método de pago",
        "noAvailableChannels": "No hay canales disponibles, configure primero los canales de pago de la entidad",
        "noChannelConfiguration": "Sin configuración de proveedor",
        "noChannelsInPackage": "No hay canales en esta plantilla, haga clic para agregar",
        "noMethodsInChannel": "No hay métodos de pago en este proveedor, haga clic para agregar",
        "noPackages": "No hay plantillas disponibles, haga clic para crear",
        "noPaymentMethodConfiguration": "Sin configuración de método de pago",
        "noPaymentMethodsInChannel": "No hay métodos de pago configurados en este canal.",
        "openApi": "API abierta",
        "packageChannelConfiguration": "Configuración de suministro preestablecida",
        "packageCode": "Código de plantilla",
        "packageName": "Nombre de la plantilla",
        "packagePreview": "Vista previa del paquete",
        "packageType": "Tipo de plantilla",
        "paymentConfigurationPackages": "Preajustes de pago",
        "paymentMethod": "Método de pago",
        "paymentMethodConfiguration": "Configuración del método de pago",
        "percentageRate": "Tasa Porcentual",
        "pleaseSelectChannel": "Por favor seleccione un Proporcionar",
        "pleaseSelectChannelFirst": "Por favor seleccione un canal primero",
        "pleaseSelectPackage": "Por favor seleccione una plantilla",
        "pleaseSelectPackageAndChannel": "Seleccione primero la plantilla y el canal.",
        "pleaseSelectPackageFirst": "Por favor seleccione una plantilla primero",
        "ratePercentage": "Tasa (%)",
        "rateRange": "La tarifa debe estar entre 0 y 99,99",
        "saveChannelFailed": "No se pudo guardar el canal",
        "saveFailed": "Error al guardar",
        "saveMethodFailed": "No se pudo guardar el método de pago",
        "savePackageFailed": "No se pudo guardar el paquete",
        "selectAtLeastOneChannel": "Por favor seleccione al menos un canal",
        "selectChannel": "Seleccionar canal",
        "selectPackageType": "Por favor seleccione el tipo de plantilla",
        "updateChannelSuccess": "Actualizar canal correctamente",
        "updateMethodSuccess": "Actualización exitosa",
        "updateSuccess": "Actualización exitosa",
        "yourReceive": "tu recibir"
      },
      "payPackagesTab": "Preajustes de pago",
      "resetPasswordDetails": {
        "confirmPassword": "confirmar Contraseña",
        "newPassword": "Nueva contraseña",
        "operator": "Usuaria",
        "resetPasswordOperator": "Usuaria",
        "title": "Restablecer contraseña"
      },
      "searchAgency": "Buscar organización...",
      "selectAgencyToView": "Seleccione una organización de la izquierda para ver los detalles",
      "title": "Gestión de jerarquía"
    },
    "machineTransferLog": {
      "endTime": "Hora de finalización",
      "enterOperator": "Introduzca operador",
      "enterSysMachineNo": "Ingrese el número de máquina del sistema",
      "loadDataFailed": "No se pudieron cargar los datos",
      "loadOrgTreeFailed": "No se pudo cargar el árbol de la organización",
      "machineInfo": "Información de la máquina",
      "machineName": "Nombre de la máquina",
      "machineType": "Tipo de máquina",
      "newOrg": "Nueva organización",
      "noErrorMessage": "Ningún mensaje de error",
      "oldOrg": "Antigua organización",
      "operateTime": "Tiempo de operación",
      "operator": "Operadora",
      "orgChange": "Cambio de organización",
      "orgMachineNoChange": "Cambio de número de máquina organizativa",
      "selectEndTime": "Seleccionar hora de finalización",
      "selectNewOrg": "Seleccionar nueva organización",
      "selectOldOrg": "Seleccionar organización antigua",
      "selectStartTime": "Seleccionar hora de inicio",
      "startTime": "Hora de inicio",
      "sysMachineNo": "Sistema Máquina No.",
      "title": "Registro de transferencia de máquina",
      "transferReason": "Motivo de la transferencia",
      "transferResult": "Resultado de la transferencia"
    },
    "operationMachineManagement": {
      "welcome": {
        "title": "Explora tu galaxia, gestiona tus máquinas",
        "selectOperator": "Selecciona un operador (galaxia) en el panel izquierdo para ver sus suboperadores y máquinas.",
        "selectMachine": "Haz clic en una máquina para ver los detalles y configurar los ajustes.",
        "alternative": "También puedes",
        "createMachine": "Crear una nueva máquina"
      },
      "accessLogTitle": "Registro de acceso",
      "accessStatus": "Estado de acceso",
      "accessStatusIdle": "Inactiva",
      "accessStatusPlaying": "Inhibir",
      "activeTime": "Tiempo activo (ms)",
      "addCurrencySymbol": "Símbolo de moneda",
      "addDeviceFailed": "No se pudo agregar el dispositivo",
      "addFavoriteFailed": "No se pudo agregar a favoritos",
      "addFavoriteSuccess": "Agregado a favoritos exitosamente",
      "addMachine": "Agregar máquina",
      "addMachineFailed": "No se pudo agregar la máquina",
      "addMachineFavoriteFailed": "No se pudo agregar el favorito de la máquina",
      "addMachineFavoriteSuccess": "El favorito de la máquina se agregó correctamente",
      "addMachineProtocolConfigFailed": "No se pudo agregar la configuración del protocolo de la máquina",
      "addMachineProtocolConfigSuccess": "Configuración del protocolo de la máquina agregada exitosamente",
      "addMachineSuccess": "Máquina agregada exitosamente",
      "addMachineTransferLogFailed": "No se pudo agregar el registro de transferencia de la máquina",
      "addMachineTransferLogSuccess": "Registro de transferencia de máquina agregado exitosamente",
      "addPrice": "Añadir precio",
      "addPriceDisabledTip": "Por favor complete el Precio 1 primero",
      "addProtocol": "Agregar protocolo",
      "addProtocolConfig": "Agregar configuración de protocolo",
      "addTransfer": "Máquina de transferencia",
      "animationDuration": "Duración de la animación",
      "animationPreview": "Vista previa de animación",
      "averageUnitPrice": "Precio unitario promedio",
      "basicConfig": "Configuración básica",
      "basicTextSettings": "Configuración de texto básica",
      "belongingOrg": "Organización matriz",
      "bindDevice": "Asignar dispositivo",
      "bindFailed": "Error en la asignación",
      "bindQr": "Asignar QR",
      "bindSuccess": "Asignación realizada correctamente",
      "bonusGames": "Juegos de bonificación",
      "bonusText": "Texto extra",
      "bound": "Asignado",
      "boundDevice": "Dispositivo asignado",
      "viewDevice": "Ver dispositivo",
      "boundQrCode": "Código QR asignado",
      "cancelFavoriteFailed": "No se pudo cancelar la favorita",
      "cancelFavoriteSuccess": "Cancelar favorita con éxito",
      "cannotFindFavoriteRecord": "No puedo encontrar el registro favorito",
      "cannotGetDeviceId": "No se puede obtener la ID del dispositivo",
      "cannotGetDeviceInfo": "No se puede obtener información del dispositivo",
      "cannotGetMachineId": "No se puede obtener la identificación de la máquina",
      "cannotGetMachineNo": "No se puede obtener el número de máquina",
      "cashAmount": "Monto en efectivo",
      "cashClearLog": "Registro de liquidación de efectivo",
      "cashHandling": "Configuración de efectivo",
      "cashLog": "Registro",
      "cci": "CCI",
      "cciProtocol": "Protocolo CCI",
      "checkDeviceStatusFailed": "No se pudo verificar el estado del dispositivo. Vuelve a intentarlo más tarde.",
      "china": "Porcelana",
      "choosePaymethodTitle": "Elija el texto del método de pago",
      "choosePlanText": "Elija el texto del plano",
      "providerName": "Proveedor de pago",
      "selectProviderName": "Seleccionar proveedor de pago",
      "chooseProgram": "Elegir programa",
      "chooseProgramTitle": "Elija el título del programa",
      "city": "Ciudad",
      "clearAmount": "Borrar cantidad",
      "clearCash": "Clara",
      "clearCashFailed": "No se pudo liquidar el efectivo",
      "clearCashSuccess": "Efectivo liquidado exitosamente",
      "clearTime": "Borrar tiempo",
      "cashProduct": "Producto",
      "cashProductHint": "Nombre para mostrar en reportes de transacciones en efectivo",
      "coinCount": "Recuento de monedas (Unidades)",
      "coinValue": "Valor de la moneda",
      "completed": "Terminada",
      "configSummary": "Resumen de configuración",
      "confirmCancelFavorite": "Confirmar Cancelar favorita",
      "confirmCancelFavoritePrompt": "¿Está seguro de que desea cancelar el favorito de la máquina {name}?",
      "confirmClearCash": "Confirmar Borrar",
      "confirmClearCashMessage": "¿Está seguro de que desea borrar el monto en efectivo {amount}? Esta acción no se puede deshacer.",
      "confirmDelete": "Confirmar eliminación",
      "confirmDeleteTransferPrompt": "¿Está seguro de que desea eliminar este registro de transferencia?",
      "confirmRemoveFavorite": "Confirmar Eliminar favorito",
      "confirmRemoveFavoriteMessage": "¿Estás segura de que quieres eliminar la máquina \"{machineName}\" de las favoritas?",
      "confirmUnbindDevice": "Confirmar desasignación del dispositivo",
      "confirmUnbindDeviceMessage": "Confirme que desea desasignar el dispositivo \"{deviceSN}\" de la máquina \"{machineName}{machineNumber}\".",
      "copy": "Copiar",
      "copyFailed": "Copia fallida",
      "copySuccess": "Copia exitosa",
      "country": "País",
      "createBy": "Creado por",
      "currentFrame": "Fotograma actual",
      "deleteFailed": "Error al eliminar",
      "deleteMachineFailed": "No se pudo eliminar la máquina",
      "deleteMachineFavoriteFailed": "No se pudo eliminar el favorito de la máquina",
      "deleteMachineFavoriteSuccess": "El favorito de la máquina se eliminó correctamente",
      "deleteMachineProtocolConfigFailed": "No se pudo eliminar la configuración del protocolo de la máquina",
      "deleteMachineProtocolConfigSuccess": "La configuración del protocolo de la máquina se eliminó correctamente",
      "deleteMachineSuccess": "Máquina eliminada exitosamente",
      "deleteMachineTransferLogFailed": "No se pudo eliminar el registro de transferencia de la máquina",
      "deleteMachineTransferLogSuccess": "El registro de transferencia de la máquina se eliminó correctamente",
      "deleteProtocol": "Eliminar protocolo",
      "deleteProtocolConfirm": "¿Está seguro de que desea eliminar el protocolo \"{name}\"?",
      "deleteSuccess": "Eliminado exitosamente",
      "paymentSimulationMode": "Modo de simulación de pago",
      "paymentSimulationModeDesc": "Elija cómo se simularán los pagos para esta máquina en modo Demo.",
      "paymentSimulationModeManualTitle": "Simulación de escaneo y pago manual",
      "paymentSimulationModeManualDesc": "Los usuarios obtendrán un código QR dinámico en el terminal, lo escanearán con su teléfono para abrir la página de pago de Trilad y presionarán Pagar para aprobar el pago en el teléfono.",
      "paymentSimulationModeAutoTitle": "Simulación de autopago",
      "paymentSimulationModeAutoDesc": "Simula automáticamente un pago exitoso después de una cuenta regresiva. No se requiere interacción con el teléfono.",
      "detailedLocation": "Ubicación detallada",
      "detectionMethod": "Método de detección",
      "detectionNone": "Ninguna",
      "detectionPulse": "Pulso",
      "deviceCount": "Recuento de dispositivos",
      "deviceCreateSuccess": "Máquina creada con éxito",
      "deviceName": "Nombre del dispositivo",
      "deviceNotBound": "El dispositivo no está asignado, no puede realizar la operación de venta gratuita",
      "deviceOffline": "El dispositivo está fuera de línea, no puede realizar la operación de salida",
      "deviceProtocolConfig": "Configuración de la máquina",
      "deviceSn": "Número de dispositivo",
      "deviceStatusForbidden": "El estado de la máquina se ha configurado como no activo, esta máquina no podrá realizar pagos",
      "deviceStatusNormal": "El estado del dispositivo se ha restablecido a la normalidad.",
      "deviceType": "Tipo de dispositivo",
      "deviceUpdateSuccess": "Máquina actualizada exitosamente",
      "dictItemNotFound": "Elemento del diccionario no encontrado",
      "discountAmount": "Cantidad de descuento",
      "discountRate": "Tasa de descuento (%)",
      "displayBasePrice": "Mostrar precio base",
      "displaySavedPercent": "Mostrar % guardado",
      "editMachine": "Editar máquina",
      "editMachineFavoriteFailed": "No se pudo editar el favorito de la máquina",
      "editMachineFavoriteSuccess": "El favorito de la máquina se actualizó correctamente",
      "editMachineProtocolConfigFailed": "No se pudo actualizar la configuración del protocolo de la máquina",
      "editMachineProtocolConfigSuccess": "Configuración del protocolo de la máquina actualizada correctamente",
      "editMachineTransferLogFailed": "No se pudo actualizar el registro de transferencia de la máquina",
      "editMachineTransferLogSuccess": "Registro de transferencia de máquina actualizado exitosamente",
      "editProtocolConfig": "Configuración de la máquina",
      "email": "Correo electrónico",
      "enableTimeout": "Habilitar configuración de tiempo de espera",
      "enterChoosePaymethodTitle": "Por favor ingrese el texto del método de pago",
      "enterChoosePlanText": "Por favor ingrese elija el texto del plan",
      "enterChooseProgramTitle": "Por favor ingrese elija el título del programa",
      "enterDeviceSn": "Por favor ingrese el SN del dispositivo",
      "enterDeviceSnOrQrCode": "Por favor ingrese el SN del dispositivo o el código QR",
      "enterOrgNo": "Por favor ingrese el número de organización",
      "enterQrCodeNo": "Por favor ingrese el código QR",
      "enterResultDescription": "Por favor ingrese la descripción de la página de resultados",
      "enterResultTitle": "Por favor ingrese el título de la página de resultados",
      "enterSinglePriceGoodsNameText": "Por favor ingrese el texto \"Total\" del precio único",
      "enterSinglePriceGoodsUnitText": "Por favor ingrese texto adicional de Precio Único",
      "enterTransferRemark": "Introduzca el comentario de transferencia",
      "errorMessage": "Mensaje de error",
      "favoriteFailed": "Falló a la favorita",
      "favoriteMachines": "Máquinas favoritas",
      "favoriteRecordNotFound": "Registro favorito no encontrado",
      "favoriteSuccess": "Favorito con éxito",
      "fixedAmount": "Monto Fijo",
      "fixedRateNotNegative": "El tipo fijo no puede ser negativo",
      "freeVend": "Venta remota",
      "freeVendTooltip": "Dispensar un artículo de forma remota sin cobrar al usuario",
      "fromOrg": "De la organización",
      "generateQrCodeImageFailed": "No se pudo generar la imagen del código QR",
      "generateQrCodeLinkFailed": "No se pudo generar el enlace del código QR",
      "gift": "Regalo",
      "goLive": "Ir en vivo",
      "goodsImage": "Imagen del producto",
      "help": {
        "addCurrencySymbol": "Si se debe agregar el símbolo de moneda en la visualización del precio",
        "animationDuration": "Duración de la animación, rango de 1 a 10 segundos, controla la duración de la reproducción de la animación",
        "belongingOrg": "Seleccione la organización a la que pertenece la máquina, no se puede modificar después de la creación",
        "choosePaymethodTitle": "Elija el título del método de pago, el texto se muestra como título en el área de selección del método de pago",
        "choosePlanText": "Elija el texto del plan, utilizado para mostrar en dispositivos terminales",
        "providerName": "Proveedor de pago de terminal (BrePay / MercadoPago), insertado en la configuración base como proveedor.nombre",
        "chooseProgramTitle": "Elija el título del programa, el texto se muestra como título en el área de selección de precios",
        "city": "Ciudad donde está ubicada la máquina",
        "cashProduct": "Nombre del producto para pedidos en efectivo. Solo se guarda en la configuración del protocolo de la máquina y no se envía al dispositivo",
        "coinCount": "Agregación de pulsos, rango 1-999, cuántos pulsos se consideran 1 reproducción/1 transacción (por ejemplo, si 1 reproducción son 6 pulsos x 0,25 $, entonces la configuración debe ser 6 y 0,25 en el parámetro de valor de moneda).",
        "coinValue": "Equivale a la moneda/billete más pequeño, por ejemplo 0,25$ en su propia moneda",
        "country": "País donde está ubicada la máquina",
        "detailedLocation": "Información detallada de la dirección de la máquina.",
        "detectionMethod": "Método de detección, ninguno significa no detección, pulso significa detección a través de señal de pulso",
        "deviceSn": "Número de serie del dispositivo, utilizado para identificar y asignar dispositivos físicos",
        "enableTimeout": "Ya sea para habilitar la configuración de tiempo de espera, cuando está habilitada puede configurar la duración del tiempo de espera y el método de detección",
        "gift": "La cantidad de obsequios, rango de 0 a 999, representa la cantidad de obsequios proporcionados a este precio.",
        "indexGoodsImg": "Imagen de productos indexados, que se muestra como imagen en el área de productos indexados",
        "locationInfo": "Información de ubicación de la máquina, incluido el país, la ciudad y la dirección detallada",
        "machineImage": "Cargue la imagen principal de la máquina, admite formato jpg/png, tamaño no superior a 1 MB",
        "machineName": "Nombre para mostrar de la máquina, utilizado para identificar la máquina en el sistema, longitud de 2 a 50 caracteres",
        "machineNumber": "El número único de la máquina, utilizado para identificar la máquina, no se puede modificar después de la creación.",
        "machineTags": "Agregue etiquetas a la máquina para categorizar y filtrar, admite la creación de nuevas etiquetas",
        "machineType": "Seleccione el tipo de máquina, los diferentes tipos tienen diferentes reglas comerciales y funciones.",
        "orgNo": "Introduzca el número de organización de la organización de destino.",
        "orgPaymentPackage": "Seleccione el ajuste preestablecido de pago de la organización, que determina los canales y métodos de pago disponibles para la máquina",
        "preAnimationGifs": "GIF de preanimación, que se muestran como GIF de preanimación en la página de pago exitoso",
        "preAnimationStaticImg": "Imagen estática previa a la animación, que se muestra como imagen estática previa a la animación en la página de pago exitoso",
        "priceMode": "Modo de precio, descuento para el cálculo automático del descuento, obsequio para la entrada manual de la cantidad del obsequio",
        "priceText": "Texto de precio, texto personalizado que se muestra en el área de selección de precio",
        "priceYuan": "Precio, rango ≥0, admite dos decimales; si hay un paquete de pago vinculado, también debe cumplir los límites mínimo{min}/máximo{max} del paquete",
        "protocolCode": "Seleccione el tipo de protocolo, diferentes protocolos tienen diferentes opciones de configuración y funciones",
        "pulseActive": "Duración activa del pulso, en milisegundos, predeterminado 100 ms",
        "pulseActiveTime": "Tiempo activo de pulso, rango de 1 a 9999 milisegundos, controla la duración de la señal de pulso",
        "pulseCount": "El conteo de pulsos, rango 1-9999, debe ser un múltiplo del conteo de monedas",
        "pulseInactive": "Duración del pulso inactivo, en milisegundos, predeterminado 100 ms",
        "pulseInactiveTime": "Tiempo inactivo de pulso, rango de 1 a 9999 milisegundos, controla el intervalo entre señales de pulso",
        "pulseUnit": "Cuántos pulsos reportar a la vez, por defecto 1",
        "qrCodeNo": "Número QR, utilizado para asignar el código QR de pago a la máquina",
        "quantity": "Texto cuantitativo, rango 1-999, representa el texto antes de las jugadas, los juegos y los minutos; por ejemplo, 5 (jugadas), 2 (minutos).",
        "remark": "Comentarios para la máquina, utilizados para registrar notas o comentarios adicionales.",
        "resultAnimationGifs": "GIF de animación de resultados, que se muestran como GIF de animación de resultados en la página de pago exitoso",
        "resultAnimationStaticImg": "Imagen estática de animación de resultados, que se muestra como imagen estática de animación de resultados en la página de pago exitoso",
        "resultDescription": "Descripción del resultado, que se muestra como descripción en la página de pago exitoso",
        "resultTitle": "Título del resultado, que se muestra como título en la página de pago exitoso",
        "sceneType": "Seleccione el tipo de aplicación, diferentes escenas tienen diferentes opciones y funciones de visualización",
        "selectProduct": "Seleccione el producto para venta gratuita, elija entre los precios del protocolo de pulso configurado",
        "serviceFeeRate": "Tarifa de tarifa de conveniencia, rango de tipo de porcentaje 0-100, rango de tipo de cantidad fija ≥0",
        "serviceFeeType": "Seleccione el tipo de tarifa de conveniencia, el porcentaje se calcula como porcentaje del monto de la transacción, el monto fijo es una tarifa fija por transacción",
        "showInsertedCoin": "Ya sea para mostrar el recuento de monedas insertadas",
        "singlePriceGoodsNameText": "Anule el \"Total\" predeterminado con su propio texto",
        "singlePriceGoodsUnitText": "Agregue texto adicional debajo del monto del precio único.",
        "status": "Seleccione el estado de la máquina, las máquinas deshabilitadas no podrán realizar operaciones de pago",
        "supportOnlinePayment": "Después de habilitarla, la máquina admitirá la funcionalidad de pago en línea.",
        "taxRate": "Tasa impositiva, rango 0-100%, calculada como porcentaje",
        "theme": "Seleccione el estilo del tema del terminal utilizado para controlar la apariencia visual de la página de pago.",
        "timeoutDuration": "Duración del tiempo de espera, rango de 1 a 300 segundos; exceder esta duración activará el manejo del tiempo de espera",
        "timeoutNonCash": "Si se deben permitir transacciones que no sean en efectivo después del tiempo de espera de entrega",
        "toOrg": "Seleccione la organización de destino, la máquina se transferirá a esta organización",
        "transferMode": "Seleccione el método para transferir la máquina",
        "transferReason": "Motivo de la transferencia, explica el motivo de la transferencia de la máquina, máximo 200 caracteres"
      },
      "imageSizeLimit": "El tamaño de la imagen no puede exceder 1 MB",
      "imageUploadFailed": "No se pudo cargar la imagen",
      "imageUploadSuccess": "Imagen cargada exitosamente",
      "imageUploadTip": "Sólo se permiten archivos jpg/png, máximo 1 MB",
      "inactiveTime": "Tiempo inactivo (ms)",
      "indexGoodsImg": "Imagen de productos indexados",
      "indexGoodsImgSettings": "Configuración de imagen de productos de índice",
      "invalidProduct": "El producto seleccionado no es válido",
      "isBindDevice": "Dispositivo asignado",
      "isBindQr": "QR asignado",
      "isGoodsCollapsible": "Añadir más precios en modo oculto",
      "jvma": "JVMA",
      "jvmaProtocol": "Protocolo JVMA",
      "loadAccessLogFailed": "No se pudo cargar el registro de acceso",
      "loadCashLogFailed": "No se pudo cargar el registro de liquidación de efectivo",
      "loadDeviceTagsFailed": "No se pudieron cargar las etiquetas del dispositivo",
      "loadDeviceTypesFailed": "No se pudieron cargar los tipos de dispositivos",
      "loadFavoriteMachinesFailed": "No se pudieron cargar las máquinas favoritas",
      "loadingOrgDeviceTree": "Cargando árbol de galaxias y máquinas...",
      "machines": "Máquinas",
      "loadMachineDetailFailed": "No se pudo cargar el detalle de la máquina",
      "loadOrgPayPackageFailed": "No se pudo cargar el valor preestablecido de pago de la organización",
      "loadTransferFailed": "No se pudieron cargar los registros de transferencia",
      "loadTransferLogListFailed": "No se pudo cargar la lista de registros de transferencias",
      "location": "Ubicación",
      "locationInfo": "Información de ubicación",
      "longitudeLatitude": "Longitud y Latitud",
      "lottieAssetsUploadComplete": "Carga de recursos de animación de Lottie completa",
      "lottieAssetsUploadTip": "Recursos de imagen externos detectados en la animación de Lottie, cargue los archivos de imagen correspondientes en orden",
      "lottieHasExternalAssets": "Recursos de imágenes externos detectados en la animación de Lottie, se recomienda utilizar archivos de Lottie con imágenes en línea Base64",
      "machineBinding": "Asignación de máquina",
      "machineConfigExistsPrompt": "Ya existe una configuración de máquina (machine.cfg) para este dispositivo. ¿Actualizar la configuración existente?",
      "machineConfigUpdateSuccess": "Configuración de la máquina actualizada",
      "machineImage": "Imagen de la máquina (solo para uso interno)",
      "machineInfo": "Información de la máquina",
      "machineName": "Nombre de la máquina",
      "machineNumber": "Número de máquina",
      "machineTags": "Etiquetas de la máquina",
      "machineTransferLog": "Registro de transferencia de máquina",
      "machineType": "Tipo de máquina",
      "mapSelectorPending": "La función de selección de mapas está pendiente de implementación",
      "mdb": "MDB",
      "mdbProtocol": "Protocolo MDB",
      "missingQrCodeInfo": "Falta información del código QR",
      "modeLabel": "Modo:",
      "modeSwitchFailed": "Error en el cambio de modo",
      "newOrgMachineNo": "Nueva máquina de organización No.",
      "next": "Próxima",
      "noBindDevice": "Esta máquina no tiene ningún dispositivo asignado.",
      "noErrorMessage": "Ningún mensaje de error",
      "noFavorites": "Sin favoritos",
      "noImage": "Sin imagen",
      "noPermissionAddMachine": "Sin permiso para agregar máquina",
      "noPermissionAddMachineFavorite": "No hay permiso para agregar el favorito de la máquina",
      "noPermissionDeleteMachine": "Sin permiso para eliminar la máquina",
      "noPermissionEditMachineFavorite": "No hay permiso para editar el favorito de la máquina",
      "noPermissionQueryMachineDetail": "No hay permiso para consultar los detalles de la máquina",
      "noPermissionQueryMachineList": "No hay permiso para consultar la lista de máquinas",
      "noPermissionQueryOrgTree": "No hay permiso para consultar el árbol de la organización",
      "noPermissionUpdateMachine": "Sin permiso para actualizar la máquina",
      "noPreviewImage": "Sin imagen de vista previa",
      "noProtocolConfig": "No hay ningún protocolo configurado, haga clic en el botón Agregar protocolo arriba para iniciar la configuración",
      "noPulseProtocolConfig": "No se encontró la configuración del protocolo PULSE o la configuración del producto está vacía; configure el protocolo primero",
      "noQrCodeLink": "No hay enlace para copiar",
      "noTransferLog": "Sin registros de transferencia",
      "noTransferOrg": "No hay organizaciones disponibles. Por favor cree uno primero.",
      "notSet": "No establecido",
      "offline": "Desconectada",
      "oldOrgMachineNo": "Máquina de organización antigua No.",
      "online": "En línea",
      "onlineStatus": "Estado en línea",
      "onlyImageFiles": "Sólo se permiten archivos de imagen",
      "onlyImageOrJsonFiles": "Solo se permiten archivos de imagen o archivos JSON de animación Lottie",
      "operateTime": "Tiempo de operación",
      "operationFailed": "La operación falló, verifique los datos del formulario.",
      "operator": "Operadora",
      "orgChange": "Cambio de organización",
      "orgDeviceNumber": "ID de la máquina de la organización actual",
      "orgDeviceTree": "Árbol de máquinas del sistema",
      "orgMachineNoChange": "Cambio de número de máquina organizativa",
      "orgName": "Nombre de la organización",
      "orgNo": "Número de organización",
      "orgPaymentPackage": "Preestablecido de pago",
      "orgType": "Tipo de organización",
      "outputSignalSentSuccess": "Señal de salida enviada exitosamente",
      "pause": "Pausa",
      "paymentPreAnimation": "Pre-animación de pago",
      "paymentResultAnimation": "Animación del resultado del pago",
      "pending": "Pendiente",
      "percentage": "Porcentaje",
      "percentageRateRange": "El porcentaje debe estar entre 0 y 100.",
      "play": "Jugar",
      "pleaseConfigurePaymentPackage": "Primero configure el paquete de pago",
      "machinePriceConfigInvalid": "La configuración de montos de la máquina es incorrecta. Ajuste los precios del protocolo antes de vincular este paquete de pago",
      "priceOutOfPackageRange": "El precio está fuera del rango del paquete de pago (mín {min}, máx {max})",
      "pricePackageRangePlaceholder": "Rango del paquete: {min} ~ {max}",
      "pleaseSelectDevice": "Por favor seleccione una máquina primero",
      "pleaseSelectProduct": "Por favor seleccione un producto",
      "pleaseUploadAllAssets": "Cargue todos los recursos antes de confirmar",
      "preAnimationGifs": "GIF de preanimación",
      "preAnimationStaticImg": "Imagen estática previa a la animación",
      "preview": "Avance",
      "previewActiveTime": "Tiempo activo",
      "previewCashHandling": "Manejo de efectivo",
      "previewChoosePlanText": "Elija el texto del plano",
      "previewChooseProgramTitle": "Elija el título del programa",
      "previewCashProduct": "Producto",
      "previewCoinCount": "Conteo de monedas",
      "previewCoinValue": "Valor de la moneda",
      "previewCurrencySymbol": "Símbolo de moneda",
      "previewDetectionMethod": "Método de detección",
      "previewDiscount": "descuento",
      "previewDiscountAmount": "Cantidad de descuento",
      "previewEnableTimeout": "Habilitar tiempo de espera",
      "previewInactiveTime": "Tiempo inactivo",
      "previewNo": "No",
      "previewPriceItem": "Precio",
      "previewPriceMode": "Modo de precio",
      "previewPriceSettings": "Configuración de precios",
      "previewPulse": "Pulso",
      "previewTax": "Tasa impositiva",
      "previewTextSettings": "Configuración de texto",
      "previewTimeoutDuration": "Duración del tiempo de espera",
      "previewTimeoutNonCash": "Tiempo de espera en pagos digitales",
      "previewTitle": "Configuración del protocolo de pulso",
      "previewUnit": "piezas",
      "previewYes": "Sí",
      "previous": "Previa",
      "priceDiscount": "Descuento de precio",
      "priceMode": "Modo de precio",
      "priceModeDiscount": "Modo de descuento de precio",
      "priceModeGift": "Modo de juegos de bonificación",
      "priceNumber": "Precio",
      "priceSettings": "Configuración de precios",
      "priceText": "Texto del precio",
      "priceYuan": "Precio",
      "prices": "precios",
      "prodMode": "Producción",
      "prodModeWarn": "En modo de producción ahora",
      "productOptionLabel": "Precio: {price} | Conteo de pulsos: {pulseCount}",
      "productionSubtext": "Transacciones en vivo habilitadas",
      "protocolCode": "Tipo de protocolo",
      "protocolConfig": "Configuración del protocolo",
      "protocolCreateSuccess": "Protocolo creado exitosamente",
      "protocolName": "Nombre del protocolo",
      "protocolUpdateSuccess": "Protocolo actualizado exitosamente",
      "inhibit": "Inhibit",
      "inhibitMode": "Modo de inhibicion",
      "inhibitModeHint": "Cuando esta activo, el dispositivo Trilad sera inhibido por el controlador de la maquina segun la siguiente logica.",
      "inhibitEnabled": "Enabled",
      "inhibitDisabled": "Disabled",
      "signalPolarity": "Polaridad de la senal",
      "signalPolarityHint": "El controlador de la maquina emitira nivel {polarity} para inhibir el dispositivo Trilad Payment.",
      "activeHigh": "Nivel alto",
      "activeLow": "Nivel bajo",
      "pulse": "Pulso",
      "pulseActive": "Duración activa del pulso",
      "pulseConfig": "Configuración de pulso",
      "pulseCount": "Número de pulsos",
      "pulseCountMustBeMultipleOfCoinCount": "El conteo de pulsos debe ser múltiplo del conteo de monedas ({coinCount})",
      "pulseDevice": "Dispositivo de pulso",
      "pulseInactive": "Duración inactiva del pulso",
      "pulseProtocol": "Protocolo de pulso",
      "pulseProtocolConfig": "Configuración del protocolo de pulso",
      "pulsePriceRequired": "Antes de guardar un protocolo Pulse, al menos un precio de la lista debe ser mayor que 0",
      "mdbCurrencyNumericCodeRequired": "Antes de guardar un protocolo MDB, la máquina debe tener configurado el código numérico de la moneda del paquete de pago",
      "pulseSettings": "Configuración de pulso",
      "pulseUnit": "Unidad de informe de pulso",
      "qrCode": "Código QR",
      "qrCodeDialogTitle": "Información del código QR",
      "qrCodeGenerating": "Generando código QR...",
      "qrCodeImage": "Código QR",
      "qrCodeLink": "Enlace",
      "qrCodeNo": "Número QR",
      "qrId": "ID QR",
      "quantity": "Cantidad",
      "queryMachineDetailFailed": "No se pudo consultar el detalle de la máquina",
      "queryMachineFavoriteListFailed": "No se pudo consultar la lista de favoritos de la máquina",
      "queryMachineListFailed": "No se pudo consultar la lista de máquinas",
      "queryMachineProtocolConfigFailed": "No se pudo consultar la configuración del protocolo de la máquina",
      "queryMachineTagsFailed": "No se pudieron consultar las etiquetas de la máquina",
      "queryMachineTransferLogListFailed": "No se pudo consultar la lista de registros de transferencias de la máquina",
      "queryMachineTypeFailed": "No se pudo consultar el tipo de máquina",
      "queryOrgPayPackageFailed": "No se pudo consultar el valor preestablecido de pago de la organización",
      "queryOrgTreeFailed": "No se pudo consultar el árbol de organización",
      "refreshMachineDetailFailed": "No se pudo actualizar el detalle de la máquina",
      "refreshMachineDetailSuccess": "Detalle de la máquina actualizado exitosamente",
      "refreshOrgDeviceListFailed": "No se pudo actualizar la lista de dispositivos de la organización",
      "remark": "Observación",
      "removeFavoriteFailed": "No se pudo eliminar de favoritos",
      "removeFavoriteSuccess": "Eliminado de favoritos con éxito",
      "resultAnimationGifs": "GIF de animación de resultados",
      "resultAnimationStaticImg": "Resultado Animación Imagen Estática",
      "resultDescription": "Descripción de la página de resultados",
      "resultTitle": "Título de la página de resultados",
      "sandboxMode": "Manifestación",
      "sandboxModeWarn": "En modo demostración ahora",
      "sandboxSubtext": "Solo transacciones simuladas",
      "save": "Guardar",
      "saveQrCode": "Guardar código QR",
      "saveQrCodeFailed": "Error al guardar",
      "saveQrCodeSuccess": "Guardar exitosa",
      "saveText": "Guardar texto",
      "sceneType": "Tipo de aplicación",
      "sceneTypeH5": "H5",
      "sceneTypeTerminal": "Terminal",
      "searchOrgOrDevice": "Buscar organizaciones o máquinas...",
      "searchMachines": "Buscar máquinas...",
      "foundMachines": "{count} máquinas encontradas",
      "orgScope": {
        "search": "Buscar galaxia...",
        "select": "Seleccionar",
        "empty": "No se encontraron organizaciones",
        "saveFailed": "No se pudo guardar el ámbito de la organización"
      },
      "treePopover": {
        "machineType": "Tipo de máquina",
        "machineNumber": "N.º de máquina",
        "device": "Dispositivo",
        "notAssigned": "Sin asignar",
        "qr": "QR",
        "number": "N.º",
        "url": "URL",
        "checkoutPage": "Página de pago",
        "lastOnline": "Última vez en línea"
      },
      "searching": "Búsqueda de organizaciones o máquinas que contengan \"{keyword}\"",
      "selectImage": "Seleccionar imagen",
      "selectImageRequired": "Por favor seleccione la imagen de la máquina",
      "selectLocation": "Seleccionar Ubicación",
      "selectOrgOrDevice": "Seleccione un dispositivo de la izquierda para ver los detalles",
      "selectProduct": "Seleccionar Producto",
      "selectProductPlaceholder": "Por favor seleccione un producto",
      "selectTargetOrg": "Por favor seleccione una organización objetivo",
      "sendOutputSignalFailed": "No se pudo enviar la señal de salida. Vuelva a intentarlo más tarde.",
      "serviceFeeRate": "Tarifa de conveniencia (cargo adicional)",
      "serviceFeeType": "Tipo de tarifa de conveniencia",
      "shenzhen": "Shénzhen",
      "shenzhenIndustrialPark": "Parque industrial Shenzhen Baoan",
      "showInsertedCoinCount": "Mostrar recuento de monedas insertadas",
      "singlePriceGoodsNameText": "Precio Único Texto \"Total\"",
      "singlePriceGoodsUnitText": "Precio único texto adicional",
      "stateLabel": "Estado:",
      "supportOnlinePayment": "Soporte de pago en línea",
      "switchToSandbox": "Cambiar a demostración",
      "sysMachineNo": "Sistema Máquina No.",
      "systemDeviceNumber": "ID de máquina del sistema",
      "taxRate": "Tasa impositiva (%)",
      "taxSettings": "Configuración de impuestos",
      "protocolConfigTitle": "Configuración de {protocol}",
      "mdbCurrencyScaling": "Escalado de moneda",
      "mdbExample": "p. ej.",
      "mdbScaleFactor": "Factor de escala",
      "mdbDecimalPlace": "Posición decimal",
      "mdbProtocolLevel": "Nivel de protocolo MDB",
      "mdbLevelOption": "Nivel {level}",
      "mdbLevelHintEnabled": "El Nivel 3 habilita el modo siempre inactivo. Al cambiar este parámetro, el dispositivo se reiniciará",
      "mdbLevelHintConnected": "La máquina conectada está usando MDB Nivel 2",
      "mdbLevelHintDisabled": "El modo siempre inactivo no es compatible con MDB Nivel {level}",
      "mdbAlwaysIdleMode": "Modo siempre inactivo",
      "mdbAlwaysIdleHintEnabled": "La transacción comenzará eligiendo un producto en la máquina expendedora",
      "mdbAlwaysIdleHintDisabled": "La transacción comenzará tocando el terminal para proporcionar un crédito predeterminado a la máquina expendedora",
      "mdbAlwaysIdleHintUnavailable": "Deshabilitado porque el modo siempre inactivo requiere MDB Nivel 3 o superior",
      "mdbCreditLimit": "Crédito predeterminado",
      "mdbDefaultCredit": "Crédito predeterminado",
      "mdbUseHighestLimit": "Usar el límite más alto",
      "mdbMonetaryFormat": "Formato monetario",
      "mdbMonetaryFormat16Hint": "Formato monetario estándar para controladores de máquina compatibles.",
      "mdbMonetaryFormat32Hint": "Rango monetario ampliado para transacciones de alto valor, cuando el controlador de la máquina lo admite.",
      "mdbCreditLimitAdjusted": "Se ha cambiado a {format}. El crédito predeterminado se ha ajustado al valor máximo permitido de {value}.",
      "mdbCreditLimitHint": "El valor máximo permitido es {value} ({maxInteger} × Scale Factor / (10^Decimal Place))",
      "mdbAutoRefund": "Reembolso automático",
      "mdbAutoRefundHint": "Reembolsa automáticamente al cliente si el pago se realiza correctamente pero la máquina informa una venta fallida",
      "mdbVendResultTimeout": "Tiempo de espera del resultado de venta",
      "mdbVendResultTimeoutHint": "Máximo 1800 segundos",
      "mdbCashSale": "Venta en efectivo",
      "mdbCashSaleHint": "Permitir que el VMC informe transacciones en efectivo al dispositivo Trilad",
      "mdbSessionIdleTimeout": "Tiempo de espera de sesión inactiva",
      "mdbMaximum255Seconds": "Máximo 255 segundos",
      "mdbApplicationMaximumResponseTime": "Tiempo máximo de respuesta de la aplicación",
      "textSettings": "Configuración de texto",
      "theme": "Tema",
      "themeZorbamaticGemstone": "Zorbamatic Gemstone",
      "themeZorbamaticWoodenBalls": "Zorbamatic Wooden Balls",
      "themeDarkFlame": "Llama oscura",
      "themeDefault": "Tema predeterminado",
      "themePeppaPigKiddleRide": "Paseo infantil de Peppa Pig",
      "themeGashapon": "Gashapon",
      "themeArcade": "Máquinas recreativas",
      "themePennyPress": "Prensa de monedas",
      "themePinball": "Pinball",
      "themeMassageChair": "Sillón de masaje",
      "timeoutDuration": "Duración del tiempo de espera",
      "timeoutNonCash": "Permitir transacciones que no sean en efectivo después del tiempo de espera",
      "timeoutSettings": "Configuración de tiempo de espera",
      "title": "Gestión de máquinas",
      "toOrg": "A la organización",
      "totalFrames": "Cuadros totales",
      "transferFailed": "La transferencia de la máquina falló",
      "transferMode": "Modo de transferencia",
      "transferModeOrgNo": "Ingrese el número de organización",
      "transferModeTree": "Seleccionar del árbol organizativo",
      "transferOrgSameWarning": "La organización objetivo no puede ser la misma que la actual.",
      "transferReason": "Motivo de la transferencia",
      "transferResult": "Resultado de la transferencia",
      "transferStatus": "Estado de transferencia",
      "transferSuccess": "La transferencia de la máquina fue exitosa",
      "triladSerial": "Serie Trilada",
      "triladSerialProtocol": "Protocolo serie Trilad",
      "unbindDevice": "Desasignar dispositivo",
      "unbindDeviceFailed": "No se pudo desasignar el dispositivo",
      "unbindDeviceSuccess": "Dispositivo desasignado correctamente",
      "unbound": "No asignado",
      "unitPrice": "Precio unitario",
      "unitSecond": "Segunda (s)",
      "unknownDevice": "Dispositivo desconocido",
      "unsupportedPlatProductCode": "Código de producto de plataforma no compatible",
      "updateMachineFailed": "No se pudo actualizar la máquina",
      "updateMachineSuccess": "Máquina actualizada exitosamente",
      "uploadGif": "Subir GIF",
      "uploadGifTip": "Admite formato GIF, imagen única de menos de 1 MB",
      "uploadImage": "Subir imagen",
      "uploadImageTip": "Admite formatos JPG, PNG, GIF, imagen única de menos de 1 MB",
      "uploadLottieAssets": "Cargar recursos de animación de Lottie",
      "uploaded": "subido",
      "viewAccessLog": "Ver registro",
      "viewQrCode": "Ver código QR",
      "viewTransactions": "Ver transacciones"
    }
  },
  "report": {
    "authorizationOrder": {
      "dialog": {
        "authInfo": "Información de autorización",
        "basicInfo": "Información básica",
        "captureAmount": "Cantidad de captura",
        "captureInfo": "Captura de transmisión",
        "captureOrderNo": "Captura Txn No.",
        "captureStatus": "Estado de captura",
        "captureTime": "Tiempo de captura",
        "channelErrorCode": "Código de error del canal",
        "channelErrorMsg": "Mensaje de error del canal",
        "channelResponseTime": "Tiempo de respuesta del canal",
        "goodsAmount": "Cantidad de mercancías",
        "noCaptureOrder": "Sin transacción de captura",
        "noVoidOrder": "Ninguna transacción nula",
        "orgPayFee": "Tarifa de pago de la organización",
        "outputNums": "Cantidad de salida",
        "outputStatus": "Estado de salida",
        "payResponseTime": "Tiempo de respuesta de pago",
        "payToken": "Ficha de pago",
        "remark": "Observación",
        "serviceFee": "Tarifa de conveniencia",
        "settleTime": "Tiempo de liquidación",
        "taxFee": "Tarifa de impuestos",
        "thirdDes": "Descripción de terceros",
        "thirdResponseTime": "Tiempo de respuesta de terceros",
        "title": "Detalles de transmisión de autorización",
        "traceId": "Solicitud API No.",
        "voidAmount": "Monto anulado",
        "voidInfo": "Txn vacío",
        "voidOrderNo": "Núm. de Txn nulo.",
        "voidStatus": "Estado nulo",
        "voidTime": "Tiempo vacío"
      },
      "messages": {
        "loadCaptureFailed": "No se pudo cargar la transacción de captura",
        "loadDataFailed": "No se pudieron cargar los datos de la transacción de autorización",
        "loadDetailFailed": "No se pudieron cargar los detalles de la transacción de autorización",
        "loadVoidFailed": "No se pudo cargar la transacción anulada"
      },
      "searchForm": {
        "channelAuthOrderNo": "Número de transmisión de autenticación de canal",
        "dateRange": "Rango de fechas",
        "deviceNumbers": "Números de dispositivo",
        "endPlaceholder": "Fecha de finalización",
        "keyword": "Búsqueda de palabras clave",
        "machineNumbers": "Números de máquina",
        "merchantAuthOrderNo": "Número de Txn de autenticación del comerciante.",
        "orderStatus": "Estado de transmisión",
        "placeholder": {
          "deviceNumbers": "Por favor seleccione Números de dispositivo",
          "keyword": "Ingrese el número de transacción, número de dispositivo, etc.",
          "machineNumbers": "Por favor seleccione Números de máquina"
        },
        "platformAuthOrderNo": "Número de transmisión de autenticación de plataforma",
        "rangeSeparator": "A",
        "startPlaceholder": "Fecha de inicio"
      },
      "status": {
        "FAILED": "Fallida",
        "Processing": "Tratamiento",
        "SUCCEEDED": "Tuvo éxito",
        "UNATTEMPTED": "Sin intentar",
        "closed": "Cerrada",
        "opened": "Abierta",
        "pending": "Pendiente",
        "processing": "Tratamiento",
        "shipped": "Enviada",
        "shippedFail": "Envío fallido",
        "unShipped": "Sin enviar"
      },
      "table": {
        "authAmount": "Monto de autorización",
        "authStatus": "Estado de autorización",
        "captureAmount": "Cantidad de captura",
        "captureStatus": "Estado de captura",
        "channelAuthOrderNo": "Número de transmisión de autenticación de canal",
        "createTime": "Crear tiempo",
        "currency": "Divisa",
        "deviceId": "ID del dispositivo",
        "deviceName": "Nombre del dispositivo",
        "deviceSn": "Número de dispositivo",
        "doorStatus": "Estado de la puerta",
        "merchantAuthOrderNo": "Número de Txn de autenticación del comerciante.",
        "operation": "Operación",
        "orgMachineNo": "Número de máquina organizativa",
        "payChannel": "Canal de pago",
        "payMethod": "Método de pago",
        "platformAuthOrderNo": "Número de transmisión de autenticación de plataforma",
        "thirdStatus": "Estado de terceros",
        "updateTime": "Hora de actualización",
        "viewDetail": "Ver detalles",
        "voidStatus": "Estado nulo"
      },
      "thirdStatus": {
        "00": "Existosa",
        "01": "Fallida"
      },
      "title": "Transacciones de autorización"
    },
    "transactions": {
      "title": "Transacciones",
      "export": "Exportar",
      "exportProgress": {
        "title": "Exportar",
        "exporting": "Exportando...",
        "count": "Obtenido {fetched} / {total}"
      },
      "exportHeaders": {
        "txnId": "ID de transacción",
        "machineName": "Nombre de la máquina",
        "machineNumber": "Número de máquina",
        "deviceType": "Tipo de dispositivo",
        "deviceNo": "N.º de dispositivo",
        "type": "Tipo",
        "status": "Estado",
        "selectionProducts": "Selección/Productos",
        "currency": "Moneda",
        "orderAmount": "Monto del pedido",
        "authAmount": "Monto autorizado",
        "settledAmount": "Monto liquidado",
        "createdTime": "Hora de creación",
        "settlementTime": "Hora de liquidación",
        "authTime": "Hora de autorización",
        "paymentChannel": "Canal de pago",
        "paymentProvider": "Proveedor de pago",
        "paymentMethod": "Método de pago",
        "galaxyName": "Nombre de organización",
        "galaxyId": "ID de organización"
      },
      "liveMode": "Modo en vivo",
      "demoMode": "Modo demo",
      "search": {
        "dateRange": "Rango de fechas",
        "createdTime": "Hora de creación",
        "authTime": "Hora de autorización",
        "settlementTime": "Hora de liquidación",
        "to": "A",
        "startTime": "Hora de inicio",
        "endTime": "Hora de fin",
        "txnId": "ID de transacción",
        "txnIdPlaceholder": "ID de transaccion",
        "machineDevice": "Máquina/Dispositivo",
        "machineDevicePlaceholder": "Nombre/Núm./SN/QR",
        "galaxy": "Organización",
        "galaxyPlaceholder": "Seleccione una organización",
        "type": "Tipo de transacción",
        "status": "Estado",
        "payment": "Pago",
        "method": "Method",
        "channel": "Channel",
        "provider": "Provider"
      },
      "table": {
        "displayOrderNo": "ID de transaccion",
        "machineDevice": "Máquina/Dispositivo",
        "galaxyId": "Organización/ID",
        "machineNo": "Núm. de máquina",
        "deviceSn": "SN del dispositivo",
        "methodChannel": "Método/Canal",
        "typeStatus": "Tipo/Estado",
        "selectionProducts": "Selección/Productos",
        "orderAmount": "Monto del pedido",
        "authAmount": "Monto autorizado",
        "settledAmount": "Monto liquidado",
        "authTime": "Hora de autorización",
        "settlementTime": "Hora de liquidación",
        "paymentChannel": "Canal de pago",
        "paymentProvider": "Proveedor de pago",
        "paymentMethod": "Método de pago",
        "createdTime": "Hora de creación",
        "operation": "Operación",
        "clickToCopy": "Haga clic para copiar",
        "machineConfiguration": "Configuración de máquina"
      },
      "type": {
        "sale": "Venta",
        "freeVend": "Venta gratuita",
        "preAuth": "Preautorización",
        "cash": "Efectivo",
        "refund": "Reembolso"
      },
      "status": {
        "pending": "Pendiente",
        "processing": "En proceso",
        "refundProcessing": "Reembolso en proceso",
        "success": "Existosa",
        "failed": "Fallida",
        "refundFailed": "Reembolso fallido",
        "authFailed": "Autorizacion fallida",
        "cancelled": "Cancelada",
        "authorized": "Autorizada",
        "notComplete": "Incompleta",
        "voided": "Anulada",
        "refundReview": "Revisión de reembolso",
        "refundRejected": "Reembolso rechazado",
        "fullyRefunded": "Reembolso total",
        "partiallyRefunded": "Reembolso parcial"
      },
      "detail": {
        "currentTimezone": "Zona horaria actual",
        "machineTimezone": "Zona horaria de la máquina",
        "tabs": {
          "payment": "Pago",
          "refund": "Reembolso",
          "order": "Pedido",
          "fees": "Tarifas",
          "machine": "Máquina"
        },
        "machineInfo": "Información de la máquina",
        "type": "Tipo",
        "currency": "Moneda",
        "status": "Estado",
        "fee": "Tarifa",
        "netAmount": "Monto neto",
        "authorized": "Autorizado",
        "order": "Pedido",
        "settled": "Liquidado",
        "vend": "Dispensación",
        "vendStatus": {
          "success": "Exitosa",
          "processing": "En proceso",
          "failed": "Fallida"
        },
        "machineName": "Nombre de la máquina",
        "machineNo": "Núm. de máquina",
        "systemMachineNo": "Núm. de máquina del sistema",
        "deviceNo": "SN del dispositivo",
        "qrNo": "Núm. QR",
        "location": "Ubicación",
        "operatorName": "Nombre del operador",
        "operatorId": "ID del operador",
        "paymentMethod": "Método de pago",
        "paymentChannel": "Canal de pago",
        "paymentProvider": "Proveedor de pago",
        "providerTxnId": "ID de transacción del proveedor",
        "payerName": "Nombre del pagador",
        "createdTime": "Hora de creación",
        "authTime": "Hora de autorización",
        "settlementTime": "Hora de liquidación",
        "refundOrder": "Pedido de reembolso",
        "refundApplications": "Solicitudes de reembolso",
        "id": "ID",
        "refundTime": "Hora del reembolso",
        "applicant": "Solicitante",
        "applicationTime": "Hora de la solicitud",
        "auditComment": "Comentario de auditoría",
        "description": "Descripción",
        "units": "Unidades",
        "price": "Precio",
        "amount": "Importe",
        "bill": "Billete",
        "coin": "Moneda",
        "totalAmount": "Importe total",
        "subtotal": "Subtotal",
        "discount": "Descuento",
        "tax": "Impuesto",
        "convenienceFee": "Tarifa de conveniencia",
        "handlingFee": "Tarifa de procesamiento",
        "transactionTax": "IVA sobre las tarifas de procesamiento"
      },
      "messages": {
        "loadDataFailed": "No se pudieron cargar las transacciones",
        "noExportData": "No hay datos para exportar"
      }
    },
    "refundApply": {
      "auditDialog": {
        "auditComment": "Comentario de auditoría",
        "auditResult": "Resultado de la auditoría",
        "confirmMessage": "¿Está seguro de que desea {result} esta solicitud de reembolso?",
        "confirmTitle": "Confirmar auditoría",
        "placeholder": {
          "auditComment": "Por favor ingrese el comentario de auditoría (obligatorio para el rechazo)"
        },
        "title": "Solicitud de reembolso de auditoría",
        "validation": {
          "auditCommentLength": "El comentario de auditoría no puede exceder los 500 caracteres.",
          "auditCommentRequiredForReject": "Se requiere un comentario de auditoría al rechazar",
          "auditResultRequired": "Por favor seleccione el resultado de la auditoría"
        }
      },
      "auditResult": {
        "APPROVED": "Aprobar",
        "REJECTED": "Rechazar"
      },
      "dateRange": {
        "endPlaceholder": "Fecha de finalización",
        "separator": "a",
        "startPlaceholder": "Fecha de inicio"
      },
      "dialog": {
        "applyInfo": "Información de la aplicación",
        "title": "Detalle de la aplicación"
      },
      "messages": {
        "auditFailed": "La auditoría falló",
        "auditSuccess": "Auditoría exitosa",
        "loadDataFailed": "No se pudieron cargar los datos de la solicitud de reembolso",
        "loadDetailFailed": "No se pudieron cargar los detalles de la aplicación"
      },
      "searchForm": {
        "applyNo": "Solicitud No.",
        "applyStatus": "Estado de la solicitud",
        "dateRange": "Tiempo de aplicación",
        "orderNo": "Nro. de orden"
      },
      "status": {
        "APPROVED": "Aprobada",
        "CANCELLED": "Cancelada",
        "PENDING": "Pendiente",
        "REJECTED": "Rechazada",
        "REFUND_PROCESSING": "Reembolso en proceso",
        "REFUND_SUCCEEDED": "Reembolso exitoso",
        "REFUND_FAILED": "Reembolso fallido"
      },
      "table": {
        "applicantName": "Solicitante",
        "applyAmount": "Monto de la solicitud",
        "applyNo": "Solicitud No.",
        "applyReason": "Motivo de la solicitud",
        "applyStatus": "Estado de la solicitud",
        "applyTime": "Tiempo de aplicación",
        "audit": "Auditoría",
        "auditComment": "Comentario de auditoría",
        "auditTime": "Tiempo de auditoría",
        "auditorName": "Auditora",
        "currency": "Divisa",
        "operation": "Operación",
        "orderNo": "Nro. de orden",
        "refundOrderNo": "Orden de reembolso No.",
        "viewDetail": "Ver detalle"
      },
      "title": "Gestión de solicitudes de reembolso"
    },
    "salesAnalysis": {
      "salesDescription": "La función de análisis de ventas está en desarrollo, estad atentos...",
      "salesDeveloping": "Característica en desarrollo",
      "title": "Ventas por"
    },
    "salesByMachine": {
      "title": "Ventas por máquina",
      "exportProgress": {
        "title": "Exportar Excel",
        "exporting": "Exportando...",
        "count": "Obtenido {fetched} / {total}"
      },
      "exportHeaders": {
        "machineName": "Nombre de la máquina",
        "machineNumber": "Número de máquina",
        "deviceType": "Tipo de dispositivo",
        "deviceNo": "N.º de dispositivo",
        "galaxyName": "Nombre de organización",
        "galaxyCurrency": "Moneda de organización",
        "totalsTxns": "Txns totales",
        "totalsGrossAmt": "Monto bruto total",
        "totalsCashlessCashPct": "Total de pagos digitales/efectivo $%",
        "cashlessTxns": "Txns pagos digitales",
        "cashlessGrossAmt": "Monto bruto de pagos digitales",
        "cashlessAtv": "ATV en pagos digitales",
        "cashTxns": "Txns en efectivo",
        "cashAmount": "Monto en efectivo",
        "cashAtv": "ATV en efectivo",
        "refundTxns": "Txns reembolso",
        "refundAmt": "Monto reembolso"
      },
      "overview": {
        "totalMachines": "Máquinas totales",
        "transactingMachines": "Máquinas con transacciones"
      },
      "search": {
        "galaxy": "Galaxy",
        "galaxyPlaceholder": "Por favor seleccione",
        "dateRange": "Rango de fechas",
        "to": "A",
        "startTime": "Hora de inicio",
        "endTime": "Hora de fin",
        "reportingCurrency": "Moneda del informe",
        "payment": "Pago en pagos digitales",
        "machineDevice": "Máquina / Dispositivo",
        "machineDevicePlaceholder": "Nombre/Nro./SN/QR"
      },
      "table": {
        "index": "#",
        "machineDevice": "Máquina / Dispositivo",
        "galaxyCurrency": "Galaxy / Moneda",
        "currency": "Divisa",
        "totals": "Totales",
        "cashless": "Pagos Digitales",
        "cash": "Efectivo",
        "txns": "Txns",
        "grossAmt": "Monto bruto",
        "cashlessCashPct": "Pagos Digitales / Efectivo $%",
        "atv": "ATV",
        "amount": "Monto",
        "refundTxns": "Txns reembolso",
        "refundAmt": "Monto reembolso",
        "netAmount": "Monto neto",
        "operation": "Operación"
      },
      "summary": {
        "totalAllResults": "Total - Todos los resultados"
      },
      "messages": {
        "noExportData": "No hay datos para exportar"
      },
      "columnPreference": {
        "title": "Agregar/Quitar campos",
        "description": "Seleccione las columnas para mostrar."
      }
    },
    "transactionOrder": {
      "cashBreakdown": {
        "bill": "Factura",
        "coin": "Acuñar"
      },
      "dateRange": {
        "endPlaceholder": "Fecha de finalización",
        "separator": "a",
        "startPlaceholder": "Fecha de inicio"
      },
      "dialog": {
        "amountInfo": "Información de cantidad",
        "applicantName": "Solicitante",
        "applyAmount": "Monto de la solicitud",
        "applyNo": "Solicitud No.",
        "applyStatus": "Estado de la solicitud",
        "applyTime": "Tiempo de aplicación",
        "auditComment": "Comentario de auditoría",
        "basicInfo": "Información básica",
        "channelRefundOrderNo": "Canal Reembolso Txn No.",
        "commissionServiceFee": "Tarifa de conveniencia de la comisión",
        "currency": "Divisa",
        "discountAmount": "Cantidad de descuento",
        "goodsAmount": "Cantidad de mercancías",
        "mdrVatAmount": "Impuesto sobre transacciones",
        "merchantReceivedAmount": "Importe recibido por el comerciante",
        "merchantRefundOrderNo": "N.º de Txn de reembolso al comerciante",
        "noRefundApplies": "Sin solicitudes de reembolso",
        "noRefundOrders": "Sin transacciones de reembolso",
        "orgPayFee": "Tarifa de manejo",
        "productExternalId": "ID externo del producto",
        "productInfo": "Información del producto",
        "productInfoLabel": "Información del producto",
        "productInternalCode": "Código interno del producto",
        "profit": "Beneficio de la plataforma",
        "refundAmount": "Monto del reembolso",
        "refundAmountLabel": "Monto del reembolso",
        "refundApplies": "Solicitudes de reembolso",
        "refundOrderNo": "Reembolso Txn No.",
        "refundOrders": "Transacciones de reembolso",
        "refundStatus": "Estado del reembolso",
        "refundTime": "Tiempo de reembolso",
        "serviceFee": "Tarifa de conveniencia",
        "singleProductCode": "Código de producto único",
        "title": "Detalles de la transacción"
      },
      "envMode": {
        "production": "Producción",
        "sandbox": "Manifestación"
      },
      "messages": {
        "loadDataFailed": "No se pudieron cargar los datos de Txn",
        "loadDetailFailed": "No se pudieron cargar los detalles de Txn",
        "loadRefundApplyFailed": "No se pudieron cargar los registros de solicitud de reembolso",
        "refundAuditNoLongerPending": "Esta solicitud de reembolso ya no está pendiente.",
        "loadRefundFailed": "No se pudieron cargar las transacciones de reembolso",
        "refundApplyFailed": "No se pudo enviar la solicitud de reembolso",
        "refundApplyPending": "Hay una solicitud de reembolso pendiente para este pedido, no se puede enviar una nueva",
        "refundApplySuccess": "Solicitud de reembolso enviada, pendiente de revisión",
        "refundFailed": "Reembolso fallido",
        "refundPending": "Esta transacción tiene reembolsos pendientes, no se puede iniciar un nuevo reembolso",
        "refundSuccess": "Reembolso exitosa"
      },
      "orderType": {
        "capture": "Autorización previa completa",
        "cash_order": "Dinero",
        "feeVend": "Venta gratuita",
        "qr": "Código QR dinámico",
        "transfer": "Venta",
        "void_order": "Cancelar autorización previa"
      },
      "prizeWin": {
        "0": "No",
        "1": "Enviada"
      },
      "pulseStatus": {
        "0": "Esperando completar",
        "1": "Consumidora",
        "2": "Terminada"
      },
      "recognitionMethod": {
        "H5": "H5",
        "chip": "Tarjeta con chip",
        "magnetic": "Tarjeta magnética"
      },
      "auditDialog": {
        "amountRequested": "Monto de reembolso solicitado",
        "auditAction": "Auditar solicitud de reembolso",
        "approveMessage": "¿Está seguro de que desea aprobar el reembolso de esta transacción?",
        "approveTitle": "Aprobar reembolso",
        "by": "By",
        "comment": "Comentario",
        "placeholder": {
          "approveComment": "Escriba comentarios adicionales aquí. (Opcional)",
          "rejectReason": "Por favor ingrese el motivo del rechazo."
        },
        "refundReason": "Motivo del reembolso",
        "rejectMessage": "¿Está seguro de que desea rechazar esta solicitud de reembolso?",
        "rejectReason": "Motivo",
        "rejectTitle": "Rechazar reembolso",
        "requestTime": "Hora de la solicitud",
        "requestTitle": "Solicitud de reembolso",
        "requestedBy": "Solicitado por",
        "validation": {
          "commentLength": "El contenido no puede exceder los 255 caracteres",
          "rejectReasonRequired": "Por favor ingrese el motivo del rechazo"
        }
      },
      "refundDialog": {
        "applyConfirmMessage": "¿Está seguro de que desea enviar una solicitud de reembolso por {amount}?",
        "applyConfirmTitle": "Confirmar envío",
        "applyTitle": "Solicitud de reembolso",
        "confirmMessage": "¿Estás segura de que deseas reembolsar {amount}?",
        "confirmTitle": "Confirmar reembolso",
        "orderNo": "Txn No.",
        "placeholder": {
          "refundAmount": "Por favor ingrese el monto del reembolso",
          "refundReason": "Por favor ingresa el motivo del reembolso",
          "withdrawMethodKey": "Por favor ingrese la clave de usuario"
        },
        "refundAmount": "Monto del reembolso",
        "refundReason": "Motivo del reembolso",
        "refundableAmount": "Monto máximo reembolsable",
        "refundedAmount": "Monto reembolsado",
        "requestAction": "Solicitar",
        "title": "Reembolso",
        "totalAmount": "Monto total",
        "validation": {
          "refundAmountMax": "El monto del reembolso no puede exceder {max}",
          "refundAmountMin": "El monto del reembolso debe ser mayor que 0",
          "refundAmountRequired": "Por favor ingrese el monto del reembolso",
          "refundReasonLength": "La longitud del motivo del reembolso debe tener entre 1 y 500 caracteres.",
          "refundReasonRequired": "Por favor ingresa el motivo del reembolso",
          "withdrawMethodKeyLength": "La longitud de la clave de usuario no puede exceder los 200 caracteres",
          "withdrawMethodKeyRequired": "Por favor ingrese la clave de usuario"
        },
        "withdrawMethodKey": "Clave de usuario"
      },
      "searchForm": {
        "channelOrderNo": "Canal Txn No.",
        "dateRange": "Rango de fechas",
        "deviceNumbers": "Números de dispositivo",
        "keyword": "Búsqueda de palabras clave",
        "machineNo": "Máquina No.",
        "machineNumbers": "Números de máquina",
        "merchantOrderNo": "Comerciante Txn No.",
        "orderNo": "Nro. de transacción",
        "orderStatus": "Estado de la transacción",
        "orderType": "Tipo de transacción",
        "placeholder": {
          "deviceNumbers": "Por favor seleccione Números de dispositivo",
          "keyword": "Ingrese el número de transacción, número de dispositivo, etc.",
          "machineNo": "Por favor ingrese el número de máquina",
          "machineNumbers": "Por favor seleccione Números de máquina",
          "orderNo": "Por favor ingrese el número de transacción"
        },
        "platformOrderNo": "Plataforma Txn No."
      },
      "status": {
        "FAILED": "Fallida",
        "Processing": "Tratamiento",
        "SUCCEEDED": "Tuvo éxito",
        "UNATTEMPTED": "Sin intentar",
        "processing": "Tratamiento",
        "shipped": "Enviada",
        "shippedFail": "Envío fallido",
        "unShipped": "Sin enviar"
      },
      "table": {
        "authDate": "Fecha de autorización",
        "authTime": "Hora de autorización",
        "billAmount": "Monto de la factura",
        "channelOrderNo": "Canal Txn No.",
        "coinAmount": "Cantidad de moneda",
        "currency": "Divisa",
        "deviceId": "ID del dispositivo",
        "deviceName": "Nombre del dispositivo",
        "deviceSn": "Número de dispositivo",
        "envMode": "Modo ambiente",
        "machineName": "Nombre de la máquina",
        "machineNumber": "Número de máquina",
        "merchantOrderNo": "Comerciante Txn No.",
        "netAmount": "Importe neto",
        "operation": "Operación",
        "orderStatus": "Estado de la transacción",
        "orderType": "Tipo de transacción",
        "orgMachineNo": "Sistema Máquina No.",
        "outputStatus": "Estado de salida",
        "payChannel": "Proveedor de pago",
        "payMethod": "Canal de pago",
        "platformOrderNo": "Plataforma Txn No.",
        "prizeWin": "Premio ganado",
        "productCode": "Código de producto",
        "productName": "Nombre del producto",
        "recognitionMethod": "Método de reconocimiento",
        "refund": "Reembolso",
        "refundAmount": "Monto del reembolso",
        "refundApply": "Reembolso",
        "refundStatus": "Estado del reembolso",
        "remark": "Observación",
        "serviceFee": "Tarifa de conveniencia",
        "settleDate": "Fecha de liquidación",
        "settleTime": "Tiempo de liquidación",
        "taxAmount": "Monto del impuesto",
        "totalAmount": "Monto total",
        "viewDetail": "Ver detalles"
      },
      "title": "Informe de transacciones"
    }
  },
  "routeButton": {
    "auth_getRoleAuth": "Obtener permisos de rol",
    "button_add": "Agregar botón",
    "button_delete": "Botón Eliminar",
    "button_findAll": "Consultar todos los botones",
    "button_getMenuButton": "Botones del menú de consulta",
    "button_update": "Botón Editar",
    "channelPlatProduct_add": "Agregar canal de pago asociado",
    "channelPlatProduct_delete": "Eliminar canal de pago asociado",
    "channelPlatProduct_getPage": "Consultar canales de pago asociados",
    "channelProduct_add": "Agregar producto de canal",
    "channelProduct_delete": "Eliminar producto del canal",
    "channelProduct_getPage": "Lista de productos del canal de consulta",
    "channelProduct_update": "Editar producto del canal",
    "country_add": "Agregar país",
    "country_delete": "Eliminar país",
    "country_getPage": "Lista de países de consulta",
    "country_update": "Editar país",
    "currency_add": "Agregar moneda",
    "currency_delete": "Eliminar moneda",
    "currency_getPage": "Lista de monedas de consulta",
    "currency_update": "Editar moneda",
    "dashboard_getCurrencyOptions": "Obtener opciones de moneda",
    "dashboard_getMachineLocationList": "Obtener lista de ubicaciones de máquinas",
    "dashboard_getMachineOptions": "Obtener opciones de máquina",
    "dashboard_getMachinePerformanceBottom": "Obtener el rendimiento más bajo de la máquina",
    "dashboard_getMachinePerformanceTop": "Obtenga el máximo rendimiento de la máquina",
    "dashboard_getMachineStatusSummary": "Obtener resumen del estado de la máquina",
    "dashboard_getMultiPeriodOverview": "Obtenga una descripción general de varios períodos",
    "dashboard_getPayMethodOptions": "Obtener opciones de métodos de pago",
    "dashboard_getPaymentMethodBreakdown": "Obtener desglose del método de pago",
    "dashboard_getSalesTrend": "Obtener tendencia de ventas",
    "deviceCommandLog_add": "Agregar registro de comando del dispositivo",
    "deviceCommandLog_delete": "Eliminar registro de comandos del dispositivo",
    "deviceCommandLog_getPage": "Consultar la lista de registros de comandos del dispositivo",
    "deviceCommandLog_update": "Editar registro de comandos del dispositivo",
    "deviceConfigTemplate_add": "Agregar plantilla de configuración del dispositivo",
    "deviceConfigTemplate_delete": "Eliminar plantilla de configuración del dispositivo",
    "deviceConfigTemplate_getPage": "Consultar lista de plantillas de configuración de dispositivos",
    "deviceConfigTemplate_update": "Editar plantilla de configuración del dispositivo",
    "deviceConfig_add": "Agregar configuración de dispositivo",
    "deviceConfig_delete": "Eliminar configuración del dispositivo",
    "deviceConfig_getConfig": "Consultar configuración del dispositivo",
    "deviceConfig_getPage": "Consultar la lista de configuración del dispositivo",
    "deviceConfig_pushConfig": "Configuración del dispositivo push",
    "deviceConfig_sendCommand": "Enviar comando de dispositivo",
    "deviceConfig_update": "Editar configuración del dispositivo",
    "deviceModelConfig_add": "Agregar configuración del módulo del dispositivo",
    "deviceModelConfig_delete": "Eliminar la configuración del módulo del dispositivo",
    "deviceModelConfig_getPage": "Consultar lista de configuración del módulo de dispositivo",
    "deviceModelConfig_update": "Editar configuración del módulo del dispositivo",
    "deviceType_add": "Agregar tipo de dispositivo",
    "deviceType_delete": "Eliminar tipo de dispositivo",
    "deviceType_getPage": "Consultar lista de tipos de dispositivos",
    "deviceType_update": "Editar tipo de dispositivo",
    "device_add": "Agregar dispositivo",
    "device_advanced_settings": "Configuración avanzada del dispositivo",
    "device_batchRegister": "Dispositivos de registro de lotes",
    "device_delete": "Eliminar dispositivo",
    "device_getDetail": "Consultar detalles del dispositivo",
    "device_getDeviceInfo": "Consultar información del dispositivo",
    "device_getPage": "Consultar lista de dispositivos",
    "device_getStatus": "Consultar el estado del dispositivo",
    "device_update": "Editar dispositivo",
    "device_bindMachine": "Asignar máquina",
    "dictItem_add": "Agregar elemento de diccionario",
    "dictItem_delete": "Eliminar elemento del diccionario",
    "dictItem_getPage": "Lista de elementos del diccionario de consultas",
    "dictItem_update": "Editar elemento del diccionario",
    "dict_add": "Agregar diccionario",
    "dict_delete": "Eliminar diccionario",
    "dict_getPage": "Lista de diccionarios de consultas",
    "dict_update": "Editar diccionario",
    "file_upload": "Carga de archivos",
    "machineCashClearLog_getList": "Consultar registro de liquidación de efectivo",
    "machineDeviceRel_getPage": "Lista de relaciones de dispositivos de la máquina de consulta",
    "machineFavorite_add": "Agregar máquina favorita",
    "machineFavorite_delete": "Eliminar favorito de la máquina",
    "machineFavorite_getPage": "Lista de favoritos de la máquina de consultas",
    "machineFavorite_update": "Editar favorito de la máquina",
    "machineProtocolConfig_add": "Agregar configuración de protocolo de máquina",
    "machineProtocolConfig_delete": "Eliminar la configuración del protocolo de la máquina",
    "machineProtocolConfig_getByMachineId": "Consultar la lista de configuración del protocolo de la máquina por ID de la máquina",
    "machineProtocolConfig_getPage": "Consultar la lista de configuración del protocolo de la máquina",
    "machineProtocolConfig_update": "Editar configuración del protocolo de la máquina",
    "machineTagRel_add": "Agregar relación de etiqueta de máquina",
    "machineTagRel_delete": "Eliminar relación de etiqueta de máquina",
    "machineTagRel_getPage": "Lista de relaciones de etiquetas de máquina de consulta",
    "machineTagRel_update": "Editar relación de etiqueta de máquina",
    "machineTag_add": "Agregar etiqueta de máquina",
    "machineTag_delete": "Eliminar etiqueta de máquina",
    "machineTag_find": "Etiqueta de máquina de consulta",
    "machineTag_getPage": "Lista de etiquetas de la máquina de consulta",
    "machineTag_update": "Editar etiqueta de máquina",
    "machineTransferLog_add": "Agregar registro de transferencia de máquina",
    "machineTransferLog_delete": "Eliminar registro de transferencia de máquina",
    "machineTransferLog_getPage": "Consultar la lista de registros de transferencia de la máquina",
    "machineTransferLog_update": "Editar registro de transferencia de máquina",
    "machineType_add": "Agregar tipo de máquina",
    "machineType_delete": "Eliminar tipo de máquina",
    "machineType_find": "Tipo de máquina de consulta",
    "machineType_getPage": "Lista de tipos de máquinas de consulta",
    "machineType_update": "Editar tipo de máquina",
    "machine_add": "Agregar máquina",
    "machine_bind": "Asignar máquina",
    "machine_clearCash": "Limpiar efectivo",
    "machine_delete": "Eliminar máquina",
    "machine_getDetail": "Consultar detalles de la máquina",
    "machine_getPage": "Lista de máquinas de consulta",
    "machine_manualOutput": "Salida manual",
    "machine_switchEnvMode": "Cambiar modo de entorno",
    "machine_transfer": "Transferencia de máquina",
    "machine_unbindDevice": "Desasignar dispositivo",
    "machine_update": "Editar máquina",
    "mainOrder_queryList": "Lista de Txn de autorización de consulta",
    "mediaResource_add": "Agregar recurso multimedia",
    "mediaResource_delete": "Eliminar recurso multimedia",
    "mediaResource_getPage": "Lista de recursos de medios de consulta",
    "mediaResource_update": "Editar recurso multimedia",
    "menuAuth_addAuthBatch": "Permisos de menú para agregar por lotes",
    "menuAuth_getAllMenu": "Consultar todos los menús",
    "menuAuth_getMenuButton": "Botones del menú de consulta",
    "menu_add": "Agregar menú",
    "menu_delete": "Eliminar menú",
    "menu_findAll": "Consultar todos los menús",
    "menu_update": "Editar menú",
    "openApiGameWayConfig_add": "Agregar configuración de puerta de enlace OpenAPI",
    "openApiGameWayConfig_delete": "Eliminar la configuración de OpenAPI Gateway",
    "openApiGameWayConfig_getByOrgId": "Consultar la configuración de OpenAPI Gateway por ID de organización",
    "openApiGameWayConfig_getByOrgIdAndGatewayType": "Consultar la configuración de OpenAPI Gateway por ID de organización y tipo de puerta de enlace",
    "openApiGameWayConfig_getPage": "Consultar la lista de configuración de OpenAPI Gateway",
    "openApiGameWayConfig_update": "Editar la configuración de OpenAPI Gateway",
    "openApiKey_add": "Agregar clave OpenAPI",
    "openApiKey_delete": "Eliminar clave OpenAPI",
    "openApiKey_getDetail": "Consultar detalle de clave de OpenAPI",
    "openApiKey_getPage": "Consultar la lista de claves de OpenAPI",
    "openApiKey_resetPassword": "Restablecer la contraseña de la clave OpenAPI",
    "openApiKey_update": "Editar clave OpenAPI",
    "oper_addOper": "Agregar operadora",
    "oper_del": "Eliminar operadora",
    "oper_findPageOper": "Lista de operadores de consulta",
    "oper_findPageSubOper": "Lista de suboperadores de consulta",
    "oper_resetPassWord": "Restablecer contraseña",
    "oper_update": "Operadora de edición",
    "order_queryList": "Lista de transmisión de consultas",
    "orgPayChannel_add": "Agregar canal de pago",
    "orgPayChannel_delete": "Eliminar canal de pago",
    "orgPayChannel_getPage": "Consultar lista de canales de pago",
    "orgPayChannel_update": "Editar canal de pago",
    "orgPayMethod_add": "Agregar método de pago",
    "orgPayMethod_delete": "Eliminar método de pago",
    "orgPayMethod_getPage": "Consultar lista de métodos de pago",
    "orgPayMethod_update": "Editar método de pago",
    "orgPayPackageChannel_add": "Agregar proveedor de pago",
    "orgPayPackageChannel_delete": "Eliminar proveedor de pago",
    "orgPayPackageChannel_getPage": "Consultar lista de proveedores de pago",
    "orgPayPackageChannel_update": "Editar proveedor de pago",
    "orgPayPackageMethod_add": "Agregar método de plantilla de pago",
    "orgPayPackageMethod_delete": "Eliminar método de plantilla de pago",
    "orgPayPackageMethod_getPage": "Consultar lista de métodos de plantilla de pago",
    "orgPayPackageMethod_getPayMethodsByChannel": "Obtenga métodos de pago del paquete organizativo por canal",
    "orgPayPackageMethod_update": "Editar método de plantilla de pago",
    "orgPayPackage_add": "Agregar plantilla de pago",
    "orgPayPackage_delete": "Eliminar plantilla de pago",
    "orgPayPackage_getPage": "Consultar lista de plantillas de pago",
    "orgPayPackage_update": "Editar plantilla de pago",
    "org_delete": "Eliminar agencia",
    "org_getDeviceCountByOrg": "Consultar recuento de dispositivos de agencia",
    "org_getOrgDetail": "Detalles de la organización de consulta",
    "org_getTreeList": "Lista de árbol de organización de consultas",
    "org_initNewOrg": "Inicializar nueva organización",
    "org_update": "Editar organización",
    "payChannel_add": "Agregar canal de pago",
    "payChannel_delete": "Eliminar canal de pago",
    "payChannel_getDetailPage": "Consultar lista detallada de canales de pago",
    "payChannel_getPage": "Consultar lista de canales de pago",
    "payChannel_update": "Editar canal de pago",
    "payMethodChannelProduct_add": "Agregar producto de canal de método de pago",
    "payMethodChannelProduct_delete": "Eliminar producto del canal de método de pago",
    "payMethodChannelProduct_getPage": "Consultar lista de productos del canal de métodos de pago",
    "payMethodChannelProduct_getPayMethodWithProductsPage": "Consultar métodos de pago y productos de canales relacionados",
    "payMethodChannelProduct_update": "Editar producto del canal de método de pago",
    "payMethod_add": "Agregar método de pago",
    "payMethod_delete": "Eliminar método de pago",
    "payMethod_getPage": "Consultar lista de métodos de pago",
    "payMethod_update": "Editar método de pago",
    "permissionGroupRel_add": "Agregar relación de grupo de permisos",
    "permissionGroupRel_delete": "Eliminar relación de grupo de permisos",
    "permissionGroupRel_getMenuButton": "Botón de menú de grupo de permisos de consulta",
    "permissionGroupRel_getPage": "Lista de relaciones del grupo de permisos de consulta",
    "permissionGroupRel_sync": "Relación del grupo de permisos de sincronización",
    "permissionGroupRel_update": "Editar relación de grupo de permisos",
    "permissionGroup_add": "Agregar grupo de permisos",
    "permissionGroup_delete": "Eliminar grupo de permisos",
    "permissionGroup_getPage": "Lista de grupos de permisos de consulta",
    "permissionGroup_update": "Editar grupo de permisos",
    "platProduct_add": "Agregar producto de plataforma",
    "platProduct_delete": "Eliminar producto de plataforma",
    "platProduct_getPage": "Productos de plataforma de consultas",
    "platProduct_update": "Actualizar producto de plataforma",
    "qrCode_add": "Agregar código QR",
    "qrCode_generate": "Generar código QR",
    "qrCode_getPage": "Consultar lista de códigos QR",
    "qrCode_unbindById": "Desasignar código QR",
    "qrCode_update": "Editar código QR",
    "refundApply_audit": "Solicitud de reembolso de auditoría",
    "refundApply_detail": "Ver detalles de la solicitud de reembolso",
    "refundApply_queryList": "Consultar lista de solicitudes de reembolso",
    "refundApply_submit": "Enviar solicitud de reembolso",
    "refundOrder_create": "Crear transmisión de reembolso",
    "refundOrder_queryList": "Consultar lista de transmisión de reembolso",
    "rolePermissionGroupRel_add": "Agregar relación de grupo de permisos de rol",
    "rolePermissionGroupRel_delete": "Eliminar relación de grupo de permisos de función",
    "rolePermissionGroupRel_getPage": "Lista de relaciones de grupo de permisos de función de consulta",
    "rolePermissionGroupRel_update": "Editar relación de grupo de permisos de función",
    "role_add": "Agregar rol",
    "role_delete": "Eliminar rol",
    "role_get": "Función de consulta",
    "role_getAllRole": "Consultar todos los roles",
    "role_roleDetail": "Detalles de la función de consulta",
    "role_update": "Editar rol",
    "sysParams_add": "Agregar parámetro del sistema",
    "sysParams_findByParamName": "Consulta por nombre de parámetro",
    "sysParams_getAllList": "Consultar todos los parámetros del sistema",
    "sysParams_update": "Editar parámetro del sistema",
    "test(空按钮 勿删)": "Botón de prueba",
    "voidOrder_queryList": "Consultar lista de transmisiones nulas"
  },
  "router": {
    "agencyManagement": "Gestión de galaxias",
    "authorization-order": "Transacciones de Autorizaciones",
    "businessIntelligence": "Inteligencia empresarial",
    "countryManagement": "Gestión País",
    "currencyManagement": "Gestión de divisas",
    "dashboard": "Panel",
    "development": "Centro de desarrollo",
    "deviceConfigTemplate": "Plantilla de configuración del dispositivo",
    "deviceManagement": "Gestión de dispositivos",
    "deviceModelConfig": "Configuración del módulo del dispositivo",
    "deviceTagManagement": "Gestión de etiquetas de máquina",
    "deviceTransferLog": "Registro de transferencia de dispositivo",
    "deviceTypeManagement": "Gestión de tipos de dispositivos",
    "dictionaryManagement": "Gestión de diccionarios",
    "login": "Acceso",
    "machine-transfer-log": "Registro de transferencia de máquina",
    "machineManagement": "Gestión de máquinas",
    "machineTypeManagement": "Gestión de tipos de máquinas",
    "mediaResourceManagement": "Gestión de recursos multimedia",
    "menuManagement": "Gestión de menú",
    "myAccount": "Mi cuenta",
    "operation": "Operaciones",
    "operation-log-management": "Gestión de registros de operaciones",
    "operationLogManagement": "Gestión de registros de operaciones",
    "otaManagement": "Gestión OTA",
    "paymentMethodManagement": "Gestión de métodos de pago",
    "paymentProviderManagement": "Gestión de proveedores de pagos",
    "permissionGroupManagement": "Gestión de grupos de permisos",
    "platProductManagement": "Productos comerciales de plataforma",
    "platform": "Plataforma",
    "qrCodeTransferLog": "Registro de transferencia de código QR",
    "qrcodeStickerManagement": "Gestión de pegatinas QR",
    "refund-apply-management": "Gestión de solicitudes de reembolso",
    "report": "Informes",
    "roleManagement": "Gestión de roles",
    "salesAnalysis": "Análisis de ventas",
    "sales-by-machine": "Ventas por máquina",
    "salesByMachine": "Ventas por máquina",
    "setting": "Configuración",
    "system": "Sistema",
    "systemCenter": "Centro del sistema",
    "systemParameterManagement": "Gestión de parámetros del sistema",
    "systemUserManagement": "Gestión de usuarios",
    "transaction-order": "Informe de transacciones",
    "transactionReport": "Informe de transacciones",
    "transactions": "Transacciones",
    "userManagement": "Gestión de usuarios"
  },
  "setting": {
    "breadcrumb": "Migaja de pan",
    "breadcrumbIcon": "Icono de ruta de navegación",
    "clearAndReset": "Borrar caché y restablecer",
    "copy": "Copiar",
    "copyFailed": "Copia fallida",
    "copySuccess": "Copia exitosa",
    "dynamicRouter": "Enrutador dinámico",
    "fixedHeader": "Encabezado fijo",
    "fixedMenu": "Menú fijo",
    "footer": "Pie de página",
    "greyMode": "Modo gris",
    "hamburgerIcon": "Icono de hamburguesa",
    "headerTheme": "Tema de encabezado",
    "interfaceDisplay": "Pantalla de interfaz",
    "layout": "Disposición",
    "localeIcon": "Icono de configuración regional",
    "logo": "Logo",
    "menuTheme": "Tema del menú",
    "projectSetting": "Configuración del proyecto",
    "reExperienced": "Por favor cierre sesión e inicie sesión nuevamente para experimentar",
    "screenfullIcon": "Icono de pantalla completa",
    "serverDynamicRouter": "Enrutador dinámico del servidor",
    "sizeIcon": "Icono de tamaño",
    "systemTheme": "Tema del sistema",
    "tagsView": "Ver etiquetas",
    "tagsViewIcon": "Icono de vista de etiquetas",
    "theme": "Tema",
    "uniqueOpened": "Menú Acordeón"
  },
  "settingsManagement": {
    "operationLogManagement": {
      "businessType": {
        "add": "Agregar",
        "delete": "Borrar",
        "login": "Acceso",
        "logout": "Cerrar sesión",
        "unknown": "Desconocida",
        "update": "Actualizar"
      },
      "dialog": {
        "basicInfo": "Información básica",
        "requestInfo": "Solicitar información",
        "responseInfo": "Información de respuesta",
        "title": "Detalles del registro"
      },
      "logType": {
        "error": "Error",
        "info": "Información",
        "warning": "Advertencia"
      },
      "messages": {
        "loadDataFailed": "No se pudieron cargar los datos del registro"
      },
      "searchForm": {
        "browser": "Navegadora",
        "businessType": "Tipo de negocio",
        "dateRange": {
          "endPlaceholder": "Fecha de finalización",
          "label": "Rango de fechas",
          "separator": "a",
          "startPlaceholder": "Fecha de inicio"
        },
        "operateIp": "Operación IP",
        "operateName": "Operadora",
        "operateUrl": "URL de operación",
        "success": "Estado",
        "systemOs": "Sistema operativo",
        "title": "Título del registro"
      },
      "table": {
        "address": "DIRECCIÓN",
        "browser": "Navegadora",
        "businessType": "Tipo de negocio",
        "errorMsg": "Mensaje de error",
        "id": "IDENTIFICACIÓN",
        "logType": "Tipo de registro",
        "operId": "ID del operador",
        "operateIp": "Operación IP",
        "operateName": "Operadora",
        "operateUrl": "URL de operación",
        "operation": "Operación",
        "requestBody": "Cuerpo de solicitud",
        "requestMethod": "Método de solicitud",
        "requestParam": "Solicitar parámetros",
        "responseBody": "Cuerpo de respuesta",
        "sign": "Firma",
        "success": "Estado",
        "systemOs": "Sistema operativo",
        "time": "Tiempo de ejecución",
        "title": "Título del registro",
        "viewDetail": "Detalle"
      },
      "title": "Gestión de registros de operaciones"
    },
    "roleManagement": {
      "addPermissionGroup": "Agregar grupo de permisos",
      "addPermissionGroupFailed": "No se pudo agregar el grupo de permisos",
      "addPermissionGroupSuccess": "Grupo de permisos agregado exitosamente",
      "addRole": "Agregar rol",
      "addRoleDialog": "Agregar rol",
      "agencyManagement": "Gestión de jerarquía",
      "availablePermissionGroups": "Grupos de permisos disponibles",
      "branchAgent": "Agente de sucursal",
      "branchAgentAdmin": "Administradora de sucursal",
      "branchAgentAdminDesc": "Rol de administrador de agente de sucursal",
      "branchAgentOperator": "Operador de agente de sucursal",
      "branchAgentOperatorDesc": "Rol de operador de agente de sucursal",
      "buttonPermissions": "Permisos de botones",
      "buttons": "Botones",
      "confirmDeleteMessage": "¿Está seguro de eliminar el rol \"{name}\"?",
      "confirmDeleteRole": "Confirmar eliminación",
      "confirmDeleteRoleMessage": "¿Está seguro de eliminar el rol \"{roleName}\"?",
      "createFailed": "Error al crear",
      "createSuccess": "Crear exitosa",
      "currentMenu": "Menú actual",
      "customer": "Operadora",
      "customerAdmin": "Administradora de clientes",
      "customerAdminDesc": "Rol de administrador a nivel de cliente",
      "customerFinance": "Finanzas para clientes",
      "customerFinanceDesc": "Rol de finanzas del cliente",
      "customerOperator": "Operador de cliente",
      "customerOperatorDesc": "Rol de operador del cliente",
      "deleteFailed": "Error al eliminar",
      "deleteRole": "Eliminar rol",
      "deleteRoleFailed": "No se pudo eliminar el rol",
      "deleteRoleSuccess": "Rol eliminado exitosamente",
      "deleteSuccess": "Eliminar exitosa",
      "editRole": "Editar rol",
      "enterGroupName": "Introduzca el nombre del grupo",
      "enterGroupType": "Introduzca el tipo de grupo",
      "factory": "Fábrica",
      "factoryAdmin": "Administrador de fábrica",
      "factoryAdminDesc": "Rol de administrador a nivel de fábrica",
      "factoryAgent": "Agente de fábrica",
      "factoryAgentAdmin": "Administrador del agente de fábrica",
      "factoryAgentAdminDesc": "Rol de administrador del agente de fábrica",
      "factoryAgentOperator": "Operador de agente de fábrica",
      "factoryAgentOperatorDesc": "Rol de operador de agente de fábrica",
      "factoryInspector": "Inspectora de fabrica",
      "factoryInspectorDesc": "Papel de inspectora de fábrica",
      "factoryOperator": "Operadora de fabrica",
      "factoryOperatorDesc": "Rol de operador de fábrica",
      "groupCode": "Código de grupo",
      "groupName": "Nombre del grupo",
      "groupType": "Tipo de grupo",
      "help": {
        "parentRole": "Rol de los padres; Los nuevos roles heredan la jerarquía del padre seleccionado, disponible solo al crear roles.",
        "remark": "Notas adicionales para el rol, pueden describir responsabilidades o sugerencias de uso.",
        "roleName": "Nombre para mostrar del rol, utilizado para distinguir roles en el sistema, longitud recomendada de 2 a 100 caracteres",
        "roleType": "Categoría del rol, diferentes tipos determinan la jerarquía y el alcance del permiso"
      },
      "loadButtonDataError": "No se pudieron cargar los datos del botón",
      "loadMenuTreeError": "No se pudo cargar el árbol del menú",
      "loadParentRoleTreeError": "No se pudo cargar el árbol de roles principal",
      "loadPermissionGroupListError": "No se pudo cargar la lista de grupos de permisos",
      "loadRoleAuthError": "No se pudieron cargar los datos de autenticación de rol",
      "loadRolePermissionGroupsError": "No se pudieron cargar los grupos de permisos de roles",
      "loadRoleTreeError": "No se pudo cargar el árbol de roles",
      "loadingRoleTree": "Cargando árbol de roles...",
      "menuButtonPermissions": "Permisos de menú y botones",
      "menuPermissions": "Permisos de menú",
      "menus": "Menús",
      "noAvailablePermissionGroups": "No hay grupos de permisos disponibles",
      "noButtonsForMenu": "No hay permisos de botones para este menú",
      "noPermissionGroups": "No hay grupos de permisos configurados",
      "operationManagement": "Gestión de Operaciones",
      "parentRole": "Rol de padre",
      "permissionDetails": "Detalles del permiso",
      "permissionGroupAlreadyAssociated": "Grupo de permisos ya asociado",
      "permissionGroupList": "Lista de grupos de permisos",
      "permissionGroupPackages": "Paquetes de grupo de permisos",
      "permissionPreview": "Vista previa de permisos",
      "permissionSettings": "Configuración de permisos",
      "plat": "Plataforma",
      "platAdmin": "Administrador de plataforma",
      "platAdminDesc": "Rol de administrador a nivel de plataforma",
      "platAuditor": "Auditor de plataforma",
      "platAuditorDesc": "Rol de auditor de plataforma",
      "platSpecialist": "Especialista en Plataforma",
      "platSpecialistDesc": "Rol de especialista en plataforma",
      "pleaseSelectMenu": "Por favor seleccione un menú primero",
      "previewPermissions": "Permisos de vista previa",
      "remove": "Eliminar",
      "removePermissionGroupFailed": "No se pudo eliminar el grupo de permisos",
      "removePermissionGroupSuccess": "Grupo de permisos eliminado correctamente",
      "roleList": "Lista de roles",
      "roleManagement": "Gestión de roles",
      "roleName": "Nombre del rol",
      "roleType": "Tipo de rol",
      "savePermissions": "Guardar permisos",
      "savePermissionsFailed": "No se pudieron guardar los permisos",
      "savePermissionsSuccess": "Permisos guardados exitosamente",
      "selectPermissionGroup": "Seleccionar grupo de permisos",
      "selectRoleFirst": "Por favor seleccione un rol primero",
      "systemManagement": "Gestión del sistema",
      "title": "Gestión de roles",
      "updateFailed": "La actualización falló",
      "updateSuccess": "Actualización exitosa",
      "userManagement": "Gestión de usuarios",
      "viewPermissions": "Ver permisos"
    },
    "userManagement": {
      "addOperator": "Agregar usuario",
      "addOperatorDialog": "Agregar usuario",
      "backupEmail": "Correo electrónico de respaldo",
      "belongingOrg": "Organización",
      "companyName": "nombre de empresa",
      "confirmDeleteMessage": "¿Estás segura de eliminar la operadora \"{name}\"?",
      "confirmDisable": "Confirmar Desactivar",
      "confirmDisableMessage": "¿Estás segura de deshabilitar la operadora \"{name}\"?",
      "confirmEnable": "Confirmar habilitar",
      "confirmEnableMessage": "¿Estás segura de habilitar la operadora \"{name}\"?",
      "confirmPassword": "confirmar Contraseña",
      "confirmReset": "Confirmar reinicio",
      "createFailed": "Error al crear",
      "createSuccess": "Crear exitosa",
      "customer": "Operadora",
      "deleteFailed": "Error al eliminar",
      "deleteSuccess": "Eliminar exitosa",
      "disableSuccess": "Desactivar exitosa",
      "editOperator": "Editar usuario",
      "email": "Correo electrónico",
      "enableSuccess": "Habilitar exitosa",
      "factory": "Fábrica",
      "firstName": "Nombre de pila",
      "help": {
        "backupEmail": "Correo electrónico de respaldo utilizado cuando el buzón principal no está disponible",
        "belongingOrg": "Seleccione la organización a la que pertenece el operador; Define el alcance de los datos accesibles.",
        "companyName": "Nombre de la empresa o departamento del operador para una rápida identificación",
        "confirmPassword": "Confirme la nueva contraseña para asegurarse de que ambas entradas coincidan",
        "email": "Dirección de correo electrónico principal para notificaciones y recuperación de contraseña",
        "firstName": "Nombre del operador, utilizado para visualización y notificaciones",
        "lastName": "Apellido del operador, utilizado para comunicaciones formales.",
        "loginAccount": "Nombre de usuario de sesión utilizada para autenticación, admite letras, números, guiones bajos, longitud de 3 a 100 caracteres",
        "mobile": "Número de móvil principal para contacto y verificación de seguridad",
        "newPassword": "La nueva contraseña ingresada durante el restablecimiento debe cumplir con la regla de longitud mínima",
        "operatorName": "Nombre para mostrar del operador que se muestra en todo el sistema; recomendar 2-100 caracteres",
        "password": "Contraseña de inicio de sesión inicial al crear un usuario; recomienda entre 6 y 255 caracteres con tipos mixtos",
        "role": "Asignar una función para determinar los menús disponibles y los permisos de los botones.",
        "status": "Estado del operador; los usuarios discapacitados no pueden iniciar sesión ni realizar ninguna acción",
        "titleLabel": "Título o puesto laboral, por ejemplo, Gerente o Soporte"
      },
      "lastName": "Apellido",
      "loadOrgTreeFailed": "No se pudo cargar el árbol de la organización",
      "loadOperatorsFailed": "No se pudieron cargar los datos del operador",
      "loadingOrgTree": "Cargando árbol de organización...",
      "loginAccount": "Nombre de usuario",
      "mobile": "Móvil",
      "newPassword": "Nueva contraseña",
      "operationFailed": "Operación fallida",
      "operatorList": "Lista de usuarios",
      "operatorName": "Nombre del operador",
      "org": "Organización",
      "orgList": "Lista de organizaciones",
      "password": "Contraseña",
      "plat": "Plataforma",
      "resetPassword": "Restablecer contraseña",
      "resetPasswordDialog": "Restablecer contraseña",
      "resetPasswordFailed": "Error al restablecer la contraseña",
      "resetPasswordSuccess": "Restablecimiento de contraseña exitosa",
      "role": "Role",
      "searchOrg": "Organización de búsqueda...",
      "title": "Gestión de usuarios del sistema",
      "titleLabel": "Título",
      "updateFailed": "La actualización falló",
      "updateSuccess": "Actualización exitosa"
    }
  },
  "size": {
    "default": "Por defecto",
    "large": "Grande",
    "small": "Pequeña"
  },
  "systemManagement": {
    "countryManagement": {
      "addCountry": "Agregar país",
      "addCountryDialog": "Agregar país",
      "addFailed": "No se pudo agregar el país",
      "addSuccess": "País agregado exitosamente",
      "commaSeparator": "Coma (,)",
      "confirmDeleteMessage": "¿Estás segura de eliminar el país \"{countryName}\"?",
      "countryCode": "Código del país",
      "countryCodeLabel": "Código del país",
      "countryName": "Nombre del país",
      "countryNameLabel": "Nombre del país",
      "culture": "Cultura",
      "cultureCode": "Código de cultura",
      "cultureCodePlaceholder": "por ejemplo, zh-CN, en-US",
      "cultureCodeTip": "Código único para identificar esta configuración cultural.",
      "cultureLabel": "Cultura",
      "cultureOptions": {
        "ar_SA": "Arabia Saudita: formato de fecha DD/MM/AAAA, separador de números miles, símbolo de moneda ﷼",
        "de_DE": "Alemania: formato de fecha DD.MM.AAAA, separador de números miles, símbolo de moneda €",
        "en_GB": "Reino Unido: formato de fecha DD/MM/AAAA, separador de números de miles, símbolo de moneda £",
        "en_US": "Estados Unidos: formato de fecha MM/DD/AAAA, separador de números miles, símbolo de moneda $",
        "es_ES": "España: Formato de fecha DD/MM/AAAA, separador numérico miles, símbolo de moneda €",
        "fr_FR": "Francia: formato de fecha DD/MM/AAAA, separador de números miles, símbolo de moneda €",
        "hi_IN": "India: formato de fecha DD/MM/AAAA, separador de números de miles, símbolo de moneda ₹",
        "id_ID": "Indonesia: formato de fecha DD/MM/AAAA, separador de números de miles, símbolo de moneda Rp",
        "it_IT": "Italia: formato de fecha DD/MM/AAAA, separador de números miles, símbolo de moneda €",
        "ja_JP": "Japón: formato de fecha AAAA年MM月DD日, separador de números de miles, símbolo de moneda ¥",
        "ko_KR": "Corea del Sur: formato de fecha AAAA.MM.DD, separador de números de miles, símbolo de moneda ₩",
        "ms_MY": "Malasia: formato de fecha DD/MM/AAAA, separador de números miles, símbolo de moneda RM",
        "nl_NL": "Países Bajos: formato de fecha DD-MM-AAAA, separador de números miles, símbolo de moneda €",
        "pl_PL": "Polonia: formato de fecha DD.MM.AAAA, separador de números de miles, símbolo de moneda zł",
        "pt_PT": "Portugal: formato de fecha DD/MM/AAAA, separador de números miles, símbolo de moneda €",
        "ru_RU": "Rusia: formato de fecha DD.MM.AAAA, separador de números de miles, símbolo de moneda ₽",
        "th_TH": "Tailandia: formato de fecha DD/MM/AAAA, separador de números miles, símbolo de moneda ฿",
        "tr_TR": "Turquía: formato de fecha DD.MM.AAAA, separador de números de miles, símbolo de moneda ₺",
        "vi_VN": "Vietnam: formato de fecha DD/MM/AAAA, separador de números miles, símbolo de moneda ₫",
        "zh_CN": "China: formato de fecha AAAA-MM-DD, separador numérico de miles, símbolo de moneda ¥"
      },
      "currency": "Divisa",
      "currencyPosition": "Posición del símbolo de moneda",
      "currencyPositionAfter": "Después (100$)",
      "currencyPositionBefore": "Antes ($100)",
      "currencySymbol": "Símbolo de moneda",
      "dateFormat": "Formato de fecha",
      "dateSeparator": "Separador de fecha",
      "dateSeparatorPlaceholder": "p.ej., -, /, .",
      "dateTimeFormat": "Formato de fecha y hora",
      "defaultCurrencyCode": "Codigo de moneda predeterminado",
      "defaultTimezone": "Zona horaria predeterminada",
      "defaultTimezoneLabel": "Zona horaria predeterminada",
      "decimalPlaces": "Lugares decimales",
      "decimalSeparator": "Separador decimal",
      "deleteFailed": "No se pudo eliminar el país",
      "deleteSuccess": "País eliminado exitosamente",
      "dotSeparator": "Punto (.)",
      "dotSeparatorLabel": "Separadora de puntos",
      "editCountry": "Editar país",
      "editCountryDialog": "Editar país",
      "help": {
        "countryCode": "Código único de país/región, idealmente una norma ISO; no se puede cambiar después de la creación",
        "countryName": "Nombre para mostrar utilizado en la interfaz de usuario y la búsqueda, admite varios idiomas",
        "cultureCode": "Identificador cultural para reutilizar formatos de fecha, número y moneda, por ejemplo, zh-CN, en-US",
        "currency": "Moneda predeterminada; el sistema deriva el símbolo y el nombre según el código",
        "currencyPosition": "Posición del símbolo de la moneda, ya sea antes o después del monto.",
        "currencySymbol": "Símbolo de moneda, puede anular el valor predeterminado (por ejemplo, ¥, $)",
        "dateFormat": "Formato de fecha como AAAA-MM-DD o MM/DD/AAAA; afecta a todas las visualizaciones de fecha",
        "dateSeparator": "Separador utilizado entre los componentes de fecha, normalmente -, / o .",
        "defaultCurrencyCode": "Codigo de moneda predeterminado para el pais; puede seleccionarse de la lista o introducirse manualmente aunque no exista en la lista",
        "decimalPlaces": "Número predeterminado de decimales para cantidades o porcentajes",
        "decimalSeparator": "Separador decimal, normalmente punto (.) o coma (,)",
        "language": "El idioma asociado con este país afecta el idioma de visualización de la interfaz de usuario.",
        "remark": "Notas adicionales para el país, utilizadas para instrucciones o configuración especiales.",
        "textDirection": "Dirección de visualización del texto, ya sea de izquierda a derecha (ltr) o de derecha a izquierda (rtl)",
        "thousandsSeparator": "Separador de miles para agrupar números grandes",
        "timeFormat": "Formato de hora, admite visualización de 24 o 12 horas",
        "timeFormatTemplate": "Plantilla para visualización de la hora, por ejemplo, HH:mm:ss o h:mm:ss A",
        "timezone": "Zona horaria predeterminada para visualización y cálculos de hora; se puede seleccionar o ingresar manualmente"
      },
      "language": "Idioma",
      "languageLabel": "Idioma",
      "languageOptions": {
        "ar_SA": "العربية",
        "de_DE": "Alemana",
        "en_GB": "Inglés (Reino Unido)",
        "en_US": "Inglés (Estados Unidos)",
        "es_ES": "Española",
        "fr_FR": "Francesa",
        "hi_IN": "हिन्दी",
        "id_ID": "Bahasa Indonesia",
        "it_IT": "Italiana",
        "ja_JP": "日本語",
        "ko_KR": "한국어",
        "ms_MY": "Bahasa Melayu",
        "nl_NL": "Países Bajos",
        "pl_PL": "Polonia",
        "pt_PT": "portugués",
        "ru_RU": "Rusa",
        "th_TH": "ไทย",
        "tr_TR": "Turca",
        "vi_VN": "Tiếng Việt",
        "zh_CN": "中文（简体）"
      },
      "languageTimezone": "Idioma y zona horaria",
      "loadDataFailed": "No se pudieron cargar los datos del país",
      "numberCurrencyFormat": "Formato de número y moneda",
      "searchPlaceholder": "Buscar código o nombre de país...",
      "spaceSeparator": "Espacio ( )",
      "textDirection": "Dirección del texto",
      "textDirectionLtr": "De izquierda a derecha (litros)",
      "textDirectionRtl": "De derecha a izquierda (rtl)",
      "thousandsSeparator": "Separadora de miles",
      "timeFormat": "Formato de hora",
      "timeFormat12Hour": "12 horas (h:mm:ss A)",
      "timeFormat24Hour": "24 horas (HH:mm:ss)",
      "timeFormatTemplate": "Plantilla de formato de hora",
      "timezone": "Zona horaria",
      "timezoneLabel": "Zona horaria",
      "timezoneOptions": {
        "UTC+0": "UTC+0 (hora de Londres)",
        "UTC+1": "UTC+1 (hora de París)",
        "UTC+10": "UTC+10 (hora de Sídney)",
        "UTC+11": "UTC+11 (hora de las Islas Salomón)",
        "UTC+12": "UTC+12 (hora de Nueva Zelanda)",
        "UTC+2": "UTC+2 (hora de El Cairo)",
        "UTC+3": "UTC+3 (hora de Moscú)",
        "UTC+5.5": "UTC+5.5 (hora de Nueva Delhi)",
        "UTC+7": "UTC+7 (hora de Bangkok)",
        "UTC+8": "UTC+8 (hora de Pekín)",
        "UTC+9": "UTC+9 (hora de Tokio)",
        "UTC-10": "UTC-10 (hora de Hawái)",
        "UTC-11": "UTC-11 (hora de Samoa)",
        "UTC-3": "UTC-3 (hora de Brasil)",
        "UTC-4": "UTC-4 (hora de Venezuela)",
        "UTC-5": "UTC-5 (hora de Nueva York)",
        "UTC-6": "UTC-6 (hora de la Ciudad de México)",
        "UTC-7": "UTC-7 (hora de Denver)",
        "UTC-8": "UTC-8 (hora de Los Ángeles)",
        "UTC-9": "UTC-9 (hora de Alaska)"
      },
      "title": "Gestión País",
      "updateFailed": "No se pudo actualizar el país",
      "updateSuccess": "País actualizado exitosamente",
      "viewCountry": "Ver país"
    },
    "currencyManagement": {
      "addCurrency": "Agregar moneda",
      "addCurrencyDialog": "Agregar moneda",
      "addFailed": "No se pudo agregar moneda",
      "addSuccess": "Moneda agregada exitosamente",
      "confirmDeleteMessage": "¿Estás segura de eliminar la moneda \"{currencyName}\"?",
      "currencyCode": "Código de moneda",
      "currencyCodeLabel": "Código de moneda",
      "currencyNumericCode": "Código numérico de moneda",
      "currencyNumericCodeLabel": "Código numérico de moneda",
      "currencyName": "Nombre de la moneda",
      "currencyNameLabel": "Nombre de la moneda",
      "currencySymbol": "Símbolo de moneda",
      "currencySymbolLabel": "Símbolo de moneda",
      "decimalPlace": "Número decimal",
      "decimalPlaceLabel": "Número decimal",
      "deleteFailed": "No se pudo eliminar la moneda",
      "deleteSuccess": "Moneda eliminada exitosamente",
      "editCurrencyDialog": "Editar moneda",
      "help": {
        "currencyCode": "El código único para la moneda, que normalmente sigue el estándar ISO 4217 (por ejemplo, USD, EUR, CNY), no se puede modificar después de la creación, entre 1 y 50 caracteres.",
        "currencyNumericCode": "El código numérico de la moneda debe tener exactamente 3 dígitos y puede contener cualquier combinación de 0 a 9, como 156, 840 o 978.",
        "currencyName": "Nombre para mostrar de la moneda, utilizado para identificar la moneda en el sistema, como dólar estadounidense, euro, yuan chino, etc., entre 1 y 100 caracteres.",
        "currencySymbol": "Representación de símbolos de la moneda, como $, €, ¥, etc., utilizados para mostrar cantidades de moneda en la interfaz, hasta 20 caracteres",
        "decimalPlace": "Número decimal que se conserva al mostrar importes monetarios. Las opciones disponibles son 0, 1 y 2, y el valor predeterminado es 0"
      },
      "loadDataFailed": "No se pudieron cargar los datos de moneda",
      "searchPlaceholder": "Buscar código de moneda o nombre...",
      "title": "Gestión de divisas",
      "updateFailed": "No se pudo actualizar la moneda",
      "updateSuccess": "Moneda actualizada correctamente",
      "validation": {
        "currencyNumericCodeFormat": "El código numérico de moneda debe tener exactamente 3 dígitos"
      }
    },
    "deviceConfigTemplate": {
      "addDialogTitle": "Agregar plantilla de configuración del dispositivo",
      "addFailed": "Error al agregar",
      "addField": "Agregar campo",
      "addSuccess": "Añadir exitosa",
      "configJsonLabel": "Configurar JSON",
      "confirmDeleteMessage": "¿Está seguro de que desea eliminar esta plantilla de configuración del dispositivo?",
      "deleteFailed": "Error al eliminar",
      "deleteSuccess": "Eliminar exitosa",
      "disable": "Desactivar",
      "editDialogTitle": "Editar plantilla de configuración del dispositivo",
      "help": {
        "configJson": "Información de configuración de la plantilla de configuración del dispositivo, almacenada en formato JSON",
        "status": "Estado de la plantilla de configuración del dispositivo, normal o deshabilitado",
        "templateName": "Nombre para mostrar de la plantilla de configuración del dispositivo, utilizado para identificar la plantilla",
        "templateType": "Escriba el código de la plantilla de configuración del dispositivo, que se utiliza para vincular al módulo del dispositivo."
      },
      "jsonPreview": "Vista previa JSON",
      "keyName": "Nombre clave",
      "loadDataFailed": "No se pudieron cargar los datos",
      "loadDeviceModelFailed": "No se pudo cargar el modelo del dispositivo",
      "normal": "Normal",
      "searchByTemplateName": "Buscar por nombre de plantilla",
      "statusLabel": "Estado",
      "submitFailed": "Envío fallido",
      "templateName": "Nombre de la plantilla",
      "templateNameLabel": "Nombre de la plantilla",
      "templateNo": "Número de plantilla",
      "templateType": "Tipo de plantilla",
      "templateTypeLabel": "Tipo de plantilla",
      "title": "Plantilla de configuración del dispositivo",
      "updateFailed": "La actualización falló",
      "updateSuccess": "Actualización exitosa"
    },
    "deviceManagement": {
      "NetAccessError": "Error de acceso a la red",
      "NetAccessSuccess": "Primer éxito en el acceso a la red",
      "activePulse": "Pulso activo",
      "addConfig": "Agregar configuración",
      "addConfigDialog": "Agregar configuración",
      "addDevice": "Agregar dispositivo",
      "addMqtt": "Agregar MQTT",
      "addPaySource": "Agregar fuente de pago",
      "addSuccess": "Agregado exitosamente",
      "addWifi": "Añadir WIFI",
      "apn": "APN",
      "apnPlaceholder": "por ejemplo: cmnet",
      "appVersion": "Versión de la aplicación",
      "appVersionPlaceholder": "por ejemplo: 1.0.1",
      "assignedMachine": "Máquina asignada",
      "boundMachine": "Máquina asignada",
      "authPassword": "Contraseña",
      "authPasswordConfig": "Contraseña de administración",
      "baseConfigPush": "Empuje de configuración base",
      "batchAddDevices": "Agregar dispositivos por lotes",
      "batchCreateFailed": "Error al crear el lote",
      "batchCreateSuccess": "Creación por lotes exitosa",
      "belongingOrg": "Organización de pertenencia",
      "bindTime": "Fecha y hora de asignación",
      "bindMachine": "Asignar máquina",
      "bindMachineDialogTitle": "Asignar máquina",
      "bindMachineFailed": "No se pudo asignar la máquina",
      "bindMachineSuccess": "Máquina asignada correctamente",
      "bindingRecord": "Historial de asignaciones del dispositivo",
      "bluetooth": "bluetooth",
      "bootVersion": "Versión de arranque",
      "bootVersionPlaceholder": "por ejemplo: 1.0.22",
      "ccid": "ID de la tarjeta SIM del dispositivo",
      "cid": "CID",
      "coin": "Acuñar",
      "coinType": "Tipo de moneda",
      "collapse": "Colapsar",
      "commConfig": "Configuración de comunicación",
      "commandDescription": "Descripción del comando",
      "commandDescriptionLabel": "Descripción del comando",
      "commandDetail": "Detalle del comando",
      "commandGetConfig": "GetConfig - Obtener configuración del dispositivo",
      "commandLog": "Registro - Establecer nivel de registro",
      "commandReboot": "Reiniciar - Reiniciar el dispositivo",
      "commandRecord": "Registro de mando",
      "commandRestart": "Reiniciar - Reiniciar arranque",
      "commandSendFailed": "Error al enviar el comando",
      "commandSendRecord": "Comando Enviar Registro",
      "commandSendSuccess": "Comando enviado exitosamente",
      "commandSleep": "Dormir - Modo Dormir",
      "commandSyncTime": "Sincronizar hora - Sincronizar hora",
      "commandType": "Tipo de comando",
      "commandTypeLabel": "Tipo de comando",
      "communicationConfig": "Configuración de comunicación",
      "configContent": "Contenido de configuración",
      "configContentLabel": "Contenido de configuración",
      "configDownload": "Envío de configuración",
      "configEmptyTip": "La configuración del dispositivo está vacía, configúrela primero",
      "configManagement": "Gestión de configuración",
      "configTemplate": "Plantilla de configuración",
      "configType": "Tipo de configuración",
      "configTypeLabel": "Tipo de configuración",
      "confirmAction": "Confirmar acción",
      "confirmFetchLogMessage": "¿Seguro que quieres iniciar la obtención del log del dispositivo {sn}?",
      "confirmDeleteConfigMessage": "¿Estás segura de eliminar esta configuración?",
      "confirmDeleteMessage": "¿Estás segura de eliminar este dispositivo?",
      "confirmRebootMessage": "¿Estás segura de que quieres reiniciar este dispositivo?",
      "confirmRestartBootMessage": "¿Estás segura de que quieres reiniciar el arranque de este dispositivo?",
      "confirmUnbind": "Confirmar desasignación",
      "confirmUnbindMessage": "¿Está seguro de que desea desasignar el dispositivo {name}? Después de desasignarlo, puede transferir el dispositivo.",
      "creator": "Creadora",
      "deleteConfig": "Borrar",
      "deleteFailed": "Error al eliminar",
      "deleteSuccess": "Eliminado exitosamente",
      "deviceAlreadyBoundMessage": "Este dispositivo ya está asignado. ¿Desea desasignarlo y transferirlo?",
      "deviceCommandSend": "Envío de comando del dispositivo",
      "deviceConfig": "Configuración del dispositivo",
      "deviceCount": "Recuento de dispositivos",
      "deviceModel": "Modelo de dispositivo",
      "deviceModelPlaceholder": "por ejemplo: VP10",
      "deviceName": "Nombre del dispositivo",
      "deviceProvider": "Proveedor de dispositivos",
      "communicationModule": "Modulo de comunicacion",
      "deviceSN": "Número de serie del dispositivo",
      "deviceSNPlaceholder": "por ejemplo: VP10250907610001",
      "deviceSource": "Fuente del dispositivo",
      "deviceSourceInside": "Configuración interna",
      "deviceSourceOutside": "Dispositivo externo",
      "deviceInfoQr": "QR de información del dispositivo",
      "qrCodeDialogTitle": "Código QR de información del dispositivo",
      "qrCodeLink": "Enlace",
      "qrCodeImage": "Código QR",
      "qrCodeGenerating": "Generando código QR...",
      "noQrCodeLink": "No hay enlace para copiar",
      "copySuccess": "Copia exitosa",
      "copyFailed": "Error al copiar",
      "generateQrCodeLinkFailed": "Error al generar el enlace del código QR",
      "generateQrCodeImageFailed": "Error al generar la imagen del código QR",
      "deviceInfoQrNoDevice": "Guarde el dispositivo primero antes de generar el código QR",
      "deviceType": "Tipo de dispositivo",
      "device_batchRegister": "Dispositivo de registro de lotes",
      "dialnum": "Marcar número",
      "dialnumPlaceholder": "Predeterminado: *99***3#",
      "displaySupport": "Soporte de pantalla",
      "downloadConfig": "Configuración de envío",
      "downloadExample": "Descargar archivo de ejemplo",
      "downloadFailed": "Descarga fallida",
      "downloadSuccess": "Descargar exitosa",
      "downloadTip": "Descargue el archivo de ejemplo y complete la información del dispositivo según el formato, luego cárguelo",
      "downloadingExample": "Descargando archivo de ejemplo...",
      "duplicateConfigType": "Este dispositivo ya dispone de una configuración de este tipo. Cada tipo de configuración solo puede tener un registro",
      "editConfigDialog": "Editar configuración",
      "enterAuthPassword": "Ingrese la contraseña de administración",
      "enterCID": "Por favor ingrese CID",
      "enterDialNum": "Por favor ingrese el número de marcación",
      "enterMQTTIP": "Por favor ingrese la IP de MQTT",
      "enterMQTTPassword": "Por favor ingrese la contraseña MQTT",
      "enterMQTTUser": "Por favor ingrese el nombre de usuario de MQTT",
      "enterPIN": "Por favor ingrese el PIN",
      "enterPassword": "Por favor ingrese la contraseña",
      "enterTransferRemark": "Por favor ingresa el motivo de la transferencia",
      "enterUsername": "Por favor ingrese el nombre de usuario",
      "enterWifiPassword": "Por favor ingrese la contraseña de WiFi",
      "enterWifiPassword2": "Por favor ingresa la contraseña WiFi 2",
      "enterWifiSSID": "Por favor ingrese el SSID de WiFi",
      "enterWifiSSID2": "Por favor ingrese WiFi SSID 2",
      "exampleFile": "Ejemplo de importación por lotes de dispositivos.xlsx",
      "expand": "Expandir",
      "extendConfigPush": "Ampliar configuración push",
      "fourGConfig": "Configuración 4G",
      "fourGEnable": "4G habilitado",
      "fourGSupport": "Soporte 4G",
      "hardwareConfig": "Configuración de hardware",
      "hardwareSupportHint": "0 no admitido / >1 admitido",
      "help": {
        "apn": "APN (Nombre del punto de acceso) de la red 4G, utilizado para configurar el punto de acceso de la red 4G, como cmnet, 3gnet, etc.",
        "appVersion": "Versión de la aplicación reportada por el dispositivo, utilizada para mostrar la versión de software que ejecuta actualmente el terminal y no se puede modificar manualmente",
        "belongingOrg": "La organización a la que pertenece el dispositivo determina los permisos de acceso a los datos y el alcance de gestión del dispositivo.",
        "cid": "CID (Identificador de conexión) de la red 4G, rango 0-65535, utilizado para identificar la conexión de red 4G",
        "commandDescription": "Descripción del comando, utilizada para explicar el propósito o motivo del envío del comando, opcional",
        "commandType": "Tipo de comando a enviar, como reiniciar, suspender, hora de sincronización, configurar el nivel de registro, etc.",
        "configType": "Tipo de configuración, como configuración WiFi, configuración 4G, etc., cada tipo solo puede tener un registro de configuración",
        "communicationModule": "Modulo de comunicacion utilizado por el dispositivo, como 4G, 5G, WiFi o Ethernet, para identificar su capacidad de comunicacion",
        "deviceName": "Nombre para mostrar del dispositivo, utilizado para identificar el dispositivo en el sistema, admite la selección entre opciones preestablecidas o entrada personalizada",
        "deviceProvider": "Nombre del fabricante o proveedor del dispositivo, utilizado para identificar la fuente del dispositivo.",
        "deviceSource": "Tipo de fuente del dispositivo, configuración interna significa creada por el sistema internamente, dispositivo externo significa importado de sistemas externos",
        "deviceInfoQr": "Escanea el código QR para ver la página de información del dispositivo",
        "deviceType": "El código de tipo del dispositivo, determina las características funcionales y las reglas comerciales del dispositivo, debe seleccionarse de la lista de tipos de dispositivo.",
        "dialnum": "Marque el número de la red 4G, utilizado para establecer la conexión 4G, el valor predeterminado es *99#",
        "fourGEnable": "Conmutador de red 4G, cuando esté habilitado, el dispositivo usará una conexión de red 4G, cuando esté deshabilitado, la red WiFi se habilitará automáticamente",
        "moduleType": "El tipo de módulo de comunicación del dispositivo, como 4G, 5G, WiFi, Bluetooth, etc., determina el método de conexión de red del dispositivo.",
        "orgName": "La organización a la que pertenece el dispositivo determina los permisos de acceso a los datos y el alcance de gestión del dispositivo.",
        "password": "Contraseña de la red 4G, utilizada para la autenticación de la red 4G, de 8 a 16 caracteres",
        "pin": "Código PIN de la tarjeta SIM 4G, de 4 dígitos, utilizado para proteger la seguridad de la tarjeta SIM",
        "remark": "Información de comentarios del dispositivo, utilizada para registrar notas o comentarios adicionales.",
        "serialNumber": "El número de serie único del dispositivo, utilizado para identificar el dispositivo físico, no se puede modificar después de la creación.",
        "serialNumberPattern": "Sólo se permiten letras y números.",
        "status": "Estado de funcionamiento del dispositivo, prueba significa que el dispositivo está en la fase de prueba, activo significa que el dispositivo se puede utilizar normalmente, inactivo significa que el dispositivo está desactivado",
        "systemDeviceNo": "El número de dispositivo generado por el sistema, utilizado para la identificación y gestión interna del sistema, no se puede modificar manualmente",
        "toOrgLabel": "Organización de destino, el dispositivo se transferirá a esta organización",
        "transferReason": "Motivo de la transferencia, utilizado para explicar el motivo de la transferencia del dispositivo.",
        "username": "Nombre de usuario de la red 4G, utilizado para la autenticación de la red 4G, de 1 a 20 caracteres",
        "wifiEnable": "Cambio de red WiFi, cuando esté habilitado, el dispositivo usará la conexión de red WiFi, cuando esté deshabilitado, la red 4G se habilitará automáticamente",
        "wifiPassword": "Contraseña de la red WiFi, utilizada para conectarse a la red WiFi, 8-63 caracteres",
        "wifiSSID": "SSID (Identificador de conjunto de servicios) de la red WiFi, utilizado para identificar la red WiFi, de 1 a 32 caracteres, admite letras, números, guiones bajos y guiones."
      },
      "hwConfig": "Configuración de hardware",
      "inactivePulse": "Pulso inactivo",
      "lastOfflineTime": "Última vez sin conexión",
      "lastOnline": "Última vez en línea",
      "lastOnlineNetType": "Tipo de red de la última conexión",
      "lastOnlineWifiSsid": "SSID de WiFi de la última conexión",
      "lastOnlineTime": "Última vez en línea",
      "netStatus": "Estado de conexión",
      "loadBindingRecordsFailed": "No se pudo cargar el historial de asignaciones del dispositivo",
      "loadBindableMachinesFailed": "No se pudieron cargar las máquinas vinculables",
      "loadCommandLogsFailed": "No se pudieron cargar los registros de comandos",
      "loadConfigFailed": "No se pudo cargar la configuración",
      "loadConfigsFailed": "No se pudieron cargar las configuraciones del dispositivo",
      "loadDeviceDataFailed": "No se pudieron cargar los datos del dispositivo",
      "loadDeviceTypesFailed": "No se pudieron cargar los tipos de dispositivos",
      "loadOrgDevicesFailed": "No se pudieron cargar los dispositivos de la organización",
      "loadOrgTreeFailed": "No se pudo cargar el árbol de la organización",
      "loadingOrgDeviceTree": "Cargando árbol de organización y dispositivos...",
      "loadTemplatesFailed": "No se pudieron cargar las plantillas",
      "log": "Registro",
      "logClose": "Cerca",
      "logError": "Error",
      "logInfo": "Información",
      "logLevel": "Nivel de registro",
      "logLevelClose": "0 - Cerrar",
      "logLevelError": "4-Error",
      "logLevelInfo": "2 - Información",
      "logLevelTrace": "1 - Traza",
      "logLevelWarn": "3 - Advertir",
      "machineConfig": "Configuración de la máquina",
      "machineConfigAutoDispatch": "El protocolo PULSE se guardó correctamente, la configuración de la máquina se envió automáticamente",
      "machineConfigDispatchFailed": "El protocolo PULSE se guardó correctamente, pero falló el envío de la configuración de la máquina",
      "machineConfigExistsPrompt": "Ya existe una configuración de máquina (machine.cfg) para este dispositivo. ¿Actualizar la configuración existente?",
      "machineConfigUpdateSuccess": "Configuración de la máquina actualizada",
      "machineName": "Nombre de la máquina",
      "moduleType": "Tipo de módulo",
      "mqttConfig": "Configuración MQTT",
      "mqttIP": "Dirección IP",
      "mqttIPPlaceholder": "por ejemplo: 192.168.1.100",
      "mqttKeepalive": "Mantener vivo",
      "mqttKeepalivePlaceholder": "60",
      "mqttPassword": "Contraseña",
      "mqttPasswordPlaceholder": "8-16 caracteres",
      "mqttPort": "Puerto",
      "mqttPortPlaceholder": "1883",
      "mqttQos": "calidad de servicio",
      "mqttUser": "Nombre de usuario",
      "mqttUserPlaceholder": "1-20 caracteres",
      "netAccessStatus": "Primer estado de acceso a la red",
      "netAccessTime": "Primer tiempo de acceso a la red",
      "netCombineError": "Error de combinación neta",
      "netCombineStatus": "Estado de combinación neta",
      "netCombineSuccess": "Éxito neto de la combinación",
      "netCombineTime": "Tiempo neto de combinación",
      "noAvailableConfigType": "Todos los tipos de configuración ya existen para este dispositivo. No hay ningún tipo disponible para agregar",
      "noCommandHistory": "Sin historial de comandos",
      "noConfigHistory": "Sin historial de configuración",
      "noMachineConfig": "Sin configuración de máquina",
      "noTransferOrg": "Ninguna organización transferible",
      "notNetAccess": "Sin acceso a la red",
      "notNetCombine": "Combinación no neta",
      "notRegistered": "No registrada",
      "notSupport": "No es compatible",
      "notSupported": "No compatible",
      "off": "Apagada",
      "on": "En",
      "operateTime": "Tiempo de operación",
      "operatorName": "Nombre del operador",
      "optional": "Opcional",
      "orgDeviceTree": "Árbol de dispositivos de organización",
      "orgName": "Nombre de la organización",
      "osVersion": "Versión del sistema operativo",
      "osVersionPlaceholder": "por ejemplo: 5.0.21",
      "paper": "Papel",
      "parseTemplateFailed": "No se pudo analizar la plantilla",
      "password": "Contraseña",
      "passwordPlaceholder": "8-16 caracteres",
      "paySource": "Configuración de fuente de pago",
      "pin": "ALFILER",
      "pinPlaceholder": "4 dígitos",
      "pleaseSelectDevice": "Por favor seleccione un dispositivo primero",
      "port": "Puerto",
      "professionalMode": "Modo profesional",
      "pulseConfig": "Configuración de pulso",
      "pulseCount": "Conteo de pulsos",
      "pushConfig": "Configuración push",
      "pushConfigFailed": "Error al enviar la configuración",
      "pushConfigSuccess": "Configuración enviada correctamente",
      "qosAtLeastOnce": "1 - Al menos una vez",
      "qosAtMostOnce": "0 - Como máximo una vez",
      "qosExactlyOnce": "2 - Exactamente una vez",
      "reRegister": "Volver a registrarse",
      "reRegisterFailed": "Re-registro fallida",
      "reRegisterSuccess": "Volver a registrarse con éxito",
      "reboot": "Reiniciar",
      "rebootCommandSent": "El comando de reinicio se envió correctamente",
      "register": "Registro",
      "registerStatus": "Estado de registro",
      "registerSuccess": "Registro exitoso",
      "removeMqtt": "Eliminar",
      "removePaySource": "Eliminar",
      "removeWifi": "Eliminar",
      "requestJson": "Solicitar JSON",
      "requestParams": "Parámetros de solicitud",
      "requestParamsLabel": "Parámetros de solicitud",
      "responseJson": "JSON de respuesta",
      "responseResult": "Resultado de la respuesta",
      "restartBoot": "Reiniciar",
      "restartBootCommandSent": "El comando de reinicio se envió correctamente",
      "resultStatus": "Estado del resultado",
      "rssi": "Fuerza de la señal",
      "downloadDeviceLog": "Descargar log",
      "fetchLog": "Obtener log",
      "fetchLogFail": "Obtención fallida",
      "fetchLogMessage": "Resultado de obtención",
      "fetchLogRecord": "Registro de obtención de logs",
      "fetchLogDeviceOffline": "El dispositivo está fuera de línea y no se puede iniciar la obtención del log",
      "fetchLogStarted": "Se inició la obtención del log",
      "fetchLogStartFailed": "No se pudo iniciar la obtención del log",
      "fetchLogSuccess": "Correcto",
      "fetchLogSuccessMessage": "El log del dispositivo se obtuvo correctamente",
      "fetchLogReload": "Recargar",
      "fetchLogDownloading": "Obteniendo log...",
      "fetchLogDownloadFailed": "No se pudo descargar el log del dispositivo",
      "fetchLogDownloadMissing": "El archivo de log del dispositivo no existe o ya fue eliminado por vencimiento",
      "fetchLogUrlMissing": "Falta la URL de descarga del log",
      "fetchingLog": "Obteniendo log",
      "saveAuthConfigSuccess": "Contraseña de administración guardada exitosamente",
      "saveConfigFailed": "No se pudo guardar la configuración",
      "saveFailed": "Error al guardar",
      "saveFourGConfigSuccess": "Configuración 4G guardada exitosamente",
      "saveMqttConfigSuccess": "La configuración MQTT se guardó correctamente",
      "savePulseConfigSuccess": "La configuración de comunicación del terminal se guardó correctamente",
      "saveSuccess": "Guardado exitosamente",
      "saveWifiConfigSuccess": "La configuración WiFi se guardó correctamente.",
      "searchPlaceholder": "Buscar organización o dispositivo",
      "selectAPN": "Selecciona APN",
      "selectDateTime": "Seleccionar fecha hora",
      "selectDeviceFirst": "Por favor seleccione un dispositivo primero",
      "selectFile": "Seleccionar archivo",
      "selectFileFirst": "Por favor seleccione un archivo primero",
      "selectOrgFirst": "Por favor seleccione una organización primero",
      "selectOrgOrDevice": "Por favor seleccione el dispositivo",
      "selectQOS": "Seleccione QOS",
      "selectSourceOrgName": "Seleccione el nombre de la organización de origen",
      "selectTargetOrg": "Por favor seleccione la organización de destino",
      "selectTemplate": "Seleccionar plantilla",
      "send": "Enviar",
      "sendCommand": "Enviar comando",
      "sendCommandDialog": "Enviar comando",
      "sendCommandFailed": "No se pudo enviar el comando",
      "sendCommandSuccess": "Comando enviado exitosamente",
      "serialNumber": "Número de serie",
      "sleep": "Dormir",
      "sn": "SN",
      "sourceDeviceType": "Tipo de dispositivo fuente",
      "sourceOrgName": "Nombre de la organización de origen",
      "status": "Estado",
      "statusActive": "Activa",
      "statusTest": "Pruebas",
      "statusUnActive": "Inactiva",
      "supported": "Apoyado",
      "syncTime": "Hora de sincronización",
      "synchronizeTime": "Sincronizar hora",
      "sysConfig": "Configuración del sistema",
      "sysDeviceNo": "Número de dispositivo del sistema",
      "systemDeviceNo": "Número de dispositivo del sistema",
      "targetOrgName": "Nombre de la organización objetivo",
      "terminalCommunicationConfig": "Configuración de comunicación de terminales",
      "title": "Gestión de dispositivos",
      "toOrgLabel": "Organización objetivo",
      "transferDevice": "Transferir dispositivo",
      "transferFailed": "Error en la transferencia del dispositivo",
      "transferReason": "Motivo de la transferencia",
      "transferRecord": "Registro de transferencia",
      "transferSuccess": "Transferencia de dispositivo exitosa",
      "confirmUnbindMachineMessage": "¿Está seguro de que desea desasignar la máquina {name}?",
      "selectMachinePlaceholder": "Ingrese y seleccione una máquina",
      "unbindFailed": "No se pudo desasignar el dispositivo",
      "unbindMachine": "Desasignar máquina",
      "unbindSuccess": "Dispositivo desasignado correctamente",
      "unbindTime": "Fecha y hora de desasignación",
      "unitValue": "Valor unitario",
      "updateSuccess": "Actualizado exitosamente",
      "upload": "Subir",
      "uploadExcelOnly": "¡Solo se permiten archivos Excel o CSV!",
      "uploadFile": "Cargar archivo",
      "uploadFileSizeLimit": "¡El tamaño del archivo no puede exceder los 2 MB!",
      "uploadTip": "Cargue archivos en formato Excel o CSV, cuyo tamaño no exceda los 2 MB",
      "viewMachine": "Ver máquina",
      "viewMachinePending": "Ver el detalle de la máquina aún no está implementado",
      "username": "Nombre de usuario",
      "usernamePlaceholder": "1-20 caracteres",
      "vcoin": "moneda virtual",
      "wifiConfig": "Configuración Wi-Fi",
      "wifiEnable": "WiFi habilitado",
      "wifiPassword": "Contraseña WiFi",
      "wifiPassword2": "Contraseña WiFi 2",
      "wifiPasswordPlaceholder": "8-63 caracteres",
      "wifiSSID": "Wi-Fi SSID",
      "wifiSSID2": "Wi-Fi SSID 2",
      "wifiSSIDPlaceholder": "1-32 caracteres, letras/números/guiones bajos/guiones",
      "wifiSupport": "Soporte WiFi",
      "wlBand": "Banda 4G",
      "wlStandard": "Estándar 4G"
    },
    "deviceModelConfig": {
      "addDialogTitle": "Agregar configuración del módulo de dispositivo",
      "addFailed": "Error al agregar",
      "addKeyValue": "Agregar par clave-valor",
      "addSuccess": "Añadir exitosa",
      "configJson": "Configurar JSON",
      "configJsonLabel": "Configurar JSON",
      "confirmDeleteMessage": "¿Está seguro de que desea eliminar la configuración de este módulo de dispositivo?",
      "deleteFailed": "Error al eliminar",
      "deleteSuccess": "Eliminar exitosa",
      "description": "Descripción",
      "editDialogTitle": "Editar la configuración del módulo del dispositivo",
      "exampleValue": "Valor de ejemplo",
      "help": {
        "configJson": "Información de configuración del módulo del dispositivo, almacenada en formato JSON",
        "modelName": "Nombre para mostrar del módulo de dispositivo, utilizado para identificar el módulo de dispositivo",
        "modelType": "Código de tipo del módulo del dispositivo, utilizado para distinguir diferentes tipos de dispositivos"
      },
      "jsonPreview": "Vista previa JSON",
      "keyName": "Nombre clave",
      "loadDataFailed": "No se pudieron cargar los datos",
      "modelName": "Nombre del módulo",
      "modelNameLabel": "Nombre del módulo",
      "modelType": "Tipo de módulo",
      "modelTypeLabel": "Tipo de módulo",
      "submitFailed": "Envío fallido",
      "title": "Configuración del módulo de dispositivo",
      "updateFailed": "La actualización falló",
      "updateSuccess": "Actualización exitosa"
    },
    "deviceTagManagement": {
      "addFailed": "No se pudo agregar la etiqueta",
      "addSuccess": "Etiqueta agregada exitosamente",
      "addTag": "Agregar etiqueta",
      "confirmDeleteMessage": "¿Estás segura de eliminar la etiqueta \"{tagName}\"?",
      "deleteFailed": "No se pudo eliminar la etiqueta",
      "deleteSuccess": "Etiqueta eliminada correctamente",
      "editTag": "Editar etiqueta",
      "help": {
        "tagName": "Nombre de la etiqueta del dispositivo; use palabras concisas para describir el propósito de la etiqueta, hasta 100 caracteres"
      },
      "loadDataFailed": "No se pudieron cargar los datos de la etiqueta",
      "orgId": "ID de organización",
      "tagName": "Nombre de etiqueta",
      "tagNameLabel": "Nombre de etiqueta",
      "title": "Etiquetas de la máquina",
      "updateFailed": "No se pudo actualizar la etiqueta",
      "updateSuccess": "Etiqueta actualizada correctamente"
    },
    "deviceTransferLog": {
      "batchNo": "Transferir lote no",
      "endTime": "Hora de finalización",
      "loadDataFailed": "No se pudieron cargar los datos",
      "noErrorMessage": "Ningún mensaje de error",
      "orgChange": "Registro de cambios de organización",
      "selectEndTime": "Seleccionar hora de finalización",
      "selectStartTime": "Seleccionar hora de inicio",
      "startTime": "Hora de inicio",
      "transferReason": "Motivo de la transferencia",
      "transferResult": "Resultado de la transferencia"
    },
    "otaManagement": {
      "title": "Gestión de archivos OTA",
      "uploadNewFile": "Subir nuevo archivo",
      "index": "Índice",
      "fileName": "Nombre del archivo",
      "fileSize": "Tamaño del archivo",
      "uploadTime": "Hora de carga",
      "deviceList": "Lista de dispositivos",
      "selectedFile": "Archivo seleccionado:",
      "noFileSelected": "No se ha seleccionado ningún archivo para actualizar",
      "deviceSN": "SN del dispositivo",
      "netStatus": "Estado de la red",
      "orgName": "Nombre de la organización",
      "selectOrgName": "Seleccionar organización",
      "updateFile": "Actualizar archivo",
      "uploadSuccess": "Carga exitosa",
      "uploadFailed": "Error al cargar",
      "onlySupport": "Solo se admiten los formatos .rbl, .tpk y .p1z",
      "dangerousFileNotAllowed": "No se permiten formatos de archivo peligrosos, como ejecutables",
      "getFileListFailed": "No se pudo obtener la lista de archivos",
      "deleteSuccess": "Eliminación exitosa",
      "deleteFailed": "Error al eliminar",
      "getDeviceListFailed": "No se pudo obtener la lista de dispositivos",
      "pleaseSelectFileFirst": "Seleccione primero un archivo OTA",
      "updateCommandSent": "Comando de actualización enviado",
      "updateFailed": "Actualización fallida",
      "batchUpdate": "Actualización masiva",
      "batchUpdateConfirm": "¿Está seguro de que desea actualizar masivamente estos {count} dispositivos?",
      "selectedDeviceCount": "{count} dispositivos seleccionados",
      "pleaseSelectAtLeastOneDevice": "Seleccione al menos un dispositivo",
      "batchUpdateMaxDevices": "Puede seleccionar hasta 10 dispositivos para la actualización masiva",
      "batchUpdateSameDeviceType": "Los dispositivos seleccionados deben tener el mismo tipo de dispositivo",
      "batchUpdateOnlineOnly": "Solo los dispositivos en línea pueden participar en la actualización masiva",
      "batchUpdateSubmitted": "Solicitudes de actualización enviadas para {count} dispositivos",
      "batchUpdatePartial": "La entrega fue parcial, {submitted} correctas y {failed} fallidas",
      "batchUpdateAllFailed": "La actualización masiva no pudo enviarse",
      "batchUpdateFailed": "La actualización masiva falló",
      "all": "Todos",
      "noPermissionUpload": "Permiso para cargar archivos OTA",
      "noPermissionDelete": "Permiso para eliminar archivos OTA",
      "noPermissionUpdate": "Permiso para actualizar archivos OTA",
      "updateConfirm": "¿Está seguro de que desea enviar un comando de actualización a este dispositivo?",
      "updateTypeTitle": "Seleccionar tipo de actualización",
      "updateTypeApp": "App",
      "updateTypeWifiFw": "Paquete de firmware WiFi",
      "wifiFirmwareBinOnly": "El paquete de firmware WiFi debe ser un archivo .bin",
      "refresh": "Actualizar",
      "fileSizeExceed": "El tamaño del archivo no puede superar los {size}MB",
      "updateLog": "Registro de actualización",
      "updateLogList": "Lista de registros de actualización del dispositivo",
      "updateStatus": "Estado",
      "updateMessage": "Mensaje",
      "updateTime": "Hora",
      "success": "existosa",
      "fail": "fallo",
      "updating": "actualizando",
      "getLogFailed": "No se pudo obtener el registro"
    },
    "deviceTypeManagement": {
      "addFailed": "No se pudo agregar el tipo de dispositivo",
      "addSuccess": "Tipo de dispositivo agregado exitosamente",
      "addTypeDialog": "Agregar tipo de dispositivo",
      "confirmDeleteMessage": "¿Estás segura de eliminar el tipo \"{typeName}\"?",
      "deleteFailed": "No se pudo eliminar el tipo de dispositivo",
      "deleteSuccess": "Tipo de dispositivo eliminado correctamente",
      "editTypeDialog": "Editar tipo de dispositivo",
      "help": {
        "remark": "Información de comentarios del tipo de dispositivo, se puede utilizar para registrar las características, propósito o instrucciones de uso del tipo, máximo 255 caracteres.",
        "typeCode": "Código único para el tipo de dispositivo, utilizado para identificar el tipo de dispositivo en el sistema, se recomienda utilizar combinaciones alfanuméricas, de 1 a 100 caracteres",
        "typeName": "Nombre para mostrar del tipo de dispositivo, utilizado para distinguir diferentes tipos de dispositivos en el sistema, de 1 a 100 caracteres"
      },
      "loadDataFailed": "No se pudieron cargar los datos del tipo de dispositivo",
      "title": "Gestión de tipos de dispositivos",
      "typeCode": "Código de tipo",
      "typeCodeLabel": "Código de tipo",
      "typeName": "Tipo Nombre",
      "typeNameLabel": "Tipo Nombre",
      "updateFailed": "No se pudo actualizar el tipo de dispositivo",
      "updateSuccess": "Tipo de dispositivo actualizado correctamente"
    },
    "dictionaryManagement": {
      "addDictDialog": "Agregar categoría de diccionario",
      "addFailed": "No se pudo agregar",
      "addItemDialog": "Agregar elemento de diccionario",
      "addSuccess": "Agregado exitosamente",
      "confirmDeleteDictMessage": "¿Estás segura de eliminar la categoría de diccionario \"{dictText}\"?",
      "confirmDeleteItemMessage": "¿Estás segura de eliminar el elemento del diccionario \"{itemText}\"?",
      "deleteFailed": "No se pudo eliminar",
      "deleteFailedMissingId": "Error al eliminar: falta ID",
      "deleteSuccess": "Eliminado exitosamente",
      "dictCategory": "Categoría del diccionario",
      "dictCode": "Código de diccionario",
      "dictCodeLabel": "Código de diccionario",
      "dictItem": "Elemento del diccionario",
      "dictText": "Nombre del diccionario",
      "dictTextLabel": "Nombre del diccionario",
      "editDictDialog": "Editar categoría del diccionario",
      "editItemDialog": "Editar elemento del diccionario",
      "help": {
        "dictCode": "El código único para la categoría del diccionario, que se utiliza para identificar la categoría del diccionario en el sistema, no se puede modificar después de la creación, entre 1 y 60 caracteres.",
        "dictText": "Nombre para mostrar de la categoría del diccionario, utilizado para identificar y mostrar la categoría del diccionario en el sistema, de 1 a 60 caracteres",
        "itemCode": "El código único para el elemento del diccionario, que se utiliza para identificar el elemento del diccionario en el sistema, no se puede modificar después de la creación, entre 1 y 60 caracteres.",
        "itemText": "Nombre para mostrar del elemento del diccionario, utilizado para identificar y mostrar el elemento del diccionario en el sistema, de 1 a 60 caracteres"
      },
      "itemCode": "Código de artículo",
      "itemCodeLabel": "Código de artículo",
      "itemText": "Nombre del artículo",
      "itemTextLabel": "Nombre del artículo",
      "loadDictDataFailed": "No se pudieron cargar los datos de la categoría del diccionario",
      "loadItemDataFailed": "No se pudieron cargar los datos del elemento del diccionario",
      "title": "Gestión de diccionarios",
      "updateFailed": "No se pudo actualizar",
      "updateSuccess": "Actualizado exitosamente"
    },
    "machineTypeManagement": {
      "addConfigItem": "Agregar elemento de configuración",
      "addConfigSection": "Agregar sección de configuración",
      "addFailed": "No se pudo agregar el tipo de máquina",
      "addSuccess": "Tipo de máquina agregado exitosamente",
      "addTypeDialog": "Agregar tipo de máquina",
      "config": "configuración",
      "configItems": "Elementos de configuración",
      "configSection": "Sección de configuración",
      "configSectionLabel": "Sección de configuración",
      "confirmDeleteMessage": "¿Estás segura de eliminar el tipo \"{typeName}\"?",
      "deleteFailed": "No se pudo eliminar el tipo de máquina",
      "deleteFailedMissingId": "Error al eliminar: falta ID",
      "deleteSuccess": "Tipo de máquina eliminado correctamente",
      "editTypeDialog": "Editar tipo de máquina",
      "enterResourceUrl": "Por favor ingrese la URL del recurso",
      "help": {
        "configSection": "Seleccione la sección de configuración para agrupar elementos de configuración",
        "key": "La clave del elemento de configuración, utilizada para identificar la configuración en el sistema.",
        "remark": "Se pueden utilizar notas adicionales para el tipo de máquina para registrar características o descripciones.",
        "typeCode": "El código único para el tipo de máquina, usa letras o números, no se puede cambiar después de la creación",
        "typeName": "Nombre para mostrar del tipo de máquina, utilizado para distinguir diferentes tipos en el sistema.",
        "value": "El valor del elemento de configuración, correspondiente a la configuración específica de la clave."
      },
      "keyLabel": "Llave",
      "loadDataFailed": "No se pudieron cargar los datos del tipo de máquina",
      "machineSection": "Configuración de la máquina",
      "removeConfigItem": "Eliminar elemento de configuración",
      "title": "Gestión de tipos de máquinas",
      "typeCode": "Código de tipo",
      "typeCodeLabel": "Código de tipo",
      "typeName": "Tipo Nombre",
      "typeNameLabel": "Tipo Nombre",
      "updateFailed": "No se pudo actualizar el tipo de máquina",
      "updateSuccess": "Tipo de máquina actualizado exitosamente",
      "valueLabel": "Valor",
      "viewConfig": "Ver configuración"
    },
    "mediaResourceManagement": {
      "browserNotSupportVideo": "Su navegador no soporta la reproducción de vídeo",
      "clickUploadOrDrag": "Haga clic para cargar o arrastrar el archivo a esta área",
      "confirmDeleteMessage": "¿Está seguro de eliminar el recurso multimedia \"{resourceName}\"?",
      "deleteFailed": "Error al eliminar",
      "deleteSuccess": "Eliminar exitosa",
      "editMediaResource": "Editar recurso multimedia",
      "enterResourceUrl": "Por favor ingrese la URL del recurso",
      "help": {
        "resourceDescription": "Información descriptiva del recurso, utilizada para explicar el propósito, contenido o notas del recurso, máximo 255 caracteres",
        "resourceName": "Nombre para mostrar del recurso, utilizado para identificar y mostrar el recurso en el sistema, hasta 100 caracteres",
        "resourceType": "Tipo de recurso, seleccione imagen o video, diferentes tipos admiten diferentes formatos de archivo y límites de tamaño",
        "resourceUrl": "La dirección URL del recurso se puede generar automáticamente cargando un archivo o ingresando manualmente un enlace URL externo, máximo 255 caracteres."
      },
      "image": "Imagen",
      "imageLoadFailed": "Error al cargar la imagen",
      "imagePreview": "Vista previa de imagen",
      "imageSizeLimit": "¡El tamaño de la imagen no puede exceder 1 MB!",
      "loadDataFailed": "No se pudieron cargar los datos",
      "loadFailed": "Error de carga",
      "noDescription": "Sin descripción",
      "noPreview": "Sin vista previa",
      "onlyImageFiles": "¡Solo se pueden cargar archivos de imágenes!",
      "onlyVideoFiles": "¡Solo se pueden cargar archivos de video!",
      "orInputUrl": "O ingrese la URL:",
      "preview": "Avance",
      "resourceDescription": "Descripción del recurso",
      "resourceName": "Nombre del recurso",
      "resourceType": "Tipo de recurso",
      "resourceUpload": "Carga de recursos",
      "resourceUrl": "URL del recurso",
      "searchPlaceholder": "Buscar nombre o descripción del recurso...",
      "selectResourceType": "Seleccionar tipo de recurso",
      "supportFormats": "Admite el formato {formats}, el tamaño del archivo no excede {size}",
      "title": "Gestión de recursos multimedia",
      "unknownResourceType": "Tipo de recurso desconocido",
      "updateSuccess": "Actualización exitosa",
      "uploadFailed": "La carga falló, por favor inténtalo de nuevo.",
      "uploadFailedMessage": "Error en la carga de {type}",
      "uploadMediaResource": "Cargar recurso multimedia",
      "uploadResource": "Cargar recurso",
      "uploadSuccess": "Subida exitosa",
      "uploadSuccessMessage": "{type} carga exitosa",
      "video": "Video",
      "videoPreview": "Vista previa de vídeo",
      "videoSizeLimit": "¡El tamaño del video no puede exceder los 100 MB!",
      "videoUrl": "URL del vídeo"
    },
    "menuManagement": {
      "actionUrlLabel": "Solicitar URL",
      "addButton": "Agregar botón",
      "addButtonTitle": "Agregar botón",
      "addMenu": "Agregar menú",
      "addMenuTitle": "Agregar menú",
      "belongMenu": "Pertenece al menú",
      "buttonCode": "Código de botón",
      "buttonCodeLabel": "Código de botón",
      "buttonList": "Lista de botones",
      "buttonName": "Nombre del botón",
      "buttonNameLabel": "Nombre del botón",
      "createFailed": "Error al crear",
      "createSuccess": "Crear exitosa",
      "deleteButtonConfirm": "¿Estás segura de eliminar el botón \"{buttonName}\"?",
      "deleteFailed": "Error al eliminar",
      "deleteFailedMissingId": "Eliminar ID de menú fallido y faltante",
      "deleteMenuConfirm": "¿Estás segura de eliminar el menú \"{menuName}\"?",
      "deleteSuccess": "Eliminar exitosa",
      "deleteTitle": "Confirmar eliminación",
      "editButtonTitle": "Botón Editar",
      "editMenuTitle": "Editar menú",
      "help": {
        "actionUrl": "Dirección de la interfaz API de backend correspondiente al botón, utilizada para ejecutar la operación correspondiente al botón",
        "belongMenu": "Menú al que pertenece el botón, el botón se mostrará debajo de este menú, utilizado para la gestión de permisos y la organización de funciones.",
        "buttonCode": "Código único para el botón, utilizado para control de permisos y llamadas API, se recomienda utilizar nombres de subrayado, de 2 a 128 caracteres",
        "buttonName": "Nombre para mostrar del botón, utilizado para identificar y mostrar el botón en el sistema, de 2 a 60 caracteres",
        "isHidden": "Si el menú está oculto en la barra de navegación, aún se puede acceder al menú oculto a través de la URL, pero no se mostrará en la barra de navegación.",
        "menuCode": "Código único para el menú, utilizado para identificar el menú en el sistema, se recomienda utilizar combinaciones alfanuméricas y de subrayado, de 2 a 60 caracteres",
        "menuIcon": "Identificador de ícono del menú, usando nombres de íconos de la biblioteca de íconos, como ep:menu, ep:home, etc.",
        "menuName": "Nombre para mostrar del menú, utilizado para mostrar en la barra de navegación y el sistema, de 2 a 60 caracteres",
        "menuUrl": "La ruta de ruta correspondiente al menú, utilizada para la navegación de ruta frontal, debe comenzar con /",
        "parentMenu": "Menú principal del menú, utilizado para construir la estructura jerárquica de los menús, el menú raíz no tiene menú principal",
        "remarks": "Comentarios información del menú, utilizada para registrar el propósito, descripción u otras notas del menú.",
        "sort": "Ordenar transacción del menú, los valores más pequeños aparecen primero, rango 0-9999",
        "status": "Estado del menú, el menú habilitado se mostrará en el sistema, el menú deshabilitado será invisible"
      },
      "hidden": "Oculta",
      "isHidden": "esta escondido",
      "loadButtonDataFailed": "No se pudieron cargar los datos del botón",
      "loadMenuDataFailed": "No se pudieron cargar los datos del menú",
      "menuCode": "Código de menú",
      "menuDisabled": "Desactivada",
      "menuEnabled": "Activada",
      "menuIcon": "Icono de menú",
      "menuList": "Lista de menú",
      "menuName": "Nombre del menú",
      "menuUrl": "URL del menú",
      "notHidden": "No oculto",
      "parentMenu": "Menú principal",
      "requestUrl": "Solicitar URL",
      "searchMenu": "Menú de búsqueda...",
      "selectMenuFirst": "Por favor seleccione un menú primero",
      "sort": "Clasificar",
      "title": "Gestión del menú del sistema",
      "updateFailed": "La actualización falló",
      "updateSuccess": "Actualización exitosa"
    },
    "orgTagManagement": {
      "addDialogTitle": "Agregar etiqueta de organización",
      "addTag": "Agregar etiqueta",
      "deleteConfirm": "¿Estás segura de eliminar la etiqueta \"{tagName}\"?",
      "deleteTitle": "Confirmar eliminación",
      "editDialogTitle": "Editar etiqueta de organización",
      "editTag": "Editar etiqueta",
      "searchPlaceholder": "Buscar nombre de etiqueta...",
      "tagName": "Nombre de etiqueta",
      "tagNameLabel": "Nombre de etiqueta",
      "title": "Gestión de etiquetas de organización"
    },
    "paymentMethodManagement": {
      "addMethod": "Agregar método de pago",
      "addMethodDialog": "Agregar método de pago",
      "addSuccess": "Método de pago agregado exitosamente",
      "allChannels": "Todos los canales",
      "associate": "Asociada",
      "associateFailed": "Asociación fallida",
      "associateSuccess": "Asociación exitosa",
      "associatedChannelProducts": "Productos de canales asociados",
      "availableProducts": "Productos de canal disponibles",
      "clickUploadLogo": "Haga clic para cargar el logotipo",
      "confirmDeleteMethodMessage": "¿Está seguro de eliminar el método de pago \"{methodName}\"? También se eliminarán todas las asociaciones.",
      "currentMethod": "Método de pago actual",
      "deleteFailed": "No se pudo eliminar el método de pago",
      "deleteSuccess": "Método de pago eliminado exitosamente",
      "editMethodDialog": "Editar método de pago",
      "fixedRate": "Tasa Fija",
      "help": {
        "methodCode": "Código único para el método de pago, utilizado para identificar el método de pago en el sistema, se recomienda utilizar combinaciones alfanuméricas y de subrayado, máximo 50 caracteres",
        "methodLogo": "Ícono del logotipo del método de pago, admite la carga de archivos de imágenes o el uso de identificadores de íconos de la biblioteca de íconos (como ep:tarjeta de crédito), tamaño recomendado 40x40px, tamaño de imagen que no exceda 1MB",
        "methodName": "Nombre para mostrar del método de pago, utilizado para identificar y mostrar el método de pago en el sistema, como Alipay, WeChat Pay, etc., máximo 100 caracteres."
      },
      "imageSizeLimit": "¡El tamaño de la imagen no puede exceder 1 MB!",
      "loadDataFailed": "No se pudieron cargar los datos del método de pago",
      "logoCleared": "Logotipo borrado",
      "logoHint": "Admite carga de archivos de imagen, tamaño recomendado: 40x40px",
      "logoLoadFailed": "Error al cargar el logotipo",
      "logoUploadFailed": "Error al cargar el logotipo",
      "logoUploadSuccess": "Carga del logotipo exitosa",
      "manageProducts": "Administrar productos",
      "manageProductsDialog": "Gestionar productos asociados",
      "methodCode": "Código de método de pago",
      "methodLogo": "Logotipo del método de pago",
      "methodName": "Nombre del método de pago",
      "noAssociations": "No hay productos de canal asociados, haga clic en \"Administrar productos\" para asociar",
      "noMethodsDescription": "No hay datos de método de pago disponibles, haga clic en el botón \"Agregar\" para crear el primer método de pago",
      "onlyImageFiles": "¡Solo se pueden cargar archivos de imágenes!",
      "percentageRate": "Tasa Porcentual",
      "removeAssociation": "Eliminar asociación",
      "removeAssociationFailed": "No se pudo eliminar la asociación",
      "removeAssociationSuccess": "Eliminar asociación exitosamente",
      "searchPlaceholder": "Buscar nombre o código del método de pago...",
      "selectChannelFilter": "Seleccionar filtro de canal",
      "title": "Gestión de métodos de pago",
      "updateSuccess": "Método de pago actualizado exitosamente"
    },
    "paymentProviderManagement": {
      "addChannel": "Agregar proveedor",
      "addChannelDialog": "Agregar proveedor de pago",
      "addConfigItem": "Agregar elemento de configuración",
      "addProduct": "Agregar producto",
      "addProductDialog": "Agregar producto del proveedor",
      "addRequiredParam": "Agregar parámetro requerido",
      "addRequiredParamHint": "Haga clic en \"Agregar parámetro requerido\" para comenzar a configurar",
      "addSuccess": "Agregado exitosamente",
      "belongingChannel": "Proveedor Perteneciente",
      "booleanType": "Booleano",
      "channelCode": "Código de proveedor",
      "channelConfig": "Configuración del proveedor",
      "channelConfigLabel": "Configuración del proveedor",
      "channelLogo": "Logotipo del proveedor",
      "channelName": "Nombre del proveedor",
      "channelProducts": "Productos del proveedor",
      "clickAddConfig": "Haga clic en \"Agregar elemento de configuración\" para comenzar a configurar",
      "clickUploadLogo": "Haga clic para cargar el logotipo",
      "completeConfigItems": "Por favor complete todos los elementos de configuración",
      "configAction": "Acción",
      "configDetailDialog": "Detalles de configuración del proveedor",
      "configItemManagement": "Gestión de elementos de configuración",
      "configKey": "Clave de configuración",
      "configKeyCannotBeRepeated": "La clave de configuración no se puede repetir",
      "configType": "Tipo",
      "configValue": "Valor de configuración",
      "confirmDeleteChannelMessage": "¿Está seguro de eliminar el canal de pago \"{channelName}\"? Todos los productos de este canal también se eliminarán.",
      "confirmDeleteProductMessage": "¿Estás segura de eliminar el producto \"{productName}\"?",
      "deleteFailed": "Error al eliminar",
      "deleteProductFailed": "No se pudo eliminar el producto",
      "deleteSuccess": "Eliminado exitosamente",
      "editChannel": "Editar proveedor",
      "editChannelDialog": "Editar proveedor de pago",
      "editProductDialog": "Editar producto del proveedor",
      "emailType": "Correo electrónico",
      "fixedAmountRate": "Tasa de cantidad fija",
      "fixedRate": "Tasa Fija",
      "fixedRateHint": "Tasa de importe fijo, por ejemplo: 0,50 significa 0,50 yuanes por transacción",
      "formMode": "Modo formulario",
      "formatJson": "Formato JSON",
      "help": {
        "channelCode": "Código único para el proveedor de pago, utilizado para identificar al proveedor en el sistema, se recomienda utilizar combinaciones alfanuméricas y de subrayado, máximo 100 caracteres",
        "channelConfig": "Información de configuración del proveedor de pago, admite modo formulario y modo JSON para edición, se utiliza para almacenar claves API del proveedor, números de comerciante y otros parámetros de configuración.",
        "channelLogo": "Ícono del logotipo del proveedor de pagos, admite la carga de archivos de imágenes o el uso de identificadores de íconos de la biblioteca de íconos (como ep:tarjeta de crédito), tamaño recomendado 40x40px, tamaño de imagen que no exceda 1 MB",
        "channelName": "Nombre para mostrar del proveedor de pago, utilizado para identificar y mostrar el proveedor en el sistema, como Alipay, WeChat Pay, etc., máximo 100 caracteres.",
        "fixedRate": "Tasa de monto fijo del producto, por ejemplo, ingresar 0,50 significa 0,50 yuanes por transacción, que se utiliza para calcular las tarifas de transacción.",
        "orgRequiredParams": "Defina los parámetros que las organizaciones deben configurar al usar este canal, incluido el nombre del parámetro, el tipo, la descripción, el estado requerido y el valor de ejemplo, que se utilizan para guiar a las organizaciones a configurar correctamente los parámetros del canal.",
        "percentageRate": "Tasa porcentual del producto, rango 0-100, por ejemplo, ingrese 0,6 significa 0,6%, 1,5 significa 1,5%, que se utiliza para calcular las tarifas de transacción.",
        "productCode": "Código único del producto proveedor, utilizado para identificar el producto en el sistema, se recomienda utilizar combinaciones alfanuméricas y de subrayado, máximo 100 caracteres",
        "productName": "Nombre para mostrar del producto del proveedor, utilizado para identificar y mostrar el producto en el sistema, máximo 100 caracteres"
      },
      "imageSizeLimit": "¡El tamaño de la imagen no puede exceder 1 MB!",
      "jsonFormatIncorrect": "El formato JSON es incorrecto",
      "jsonMode": "Modo JSON",
      "jsonType": "JSON",
      "loadDataFailed": "No se pudieron cargar los datos",
      "logoCleared": "Logotipo borrado",
      "logoHint": "Admite carga de archivos de imagen, tamaño recomendado: 40x40px",
      "logoLoadFailed": "Error al cargar el logotipo",
      "logoUploadFailed": "Error al cargar el logotipo",
      "logoUploadSuccess": "Carga del logotipo exitosa",
      "noChannelsDescription": "No hay canales de pago disponibles. Haga clic en el botón \"Agregar\" arriba para crear su primer canal de pago",
      "noConfigItems": "Sin elementos de configuración",
      "noProducts": "No hay productos, haga clic en \"Agregar producto\" para crear",
      "noRequiredParams": "No hay parámetros requeridos",
      "numberType": "Número",
      "object": "Objeto",
      "onlyImageFiles": "¡Solo se pueden cargar archivos de imágenes!",
      "orgRequiredParams": "Parámetros requeridos por la organización",
      "orgRequiredParamsConfig": "Configuración de parámetros requeridos por la organización",
      "orgRequiredParamsConfigDesc": "Configurar los parámetros que las organizaciones deben completar al utilizar este canal",
      "orgRequiredParamsDesc": "Definir los parámetros que las organizaciones deben configurar al utilizar este canal.",
      "paramDesc": "Descripción del parámetro",
      "paramExample": "Valor de ejemplo",
      "paramName": "Nombre del parámetro",
      "paramRequired": "Requerida",
      "paramType": "Tipo de parámetro",
      "parseConfigJsonFailed": "No se pudo analizar la configuración JSON",
      "percentageRate": "Tasa Porcentual",
      "percentageRateHint": "Rango de tasa porcentual: 0-100, por ejemplo: 0,6 significa 0,6%, 1,5 significa 1,5%",
      "percentageRateLabel": "Tasa Porcentual",
      "productCode": "Código de producto",
      "productName": "Nombre del producto",
      "requiredParamAction": "Acción",
      "requiredParamDesc": "Descripción del parámetro",
      "requiredParamExample": "Valor de ejemplo",
      "requiredParamName": "Nombre del parámetro",
      "requiredParamNameExists": "El nombre del parámetro ya existe",
      "requiredParamRequired": "Requerida",
      "requiredParamMasked": "Oculto",
      "requiredParamType": "Tipo de parámetro",
      "requiredParamValidation": "El nombre del parámetro no puede estar vacío",
      "resetConfig": "Restablecer configuración",
      "searchPlaceholder": "Buscar nombre o código del proveedor...",
      "stringType": "Cadena",
      "submitChannelFailed": "No se pudo enviar el canal",
      "submitProductFailed": "No se pudo enviar el producto",
      "title": "Gestión de proveedores de pagos",
      "updateSuccess": "Actualizado exitosamente",
      "uploadResponseFormatError": "Error al cargar el formato de respuesta",
      "urlType": "URL",
      "validateJson": "Validar JSON",
      "viewConfig": "Ver configuración"
    },
    "permissionGroupManagement": {
      "addPermissionGroup": "Agregar grupo de permisos",
      "addPermissionGroupDialog": "Agregar grupo de permisos",
      "buttonPermissions": "Permisos de botones",
      "deletePermissionGroupConfirm": "¿Estás segura de eliminar el grupo de permisos \"{groupName}\"?",
      "editPermissionGroup": "Editar grupo de permisos",
      "groupName": "Nombre del grupo",
      "groupNameLabel": "Nombre del grupo de permisos",
      "groupType": "Tipo de grupo",
      "groupTypeLabel": "Tipo de grupo de permisos",
      "help": {
        "groupName": "Nombre para mostrar del grupo de permisos, utilizado para identificar y mostrar el grupo de permisos en el sistema, de 2 a 60 caracteres",
        "groupType": "Identificador de tipo del grupo de permisos, utilizado para distinguir diferentes tipos de grupos de permisos, como administrador, operador, etc.",
        "remark": "Información de comentarios del grupo de permisos, utilizada para registrar el propósito, la descripción u otras notas del grupo de permisos.",
        "status": "Estado del grupo de permisos: el grupo de permisos habilitado entrará en vigor, el grupo de permisos deshabilitado no estará disponible"
      },
      "loadButtonDataFailed": "No se pudieron cargar los datos del botón",
      "loadMenuDataFailed": "No se pudieron cargar los datos del menú",
      "loadPermissionGroupDataFailed": "No se pudieron cargar los datos del grupo de permisos",
      "loadPermissionsFailed": "No se pudo cargar la configuración de permisos",
      "menuPermissions": "Permisos de menú",
      "noButtonsForMenu": "No hay permisos de botones para este menú",
      "permissionGroupList": "Lista de grupos de permisos",
      "permissionSettings": "Configuración de permisos",
      "pleaseSelectMenu": "Por favor seleccione un menú primero",
      "pleaseSelectMenuFirst": "Por favor revisa el menú primero.",
      "savePermissions": "Guardar permisos",
      "savePermissionsFailed": "No se pudieron guardar los permisos",
      "savePermissionsSuccess": "Permisos guardados exitosamente",
      "searchPermissionGroup": "Grupo de permisos de búsqueda...",
      "selectPermissionGroupFirst": "Seleccione primero un grupo de permisos",
      "statusLabel": "Estado",
      "title": "Gestión de grupos de permisos"
    },
    "platProductManagement": {
      "addProduct": "Agregar producto",
      "addProductDialog": "Agregar producto empresarial de plataforma",
      "addSuccess": "Producto agregado exitosamente",
      "associatedChannels": "Canales asociados",
      "availableChannels": "Canales disponibles",
      "channelAssociationFailed": "Error en la asociación del canal",
      "channelAssociationSuccess": "Asociación de canales exitosa",
      "channelCount": "Conteo de canales",
      "channelManagementDialog": "Administrar asociación de canales de productos: {productName}",
      "confirmDeleteProductMessage": "¿Está seguro de eliminar el producto \"{productName}\"? Esto también eliminará todas las asociaciones de canales.",
      "deleteFailed": "No se pudo eliminar el producto",
      "deleteSuccess": "Producto eliminado exitosamente",
      "editProduct": "Editar producto",
      "editProductDialog": "Editar producto empresarial de plataforma",
      "enterH5Weburl": "Por favor ingrese la URL comercial H5",
      "enterProductCode": "Por favor ingrese el código del producto",
      "enterProductName": "Por favor ingrese el nombre del producto",
      "enterRemark": "Por favor introduzca comentario",
      "h5Weburl": "URL comercial H5",
      "help": {
        "h5Weburl": "Ruta de URL comercial H5, utilizada para la dirección URL comercial del escenario de pago H5, máximo 60 caracteres",
        "productCode": "El código único del producto empresarial de la plataforma, utilizado para identificar el producto en el sistema, no se puede modificar después de su creación, máximo 50 caracteres.",
        "productName": "El nombre para mostrar del producto comercial de la plataforma, utilizado para identificar y mostrar el producto en el sistema, máximo 100 caracteres.",
        "remark": "Información de comentarios del producto, utilizada para registrar el propósito, descripción u otros comentarios del producto, máximo 256 caracteres.",
        "status": "Estado del producto, los productos habilitados se pueden usar normalmente, los productos deshabilitados no estarán disponibles"
      },
      "loadAssociatedChannelsFailed": "No se pudieron cargar los canales asociados",
      "loadDataFailed": "No se pudieron cargar los datos del producto",
      "manageChannels": "Administrar canales",
      "noAssociatedChannels": "Sin canales asociados",
      "noAvailableChannels": "No hay canales disponibles",
      "noChannelsAvailable": "No hay canales disponibles para asociación.",
      "noChannelsSelected": "No hay canales seleccionados",
      "noProductsDescription": "No hay datos de productos comerciales de plataforma, haga clic en \"Agregar\" para crear el primer producto",
      "productCode": "Código de producto",
      "productName": "Nombre del producto",
      "relatedChannels": "Canales relacionados",
      "searchPlaceholder": "Buscar código o nombre del producto...",
      "selectAtLeastOneChannel": "Por favor seleccione al menos un canal",
      "selectChannels": "Seleccionar canales relacionados",
      "title": "Gestión de soluciones",
      "updateSuccess": "Producto actualizado exitosamente"
    },
    "qrCodeTransferLog": {
      "endTime": "Hora de finalización",
      "enterOperatorName": "Introduzca el nombre del operador",
      "loadDataFailed": "No se pudieron cargar los registros de transferencia del código QR",
      "loadOrgTreeFailed": "No se pudo cargar el árbol de la organización",
      "noErrorMessage": "Ningún mensaje de error",
      "operator": "Operadora",
      "orgChange": "Cambio de organización",
      "selectEndTime": "Seleccionar hora de finalización",
      "selectStartTime": "Seleccionar hora de inicio",
      "startTime": "Hora de inicio",
      "transferReason": "Motivo de la transferencia",
      "transferResult": "Resultado de la transferencia"
    },
    "qrcodeStickerManagement": {
      "addSticker": "Agregar pegatina",
      "addStickerDialog": "Agregar etiqueta QR",
      "batchNo": "Lote No.",
      "bound": "Asignado",
      "confirmDeleteMessage": "¿Estás segura de eliminar la pegatina QR \"{qrNo}\"?",
      "confirmUnbind": "Confirmar desasignación",
      "confirmUnbindMessage": "¿Está seguro de que desea desasignar la etiqueta QR \"{qrNo}\"? Después de desasignarla, el estado cambiará a No asignado.",
      "createBy": "Creado por",
      "deleteFailed": "Error al eliminar",
      "deleteSuccess": "Eliminar exitosa",
      "detailSectionAudit": "Registro",
      "detailSectionDevice": "Dispositivo vinculado",
      "detailSectionMachine": "Máquina asignada",
      "detailSectionSecurity": "Seguridad",
      "deviceType": "Tipo de dispositivo",
      "disabled": "Desactivada",
      "editStickerDialog": "Editar QR Pegatina",
      "enterQuantity": "Por favor ingrese generar cantidad",
      "enterTransferRemark": "Introduzca el comentario de transferencia",
      "export": "Exportar",
      "exportDialog": "Exportar código QR",
      "fromOrg": "Nombre de fuente",
      "generateQrCodeFailed": "No se pudo generar el código QR",
      "generateSuccess": "{quantity} pegatinas QR generadas correctamente",
      "help": {
        "createBy": "Creado por, utilizado para identificar al creador de la etiqueta QR",
        "createTime": "Hora de creación, utilizada para identificar la hora de creación de la etiqueta QR",
        "deviceType": "Tipo de dispositivo, utilizado para identificar el tipo de dispositivo asignado",
        "machineName": "Nombre de la máquina, utilizado para identificar la máquina asignada.",
        "machineNo": "Número de máquina, utilizado para identificar la máquina asignada.",
        "machineType": "Tipo de máquina, utilizado para identificar el tipo de máquina asignada.",
        "nfcPassword": "Contraseña NFC, utilizada para la autenticación NFC, admite letras y números, longitud de 4 a 16 caracteres",
        "qrCodeImage": "La imagen del código QR generada en función de la dirección del enlace se puede guardar en formato PNG para imprimir o mostrar.",
        "qrCodeUrl": "La dirección del enlace correspondiente al código QR, compuesta por tipo y número QR, se puede copiar para acceder",
        "qrNo": "Número único del código QR, generado automáticamente por el sistema, utilizado para identificar y rastrear pegatinas QR",
        "quantity": "Número de pegatinas QR a generar, rango 1-1000, el sistema generará por lotes la cantidad especificada de códigos QR",
        "remark": "Información de comentarios de la etiqueta QR, utilizada para registrar el propósito, descripción u otras notas, máximo 255 caracteres",
        "serialNumber": "Número de serie del dispositivo, utilizado para identificar el dispositivo asignado",
        "status": "Estado actual de la etiqueta QR, incluidos los estados No asignado, Asignado y Deshabilitado",
        "toOrgLabel": "Seleccione la organización de destino a la que transferir el código QR",
        "transferReason": "Motivo de la transferencia, explica el motivo de la transferencia del código QR, máximo 200 caracteres",
        "type": "Tipo de código QR; seleccionar diferentes tipos generará diferentes direcciones de enlace, como cajero, autenticación previa, etc.",
        "updateTime": "Hora de actualización, utilizada para identificar la hora de actualización de la etiqueta QR"
      },
      "loadDataFailed": "No se pudieron cargar los datos",
      "loadH5UrlOptionsFailed": "No se pudieron cargar las opciones de URL H5",
      "loadOrgTreeFailed": "No se pudo cargar el árbol de la organización",
      "loadTransferRecordsFailed": "No se pudieron cargar los registros de transferencia",
      "machineName": "Nombre de la máquina",
      "machineNo": "Número de máquina",
      "machineType": "Tipo de máquina",
      "nfcPassword": "Contraseña NFC",
      "noTransferRecords": "No hay registros de transferencia disponibles",
      "operateTime": "Tiempo de operación",
      "operator": "Operadora",
      "orgId": "ID de organización",
      "orgName": "Nombre de la organización",
      "pleaseSelectQrCode": "Por favor seleccione un código QR primero",
      "qrCodeImage": "Código QR",
      "qrCodeUrl": "URL del enlace",
      "qrNo": "Número QR",
      "qrNoLabel": "Número QR",
      "quantity": "Generar cantidad",
      "quantityRange": "La cantidad debe estar entre 1 y 1000",
      "quantityRequired": "Por favor ingrese generar cantidad",
      "saveFailed": "Error al guardar",
      "saveQrCode": "Guardar código QR",
      "saveSuccess": "Guardar exitosa",
      "searchPlaceholder": "Buscar número QR o comentario...",
      "selectSourceOrg": "Por favor seleccione la organización de origen",
      "selectStatus": "Seleccionar estado",
      "selectTargetOrg": "Por favor seleccione la organización de destino",
      "selectType": "Seleccionar tipo",
      "selectTypeFirst": "Por favor seleccione el tipo primero",
      "serialNumber": "SN",
      "statusLabel": "Estado",
      "title": "Gestión de pegatinas QR",
      "toOrg": "Nombre de la organización objetivo",
      "toOrgLabel": "Nombre de destino",
      "transfer": "Transferir",
      "transferDialogTitle": "Transferir código QR",
      "transferFailed": "Error en la transferencia del código QR",
      "transferReason": "Motivo de la transferencia",
      "transferRecords": "{qrCode} Transferir registros",
      "transferSuccess": "Transferencia de código QR exitosa",
      "typeCashier": "Cajera",
      "typePreAuth": "Preautorización",
      "unbind": "Desasignar QR",
      "unbindFailed": "Error en la desasignación",
      "unbindSuccess": "Desasignación realizada correctamente",
      "unbound": "No asignado",
      "updateSuccess": "Actualización exitosa"
    },
    "systemParameterManagement": {
      "addParameter": "Agregar parámetro",
      "addParameterDialog": "Agregar parámetro del sistema",
      "addSuccess": "Agregado exitosamente",
      "confirmDeleteMessage": "¿Estás segura de eliminar el parámetro \"{paramName}\"?",
      "deleteFailed": "Error al eliminar",
      "deleteSuccess": "Eliminado exitosamente",
      "editParameter": "Editar parámetro",
      "editParameterDialog": "Editar parámetro del sistema",
      "help": {
        "paramDesc": "La descripción del parámetro del sistema, utilizada para explicar el propósito, descripción u otras observaciones de este parámetro, máximo 255 caracteres.",
        "paramName": "El nombre de identificador único del parámetro del sistema, utilizado para hacer referencia a este parámetro en el sistema, no se puede modificar después de la creación, longitud de 1 a 100 caracteres.",
        "paramValue": "El valor específico del parámetro del sistema, que puede ser una cadena, un número u otro formato, con una longitud de 1 a 255 caracteres."
      },
      "loadDataFailed": "No se pudieron cargar los datos",
      "paramDesc": "Descripción del parámetro",
      "paramDescLabel": "Descripción del parámetro",
      "paramName": "Nombre del parámetro",
      "paramNameLabel": "Nombre del parámetro",
      "paramValue": "Valor del parámetro",
      "paramValueLabel": "Valor del parámetro",
      "parameter": "Parámetro",
      "searchPlaceholder": "Nombre o descripción del parámetro de búsqueda...",
      "title": "Gestión de parámetros del sistema",
      "updateSuccess": "Actualizado exitosamente"
    }
  },
  "timeZoneOptions": {
    "name": {
      "America_Anchorage": "Hora de Alaska",
      "America_Chicago": "Hora central",
      "America_New_York": "Hora del este",
      "Pacific_Honolulu": "Hora de Hawái",
      "America_Denver": "Hora de la montaña",
      "America_Los_Angeles": "Hora del Pacífico",
      "America_Halifax": "Hora del Atlántico",
      "America_Winnipeg": "Hora central",
      "America_Toronto": "Hora del este",
      "America_Edmonton": "Hora de la montaña",
      "America_St_Johns": "Hora de Terranova",
      "America_Vancouver": "Hora del Pacífico",
      "America_Mexico_City": "Hora estándar central",
      "America_Monterrey": "Hora estándar central",
      "America_Cancun": "Hora estándar del este",
      "America_Hermosillo": "Hora estándar de la montaña",
      "America_Mazatlan": "Hora estándar de la montaña",
      "America_Tijuana": "Hora del Pacífico",
      "America_Bogota": "Hora de Colombia",
      "America_Argentina_Buenos_Aires": "Hora de Argentina",
      "Europe_Vienna": "Hora de Europa central",
      "Europe_London": "Hora del meridiano de Greenwich",
      "Asia_Singapore": "Hora de Singapur",
      "Asia_Shanghai": "Hora estándar de China"
    },
    "city": {
      "America_Anchorage": "Anchorage",
      "America_Chicago": "Chicago",
      "America_New_York": "Nueva York, Washington",
      "Pacific_Honolulu": "Honolulú",
      "America_Denver": "Denver",
      "America_Los_Angeles": "Los Ángeles",
      "America_Halifax": "Halifax",
      "America_Winnipeg": "Winnipeg",
      "America_Toronto": "Toronto",
      "America_Edmonton": "Edmonton",
      "America_St_Johns": "St. John's",
      "America_Vancouver": "Vancouver",
      "America_Mexico_City": "Ciudad de México",
      "America_Monterrey": "Monterrey",
      "America_Cancun": "Cancún",
      "America_Hermosillo": "Hermosillo",
      "America_Mazatlan": "Mazatlán",
      "America_Tijuana": "Tijuana",
      "America_Bogota": "Bogotá",
      "America_Argentina_Buenos_Aires": "Buenos Aires",
      "Europe_Vienna": "Viena",
      "Europe_London": "Londres",
      "Asia_Singapore": "Singapur",
      "Asia_Shanghai": "Pekín"
    }
  },
  "tagsView": {
    "closeAll": "Cerrar todo",
    "closeOther": "Cerrar otra",
    "closeTab": "Cerrar actual",
    "closeTheLeftTab": "Cerrar a la izquierda",
    "closeTheRightTab": "Cerrar a la derecha",
    "reload": "Recargar"
  }
}
